(function () {
	'use strict';

	var serviceId = 'datacontext';
	angular.module('app').factory(serviceId, ['common', '_', datacontext]);

	function datacontext(common, _) {
		var $q = common.$q;
		var $http = common.$http;
		var urlAPI = '/api';
		var urlROOT = 'http://tirocini.ciapiweb.org';
		var controllerAccreditamento = '/Candidature/Accreditamento/#/CNDAccreditamento';
		var controllerAdesione = '/Candidature/DomandaAdesione/#/CNDDomanda';
		var numRecordsTaHead = 15;    // Variabile generale di numero record per elenchi async-TypeAHead
		var _pageSize = 30;

		//Array condivisi su app - caricati su avvio app
		// Utilizzati esclusivamente su tag SELECT
		var _arrAziende = [];
		var _arrProfili = [];
		var _arrProfiliANPAL = [];
		var _arrProfiliDocente = [];
		var _arrProvince = [];
		var _arrProvinceByReg = [];
		var _arrPaesi = [];
		var _arrRisorse = [];       //solo dati non variabili (Id, Cognome, Nome, CodiceFiscale, ProfiloId, Profilo)
		var _arrTipoStatoRichieste = [];
		var _arrTipoRegistrazione = [];
		//Array tabelle tipo
		var _arrTipoLavoro = [];
		var _arrFormaGiuridica = [];
		var _arrTipoAteco = [];
		var _arrTitoloStudio = [];
		var _arrCondizioneMercato = [];
		var _arrDurataRicerca = [];
		var _arrGruppoVulnerabilita = [];
		var _arrStatoPartecipante = [];
		var _arrTCPI = [];
		var _arrAziendeCPI = [];
		var _arrTTirocini = [];
		var _arrTTirociniDLG = [];
		var _arrTTirociniSpese = [];
		var _arrContenutoFormativo = [];
		var _arrParams = [];
		var _arrStatiCivili = [];
		var _arrStatiOccup = [];
		var _arrTitoliStudio = [];
		var _arrCittadinanze = [];
		var _arrCNDCV_TPubb = [];
		var _arrCNDTProfili = [];
		var _arrTCittadinanza = [];
		var _arrTQualifica = [];
		var _arrTRapportoLavoro = [];
		var _arrTAltraQualifica = [];
		var _arrTImpresa = [];
		var _arrTClasseImpresa = [];
		var _arrTIndirizzo = [];


		var service = {
			//Metodi pe caricamento dati condivisi su app
			//Array compilati solo a prima chiamata
			arrAziende: arrAziende,
			arrProfili: arrProfili,
			arrProfiliANPAL: arrProfiliANPAL,
			arrProfiliDocente: arrProfiliDocente,
			arrProvince: arrProvince,
			arrProvinceByReg: arrProvinceByReg,
			arrPaesi: arrPaesi,
			arrRisorse: arrRisorse,
			arrTipoStatoRichieste: arrTipoStatoRichieste,
			arrTipoRegistrazione: arrTipoRegistrazione,
			//Array per tabelle Tipo
			arrTipoLavoro: arrTipoLavoro,
			arrFormaGiuridica: arrFormaGiuridica,
			arrTipoAteco: arrTipoAteco,
			arrTitoloStudio: arrTitoloStudio,
			arrCondizioneMercato: arrCondizioneMercato,
			arrDurataRicerca: arrDurataRicerca,
			arrGruppoVulnerabilita: arrGruppoVulnerabilita,
			arrStatoPartecipante: arrStatoPartecipante,
			arrTCPI: arrTCPI,
			arrAziendeCPI: arrAziendeCPI,
			arrTTirocini: arrTTirocini,
			arrTTirociniDLG: arrTTirociniDLG,
			arrTTirociniSpese: arrTTirociniSpese,
			arrContenutoFormativo: arrContenutoFormativo,
			arrParams: arrParams,
			arrStatiCivili: arrStatiCivili,
			arrStatiOccup: arrStatiOccup,
			arrTitoliStudio: arrTitoliStudio,
			arrCittadinanze: arrCittadinanze,
			arrCNDCV_TPubb: arrCNDCV_TPubb,
			arrCNDTProfili: arrCNDTProfili,
			arrTCittadinanza: arrTCittadinanza,
			arrTQualifica: arrTQualifica,
			arrTRapportoLavoro: arrTRapportoLavoro,
			arrTAltraQualifica: arrTAltraQualifica,
			arrTImpresa: arrTImpresa,
			arrTClasseImpresa: arrTClasseImpresa,
			arrTIndirizzo: arrTIndirizzo,

			cndTProfilo_getAll: cndTProfilo_getAll,

			root_getURL: root_getURL,
			accreditamento_getURL: accreditamento_getURL,
			adesione_getURL: adesione_getURL,
			upload_getURL: upload_getURL,
			download_getURL: download_getURL,
			mail_upload_getURL: mail_upload_getURL,

			//-- DESTINATARIO DIRETTO
			destinatariodiretto_getAllList: destinatariodiretto_getAllList,
			destinatariodiretto_getAll: destinatariodiretto_getAll,
			destinatariodiretto_countAll: destinatariodiretto_countAll,
			destinatariodiretto_getAllByClasse: destinatariodiretto_getAllByClasse,
			destinatariodiretto_existsCF: destinatariodiretto_existsCF,
			destinatariodiretto_get: destinatariodiretto_get,
			destinatariodiretto_add: destinatariodiretto_add,
			destinatariodiretto_update: destinatariodiretto_update,
			destinatariodiretto_delete: destinatariodiretto_delete,


			//-- OMLS
			omls_getAllList: omls_getAllList,
			omls_getAll: omls_getAll,
			omls_countAll: omls_countAll,
			omls_getAllByClasse: omls_getAllByClasse,
			omls_statusCF: omls_statusCF,
			omls_assign: omls_assign,
			omls_existsCF: omls_existsCF,
			omls_get: omls_get,
			omls_add: omls_add,
			omls_update: omls_update,
			omls_delete: omls_delete,

			//-- TUTOR
			tutor_getAllList: tutor_getAllList,
			tutor_getAll: tutor_getAll,
			tutor_countAll: tutor_countAll,
			tutor_existsCF: tutor_existsCF,
			tutor_get: tutor_get,
			tutor_add: tutor_add,
			tutor_update: tutor_update,
			tutor_delete: tutor_delete,

			//-- TUTOR
			dipendente_getAllList: dipendente_getAllList,
			dipendente_getAll: dipendente_getAll,
			dipendente_countAll: dipendente_countAll,
			dipendente_existsCF: dipendente_existsCF,
			dipendente_get: dipendente_get,
			dipendente_add: dipendente_add,
			dipendente_update: dipendente_update,
			dipendente_delete: dipendente_delete,

			//-- CLASSE - Nuovi Metodi
			classe_getAllList: classe_getAllList,
			classe_getAllMemberDidList: classe_getAllMemberDidList,
			classe_getAllNoMemberDidList: classe_getAllNoMemberDidList,
			classe_getAll: classe_getAll,
			classe_countAllMemberDidList: classe_countAllMemberDidList,
			classe_countAllNoMemberDidList: classe_countAllNoMemberDidList,
			classe_countAll: classe_countAll,
			classe_getAllByCorso: classe_getAllByCorso,
			classe_getAllByIstituto: classe_getAllByIstituto,
			classe_get: classe_get,
			classe_add: classe_add,
			classe_update: classe_update,
			classe_delete: classe_delete,
			classe_existsCUP: classe_existsCUP,
            classe_unlock: classe_unlock,

            //-ISSUE-LOG
            issueLog_getAll: issueLog_getAll,
            issueLog_countAll: issueLog_countAll,
            issueLog_get: issueLog_get,
            issueLog_add: issueLog_add,
            issueLog_update: issueLog_update,
            issueLog_delete: issueLog_delete,
            issueLog_setState: issueLog_setState,

			//-- STUDENTE
			studente_getAllList: studente_getAllList,
			studente_getAll: studente_getAll,
			studente_countAll: studente_countAll,
			studente_getAllByUsername: studente_getAllByUsername,
			studente_countAllByUsername: studente_countAllByUsername,
			studente_getAllByClasse: studente_getAllByClasse,
			studente_getAllByClasse_Data: studente_getAllByClasse_Data,
			studente_getListNotInClasse: studente_getListNotInClasse,
			studente_existsCF: studente_existsCF,
			studente_get: studente_get,
			studente_add: studente_add,
			studente_update: studente_update,
			studente_delete: studente_delete,

			//-- DOCENTE
			docente_getAllList: docente_getAllList,
			docente_getAll: docente_getAll,
			docente_countAll: docente_countAll,
			docente_getAllByClasse: docente_getAllByClasse,
			docente_existsCF: docente_existsCF,
			docente_get: docente_get,
			docente_add: docente_add,
			docente_update: docente_update,
			docente_delete: docente_delete,



			//-- ASSEGNAZIONE
			assegnazione_getAllByCorso: assegnazione_getAllByCorso,
			assegnazione_getAllByRisorsa: assegnazione_getAllByRisorsa,
			assegnazione_getAllBySede: assegnazione_getAllBySede,
			assegnazione_get: assegnazione_get,
			assegnazione_add: assegnazione_add,
			assegnazione_update: assegnazione_update,
			assegnazione_delete: assegnazione_delete,


			//-- CORSO
			corso_getAllList: corso_getAllList,
			corso_getListByFilter: corso_getListByFilter,
			corso_getAll: corso_getAll,
			corso_countAll: corso_countAll,
			corso_get: corso_get,
			corso_add: corso_add,
			corso_update: corso_update,
			corso_delete: corso_delete,

			//-- AZIENDA-SEDE
			aziendaSede_getAllList: aziendaSede_getAllList,
			aziendaSede_getAll: aziendaSede_getAll,
			aziendaSede_countAll: aziendaSede_countAll,
			aziendaSede_get: aziendaSede_get,
			aziendaSede_add: aziendaSede_add,
			aziendaSede_update: aziendaSede_update,
			aziendaSede_delete: aziendaSede_delete,
			aziendaSede_unlock: aziendaSede_unlock,

			//-- DETTAGLIO ORA
			dettaglioOra_getAll: dettaglioOra_getAll,
			dettaglioOra_get: dettaglioOra_get,
			dettaglioOra_add: dettaglioOra_add,
			dettaglioOra_update: dettaglioOra_update,
			dettaglioOra_delete: dettaglioOra_delete,
			dettaglioOra_saveFoglio: dettaglioOra_saveFoglio,

			//-- DATO CONSUNTIVO
			datoConsuntivo_getMinuteByFilter: datoConsuntivo_getMinuteByFilter,
			datoConsuntivo_getDatiRisorsaByFilter: datoConsuntivo_getDatiRisorsaByFilter,

			//-- DOCENZE
			docenza_getAll: docenza_getAll,
			docenza_getAllByClasse: docenza_getAllByClasse,
			docenza_getAllByRisorsa: docenza_getAllByRisorsa,
			docenza_getAllByMateria: docenza_getAllByMateria,
			docenza_get: docenza_get,
			docenza_add: docenza_add,
			docenza_update: docenza_update,
			docenza_delete: docenza_delete,

			//-- GRUPPO AMM
			gruppoAmm_getAllList: gruppoAmm_getAllList,
			gruppoAmm_getAll: gruppoAmm_getAll,
			gruppoAmm_countAll: gruppoAmm_countAll,
			gruppoAmm_get: gruppoAmm_get,
			gruppoAmm_add: gruppoAmm_add,
			gruppoAmm_update: gruppoAmm_update,
			gruppoAmm_delete: gruppoAmm_delete,

			gruppoAmm_membroAdd: gruppoAmm_membroAdd,
			gruppoAmm_membroDelete: gruppoAmm_membroDelete,
			gruppoAmm_membroChangeRuolo: gruppoAmm_membroChangeRuolo,
			gruppoAmm_membriByGruppo: gruppoAmm_membriByGruppo,


			//-- GRUPPO DID
			gruppoDid_getAllList: gruppoDid_getAllList,
			gruppoDid_getAll: gruppoDid_getAll,
			gruppoDid_countAll: gruppoDid_countAll,
			gruppoDid_get: gruppoDid_get,
			gruppoDid_add: gruppoDid_add,
			gruppoDid_update: gruppoDid_update,
			gruppoDid_delete: gruppoDid_delete,

			gruppoDid_membroAdd: gruppoDid_membroAdd,
			gruppoDid_membroDelete: gruppoDid_membroDelete,
			gruppoDid_membroChangeRuolo: gruppoDid_membroChangeRuolo,
			gruppoDid_membriByGruppo: gruppoDid_membriByGruppo,
			gruppoDid_gruppiByRisorsa: gruppoDid_gruppiByRisorsa,

			gruppoDid_classeAdd: gruppoDid_classeAdd,
			gruppoDid_classeDelete: gruppoDid_classeDelete,
			gruppoDid_classiByGruppo: gruppoDid_classiByGruppo,

			gruppoDid_aziendaAdd: gruppoDid_aziendaAdd,
			gruppoDid_aziendaDelete: gruppoDid_aziendaDelete,
			gruppoDid_aziendeByGruppo: gruppoDid_aziendeByGruppo,

			gruppoDid_tirocinioAdd: gruppoDid_tirocinioAdd,
			gruppoDid_tirocinioDelete: gruppoDid_tirocinioDelete,
			gruppoDid_tirociniByGruppo: gruppoDid_tirociniByGruppo,

			//Project per Ticket
			gruppoDid_projectAdd: gruppoDid_projectAdd,
			gruppoDid_projectDelete: gruppoDid_projectDelete,
			gruppoDid_projectsByGruppo: gruppoDid_projectsByGruppo,

			gruppoDid_ticketAdd: gruppoDid_ticketAdd,
			gruppoDid_ticketDelete: gruppoDid_ticketDelete,
			gruppoDid_ticketsByGruppo: gruppoDid_ticketsByGruppo,

			//-- TICKET
			ticket_getAllList: ticket_getAllList,
			ticket_getAll: ticket_getAll,
			ticket_countAll: ticket_countAll,
			ticket_get: ticket_get,
			ticket_add: ticket_add,
			ticket_update: ticket_update,
			ticket_setRead: ticket_setRead,
			ticket_delete: ticket_delete,
			ticket_unlock: ticket_unlock,

			//-- TTICKET
			tTicket_getAllList: tTicket_getAllList,
			tTicket_getListFiltered: tTicket_getListFiltered,
			tTicket_getAll: tTicket_getAll,
			tTicket_countAll: tTicket_countAll,
			tTicket_get: tTicket_get,
			tTicket_add: tTicket_add,
			tTicket_update: tTicket_update,
			tTicket_delete: tTicket_delete,

			//-- PROJECT
			project_getAllList: project_getAllList,
			project_getAllListByUsername: project_getAllListByUsername,
			project_getAll: project_getAll,
			project_countAll: project_countAll,
			project_get: project_get,
			project_add: project_add,
			project_update: project_update,
			project_delete: project_delete,

			//-- STATUS
			status_getAllList: status_getAllList,
			status_getAll: status_getAll,
			status_countAll: status_countAll,
			status_get: status_get,
			status_add: status_add,
			status_update: status_update,
			status_delete: status_delete,

			//-- TRACE
			trace_getAllList: trace_getAllList,
			trace_getAll: trace_getAll,
			trace_countAll: trace_countAll,
			trace_get: trace_get,
			trace_add: trace_add,
			trace_update: trace_update,
			trace_delete: trace_delete,


			//-- INCARICO
			incarico_getAll: incarico_getAll,
			incarico_countAll: incarico_countAll,
			incarico_getAllByClasse: incarico_getAllByClasse,
			incarico_getAllByRisorsa: incarico_getAllByRisorsa,
			incarico_add: incarico_add,
			incarico_update: incarico_update,
			incarico_delete: incarico_delete,

			//-- ISTAT
			istat_comune_getAllList: istat_comune_getAllList,
			istat_comune_get: istat_comune_get,

			//-- TIndirizzo          
			tIndirizzo_getAllList: tIndirizzo_getAllList,
			tIndirizzo_get: tIndirizzo_get,

			//-- ISTITUTO          
			istituto_getAllList: istituto_getAllList,
			istituto_getListByFilter: istituto_getListByFilter,
			istituto_getAll: istituto_getAll,
			istituto_countAll: istituto_countAll,
			istituto_getAllBySede: istituto_getAllBySede,
			istituto_get: istituto_get,
			istituto_add: istituto_add,
			istituto_update: istituto_update,
			istituto_delete: istituto_delete,



			//-- LEZIONE
			lezione_getAll: lezione_getAll,
			lezione_countAll: lezione_countAll,
			lezione_get: lezione_get,
			lezione_add: lezione_add,
			lezione_update: lezione_update,
			lezione_delete: lezione_delete,

			//-- PRESENZA
			presenza_getAll: presenza_getAll,
			presenza_getByFoglio: presenza_getByFoglio,
			presenza_saveFoglio: presenza_saveFoglio,
			//presenza_getAllByProc: presenza_getAllByProc,
			presenza_countAll: presenza_countAll,
			presenza_get: presenza_get,
			presenza_add: presenza_add,
			presenza_update: presenza_update,
			presenza_delete: presenza_delete,
			presenza_setStato: presenza_setStato,
			presenza_setStatoClasse: presenza_setStatoClasse,
			presenza_inizializzaClasse: presenza_inizializzaClasse,

			//-- REGISTRO PRESENZE
			regAttivita_getAll: regAttivita_getAll,
			regAttivita_getByFoglio: regAttivita_getByFoglio,
			regAttivita_saveFoglio: regAttivita_saveFoglio,
			//regAttivita_countAll: regAttivita_countAll,
			regAttivita_get: regAttivita_get,
			regAttivita_add: regAttivita_add,
			regAttivita_update: regAttivita_update,
			regAttivita_delete: regAttivita_delete,
			regAttivita_exists: regAttivita_exists,
            /*
			regAttivita_setStato: regAttivita_setStato,
			regAttivita_setStatoClasse: regAttivita_setStatoClasse,
			regAttivita_inizializzaClasse: regAttivita_inizializzaClasse,
            */
			regAttivita_saveAndCompleted: regAttivita_saveAndCompleted,
			regAttivita_setCompleted: regAttivita_setCompleted,
			regAttivita_unsetCompleted: regAttivita_unsetCompleted,

			// ******************************
			//  tRegAttivita
			tRegAttivita_getAllList: tRegAttivita_getAllList,
			tRegAttivita_get: tRegAttivita_get,

			//-- MATERIA
			materia_getAllList: materia_getAllList,
			materia_getAllByCorso: materia_getAllByCorso,
			materia_get: materia_get,
			materia_add: materia_add,
			materia_update: materia_update,
			materia_delete: materia_delete,

			//-- MATERIA
			misura_getAllList: misura_getAllList,
			misura_getAll: misura_getAll,
			misura_get: misura_get,


			//-- RISORSA
			risorsa_getAllListByText: risorsa_getAllListByText,
			risorsa_getAllList: risorsa_getAllList,
			risorsa_getByUsernameList: risorsa_getByUsernameList,
			risorsa_getAll: risorsa_getAll,
			risorsa_countAll: risorsa_countAll,
			risorsa_existsCF: risorsa_existsCF,
			risorsa_getByUsername: risorsa_getByUsername,
			risorsa_getByUsername2: risorsa_getByUsername2,
			risorsa_get: risorsa_get,
			risorsa_add: risorsa_add,
			risorsa_update: risorsa_update,
			risorsa_delete: risorsa_delete,
			risorsa_setRinuncia: risorsa_setRinuncia,
			risorsa_setDecaduto: risorsa_setDecaduto,
			risorsa_setNewAssign: risorsa_setNewAssign,

			//-RISORSA AZIONE
			risorsaAzione_getList: risorsaAzione_getList,
			risorsaAzione_getAll: risorsaAzione_getAll,
			risorsaAzione_countAll: risorsaAzione_countAll,
			risorsaAzione_get: risorsaAzione_get,
			risorsaAzione_add: risorsaAzione_add,
			risorsaAzione_update: risorsaAzione_update,
			risorsaAzione_delete: risorsaAzione_delete,
			risorsaAzione_unlock: risorsaAzione_unlock,

			//-- DDPROFILING
			ddProfiling_getAllList: ddProfiling_getAllList,
			ddProfiling_getAll: ddProfiling_getAll,
			ddProfiling_countAll: ddProfiling_countAll,
			ddProfiling_getAllByDestinatario: ddProfiling_getAllByDestinatario,
			ddProfiling_get: ddProfiling_get,
			ddProfiling_add: ddProfiling_add,
			ddProfiling_update: ddProfiling_update,
			ddProfiling_delete: ddProfiling_delete,
			ddProfiling_unlock: ddProfiling_unlock,
			ddProfiling_print: ddProfiling_print,

			//-VISITA ISPETTIVA
			visitaIspettiva_getList: visitaIspettiva_getList,
			visitaIspettiva_getAll: visitaIspettiva_getAll,
			visitaIspettiva_countAll: visitaIspettiva_countAll,
			visitaIspettiva_get: visitaIspettiva_get,
			visitaIspettiva_add: visitaIspettiva_add,
			visitaIspettiva_update: visitaIspettiva_update,
			visitaIspettiva_delete: visitaIspettiva_delete,
			visitaIspettiva_unlock: visitaIspettiva_unlock,


			//-CHECKLIST
			checklist_getList: checklist_getList,
			checklist_getAll: checklist_getAll,
			checklist_countAll: checklist_countAll,
			checklist_get: checklist_get,
			checklist_add: checklist_add,
			checklist_update: checklist_update,
			checklist_delete: checklist_delete,
			checklist_unlock: checklist_unlock,
			checklist_unlockSent: checklist_unlockSent,
			checklist_isValidHelper: checklist_isValidHelper,

			//--ORIENTAMENTO
			orientamento_getList: orientamento_getList,
			orientamento_getAll: orientamento_getAll,
			orientamento_countAll: orientamento_countAll,
			orientamento_get: orientamento_get,
			orientamento_add: orientamento_add,
			orientamento_update: orientamento_update,
			orientamento_delete: orientamento_delete,
			orientamento_unlock: orientamento_unlock,

			//--PROFILO ANPAL
			profiloDocente_getAll: profiloDocente_getAll,

			//--PROFILO ANPAL
			profiloANPAL_getAll: profiloANPAL_getAll,

			//-- SEDE
			sede_getAllList: sede_getAllList,
			sede_getAll: sede_getAll,
			sede_countAll: sede_countAll,
			sede_get: sede_get,
			sede_add: sede_add,
			sede_update: sede_update,
			sede_delete: sede_delete,

			//-- SIGNATURE
			signature_getAllList: signature_getAllList,
			signature_getAll: signature_getAll,
			signature_countAll: signature_countAll,
			signature_upload: signature_upload,
			signature_get: signature_get,
			signature_add: signature_add,
			signature_update: signature_update,
			signature_delete: signature_delete,



			//-- AZIENDA - Nuovi Metodi
			azienda_getAllList: azienda_getAllList,
			azienda_getAll: azienda_getAll,
			azienda_countAll: azienda_countAll,
			//azienda_getAllMemberDidList: azienda_getAllMemberDidList,
			//azienda_getAllNoMemberDidList: azienda_getAllNoMemberDidList,
			//azienda_countAllMemberDidList: azienda_countAllMemberDidList,
			//azienda_countAllNoMemberDidList: azienda_countAllNoMemberDidList,			
			azienda_exists: azienda_exists,
			azienda_getByUsername: azienda_getByUsername,
			azienda_get: azienda_get,
			azienda_add: azienda_add,
			azienda_update: azienda_update,
			azienda_delete: azienda_delete,
			azienda_printAll3Bis: azienda_printAll3Bis,

			//-- PDF
			pdf_checklist: pdf_checklist,


			//-- TIROCINANTE
			tirocinante_getAllList: tirocinante_getAllList,
			tirocinante_getAll: tirocinante_getAll,
			tirocinante_countAll: tirocinante_countAll,
			//tirocinante_getAllByUsername: tirocinante_getAllByUsername,
			//tirocinante_countAllByUsername: tirocinante_countAllByUsername,
			tirocinante_getAllByAzienda: tirocinante_getAllByAzienda,
			tirocinante_getAllByAzienda_Data: tirocinante_getAllByAzienda_Data,
			tirocinante_existsCF: tirocinante_existsCF,
			tirocinante_statusCF: tirocinante_statusCF,
			tirocinante_assign: tirocinante_assign,
			tirocinante_get: tirocinante_get,
			tirocinante_add: tirocinante_add,
			tirocinante_update: tirocinante_update,
			tirocinante_delete: tirocinante_delete,

			//-- TIROCINIO
			tirocinio_getByTirocinante: tirocinio_getByTirocinante,
			tirocinio_getAllList: tirocinio_getAllList,
			tirocinio_getAllListByText: tirocinio_getAllListByText,
			tirocinio_getAll: tirocinio_getAll,
			tirocinio_countAll: tirocinio_countAll,
			tirocinio_getAllByAzienda: tirocinio_getAllByAzienda,
			tirocinio_existsTir: tirocinio_existsTir,
			tirocinio_get: tirocinio_get,
			tirocinio_add: tirocinio_add,
			tirocinio_update: tirocinio_update,
			tirocinio_delete: tirocinio_delete,
			tirocinio_unlock: tirocinio_unlock,
			tirocinio_setChecked: tirocinio_setChecked,
			tirocinio_setUnchecked: tirocinio_setUnchecked,
			tirocinio_setNoBenefit: tirocinio_setNoBenefit,
            tirocinio_unsetNoBenefit: tirocinio_unsetNoBenefit,
            tirocinio_disassignRlz: tirocinio_disassignRlz,
            tirocinio_status: tirocinio_status,
            tirocinio_assign: tirocinio_assign,
            tirocinio_reassign: tirocinio_reassign,            
			tirocinio_rinuncia: tirocinio_rinuncia,            
			tirocinio_rlzSuspended: tirocinio_rlzSuspended,            

			//-- TIROCINIO LOG
			tirLog_getAllList: tirLog_getAllList,
			tirLog_getAll: tirLog_getAll,
			tirLog_countAll: tirLog_countAll,
			tirLog_get: tirLog_get,
			tirLog_add: tirLog_add,
			tirLog_update: tirLog_update,
			tirLog_delete: tirLog_delete,


			//-- TIROCINI-SPESE
			tirocinioSpesa_getAllList: tirocinioSpesa_getAllList,
			tirocinioSpesa_getAll: tirocinioSpesa_getAll,
			tirocinioSpesa_countAll: tirocinioSpesa_countAll,
			tirocinioSpesa_get: tirocinioSpesa_get,
			tirocinioSpesa_add: tirocinioSpesa_add,
			tirocinioSpesa_update: tirocinioSpesa_update,
			tirocinioSpesa_delete: tirocinioSpesa_delete,

			//-- TIROCINI-PAGAMENTI
			tirocinioPagamento_getAllList: tirocinioPagamento_getAllList,
			tirocinioPagamento_getAll: tirocinioPagamento_getAll,
			tirocinioPagamento_countAll: tirocinioPagamento_countAll,
			tirocinioPagamento_get: tirocinioPagamento_get,
			tirocinioPagamento_add: tirocinioPagamento_add,
			tirocinioPagamento_update: tirocinioPagamento_update,
			tirocinioPagamento_delete: tirocinioPagamento_delete,

            //-- TIROCINIO RIMBORSO
            tirRimborso_getAllList: tirRimborso_getAllList,
            tirRimborso_getAll: tirRimborso_getAll,
            tirRimborso_countAll: tirRimborso_countAll,
            tirRimborso_get: tirRimborso_get,
            tirRimborso_add: tirRimborso_add,
            tirRimborso_update: tirRimborso_update,
            tirRimborso_changePeriodo: tirRimborso_changePeriodo,
            tirRimborso_calcolaImportoRichiesto: tirRimborso_calcolaImportoRichiesto,
            tirRimborso_updateDatiAssess: tirRimborso_updateDatiAssess,
            tirRimborso_changeState: tirRimborso_changeState,
            tirRimborso_delete: tirRimborso_delete,
            tirRimborso_unlock: tirRimborso_unlock,
            tirRimborso_unsetPresaIncarico: tirRimborso_unsetPresaIncarico,
            tirRimborso_unsetPresaIncaricoCPI: tirRimborso_unsetPresaIncaricoCPI,
            tirRimborso_unsetIssuePay: tirRimborso_unsetIssuePay,
			tirRimborso_printAllegato7: tirRimborso_printAllegato7,
			tirRimborso_changeState2: tirRimborso_changeState2,

			//-- TIROCINIO RIMBORSO DTL
			tirRimborsoDtl_getAllList: tirRimborsoDtl_getAllList,
			tirRimborsoDtl_getAll: tirRimborsoDtl_getAll,
			tirRimborsoDtl_countAll: tirRimborsoDtl_countAll,
			tirRimborsoDtl_get: tirRimborsoDtl_get,
			tirRimborsoDtl_add: tirRimborsoDtl_add,
			tirRimborsoDtl_update: tirRimborsoDtl_update,
			tirRimborsoDtl_delete: tirRimborsoDtl_delete,

			//-- MY LOG
			myLog_getAllList: myLog_getAllList,
			myLog_getAll: myLog_getAll,
			myLog_countAll: myLog_countAll,
			myLog_get: myLog_get,
			myLog_add: myLog_add,
			myLog_update: myLog_update,
			myLog_merge: myLog_merge,
			myLog_delete: myLog_delete,

			//-- TIROCINIO SOSPENSIONE
			tirSospensione_getAllByTirocinioId: tirSospensione_getAllByTirocinioId,
			tirSospensione_get: tirSospensione_get,
			tirSospensione_add: tirSospensione_add,
			tirSospensione_update: tirSospensione_update,
			tirSospensione_delete: tirSospensione_delete,

			//-- COLLOCAMENTO
			collocamento_getAllList: collocamento_getAllList,
			collocamento_getAllListByRmbDtl: collocamento_getAllListByRmbDtl,
			collocamento_getAll: collocamento_getAll,
			collocamento_countAll: collocamento_countAll,
			collocamento_existsTir: collocamento_existsTir,
			collocamento_statusCF: collocamento_statusCF,
			collocamento_assign: collocamento_assign,
			collocamento_get: collocamento_get,
			collocamento_add: collocamento_add,
			collocamento_update: collocamento_update,
			collocamento_delete: collocamento_delete,
			collocamento_unlock: collocamento_unlock,
			collocamento_proroga: collocamento_proroga,
			collocamento_unlockProroga: collocamento_unlockProroga,

			//-- COLL-RIMBORSO
			collRimborso_getAllList: collRimborso_getAllList,
			collRimborso_getAll: collRimborso_getAll,
			collRimborso_countAll: collRimborso_countAll,
			collRimborso_get: collRimborso_get,
			collRimborso_add: collRimborso_add,
			collRimborso_update: collRimborso_update,
			collRimborso_updateDatiAssess: collRimborso_updateDatiAssess,
			collRimborso_delete: collRimborso_delete,
			collRimborso_unlock: collRimborso_unlock,

			//-- COLL-SERVIZIO
			collServizio_getAllList: collServizio_getAllList,
			collServizio_getAll: collServizio_getAll,
			collServizio_countAll: collServizio_countAll,
			collServizio_get: collServizio_get,
			collServizio_add: collServizio_add,
			collServizio_update: collServizio_update,
			collServizio_delete: collServizio_delete,
			collServizio_unlock: collServizio_unlock,

			//-- COLL-CONTRATTO (ASSUNZIONE)
			collContratto_getAllList: collContratto_getAllList,
			collContratto_getAll: collContratto_getAll,
			collContratto_countAll: collContratto_countAll,
			collContratto_get: collContratto_get,
			collContratto_add: collContratto_add,
			collContratto_update: collContratto_update,
			collContratto_delete: collContratto_delete,
			collContratto_unlock: collContratto_unlock,

			//-- COLL-RIMBORSO DETAIL
			collRmbDtl_getAllList: collRmbDtl_getAllList,
			collRmbDtl_getAll: collRmbDtl_getAll,
			collRmbDtl_countAll: collRmbDtl_countAll,
			collRmbDtl_get: collRmbDtl_get,
			collRmbDtl_add: collRmbDtl_add,
			collRmbDtl_update: collRmbDtl_update,
			collRmbDtl_delete: collRmbDtl_delete,
			collRmbDtl_unlock: collRmbDtl_unlock,


			//-- TContratto          
			tContratto_getAllList: tContratto_getAllList,
			tContratto_get: tContratto_get,

			//-- RIMBORSO
			rimborso_getAllList: rimborso_getAllList,
			rimborso_getAll: rimborso_getAll,
			rimborso_countAll: rimborso_countAll,
			rimborso_get: rimborso_get,
			rimborso_add: rimborso_add,
			rimborso_update: rimborso_update,
			rimborso_updateDatiAssess: rimborso_updateDatiAssess,
			rimborso_delete: rimborso_delete,
			rimborso_unlock: rimborso_unlock,

			//-- USER
			user_getAllList: user_getAllList,
			user_getAllListActive: user_getAllListActive,
			user_getAll: user_getAll,
			user_countAll: user_countAll,
			user_get: user_get,
			user_add: user_add,
			user_update: user_update,
			user_exists: user_exists,
			user_setPassword: user_setPassword,
			user_activate: user_activate,
			user_deactivate: user_deactivate,
			user_resetPassword: user_resetPassword,
			user_invioCredenziali: user_invioCredenziali,
			user_GeneraPassword: user_GeneraPassword,
			user_UnlockAccount: user_UnlockAccount,
			user_createNewAccount: user_createNewAccount,
			//user_delete: user_delete,

			//-- ROLE
			role_getAllList: role_getAllList,
			role_getAll: role_getAll,
			role_get: role_get,
			role_getDto: role_getDto,
			role_getAllUser: role_getAllUser,
			role_countAllUser: role_countAllUser,
			role_add: role_add,
			role_update: role_update,
			role_delete: role_delete,

			roleUser_add: roleUser_add,
			roleUser_delete: roleUser_delete,
			deleteChildrenOfRoleIdOrUserId: deleteChildrenOfRoleIdOrUserId,

			//-- ROLE USER
			userRole_getAll: userRole_getAll,
			userRole_add: userRole_add,
			userRole_delete: userRole_delete,

			//-- AUTHORIZATION
			authorization_get: authorization_get,
			authorization_getById: authorization_getById,
			authorization_getAllByUser: authorization_getAllByUser,
			authorization_getAllByFilter: authorization_getAllByFilter,
			authorization_countAllByFilter: authorization_countAllByFilter,
			authorization_add: authorization_add,
			authorization_update: authorization_update,
			authorization_delete: authorization_delete,

			//-- AREA
			area_getAllList: area_getAllList,
			area_getAll: area_getAll,
			area_getAllByFilter: area_getAllByFilter,
			area_getMaxId: area_getMaxId,
			area_get: area_get,
			area_add: area_add,
			area_update: area_update,
			area_delete: area_delete,

			//=========== NEWSLETTER
			//-- MAIL_EMAIL
			newsletter_email_getAllList: newsletter_email_getAllList,
			newsletter_email_getAll: newsletter_email_getAll,
			newsletter_email_countAll: newsletter_email_countAll,
			newsletter_email_get: newsletter_email_get,
			newsletter_email_add: newsletter_email_add,
			newsletter_email_update: newsletter_email_update,
			newsletter_email_confirmSent: newsletter_email_confirmSent,
			newsletter_email_delete: newsletter_email_delete,
			newsletter_email_invioEmail: newsletter_email_invioEmail,
			newsletter_email_invioEmails: newsletter_email_invioEmails,
			newsletter_email_getTemplate: newsletter_email_getTemplate,

			//-- MAIL_ATTACHMENT
			newsletter_attachment_getAllList: newsletter_attachment_getAllList,
			newsletter_attachment_getAll: newsletter_attachment_getAll,
			newsletter_attachment_getByEmailId: newsletter_attachment_getByEmailId,
			newsletter_attachment_countByEmailId: newsletter_attachment_countByEmailId,
			newsletter_attachment_countAll: newsletter_attachment_countAll,
			newsletter_attachment_get: newsletter_attachment_get,
			newsletter_attachment_add: newsletter_attachment_add,
			newsletter_attachment_update: newsletter_attachment_update,
			newsletter_attachment_delete: newsletter_attachment_delete,

			//-- MAIL_TSOURCE
			newsletter_tSource_getAllList: newsletter_tSource_getAllList,
			newsletter_tSource_getAll: newsletter_tSource_getAll,
			newsletter_tSource_countAll: newsletter_tSource_countAll,
			newsletter_tSource_get: newsletter_tSource_get,
			newsletter_tSource_getByTable: newsletter_tSource_getByTable,
			newsletter_tSource_Entity_getList: newsletter_tSource_Entity_getList,
			newsletter_tSource_Entity_countByFilter: newsletter_tSource_Entity_countByFilter,
			newsletter_tSource_Entity_getAllByFilter: newsletter_tSource_Entity_getAllByFilter,


			//-- MAIL_RECEIVERS
			newsletter_receivers_getAllList: newsletter_receivers_getAllList,
			newsletter_receivers_getAll: newsletter_receivers_getAll,
			newsletter_receivers_countAll: newsletter_receivers_countAll,
			newsletter_receivers_getByEmailId: newsletter_receivers_getByEmailId,
			newsletter_receivers_countByEmailId: newsletter_receivers_countByEmailId,
			newsletter_receivers_getByTSourceId: newsletter_receivers_getByTSourceId,
			newsletter_receivers_get: newsletter_receivers_get,
			newsletter_receivers_add: newsletter_receivers_add,
			newsletter_receivers_update: newsletter_receivers_update,
			newsletter_receivers_delete: newsletter_receivers_delete,

			//============================================

			//-- ATTACH - Nuovi Metodi
			faq_getAllList: faq_getAllList,
			faq_getAll: faq_getAll,
			faq_countAll: faq_countAll,
			faq_get: faq_get,
			faq_add: faq_add,
			faq_update: faq_update,
			faq_delete: faq_delete,

			//-- Tfaq          
			tFaq_getAllList: tFaq_getAllList,
			tFaq_get: tFaq_get,

			//-- ATTACH - Nuovi Metodi
			attach_getAllList: attach_getAllList,
			attach_getAll: attach_getAll,
			attach_getAllCND: attach_getAllCND,
			attach_countAll: attach_countAll,
			attach_get: attach_get,
			attach_add: attach_add,
			attach_update: attach_update,
			attach_delete: attach_delete,
			attach_setCompleted: attach_setCompleted,
            attach_unsetCompleted: attach_unsetCompleted,

            attach_setIssue: attach_setIssue,
            attach_unsetIssue: attach_unsetIssue,
			attach_updateIssue: attach_updateIssue,

			attach_unlock: attach_unlock,

            //Estrazione documentazione dalla piattaforma
            attach_download: attach_download,
            attach_extract: attach_extract,
            attach_extractDigitalSignInfo: attach_extractDigitalSignInfo,

			//-- TATTACH          
			tAttach_getAllList: tAttach_getAllList,
			tAttach_getAllModal: tAttach_getAllModal,
			tAttach_getAll: tAttach_getAll,
			tAttach_countAll: tAttach_countAll,
			tAttach_get: tAttach_get,
			tAttach_add: tAttach_add,
			tAttach_update: tAttach_update,
			tAttach_delete: tAttach_delete,

			//-- TATTACHVISIBILITY
			tAttachVisibility_getAuth: tAttachVisibility_getAuth,
			tAttachVisibility_getAll: tAttachVisibility_getAll,
			tAttachVisibility_add: tAttachVisibility_add,
			tAttachVisibility_update: tAttachVisibility_update,
			tAttachVisibility_delete: tAttachVisibility_delete,

			//-- TATTACHFILETYPE
			tAttachFileType_getAll: tAttachFileType_getAll,
			tAttachFileType_add: tAttachFileType_add,
			tAttachFileType_update: tAttachFileType_update,
			tAttachFileType_delete: tAttachFileType_delete,

			//-- TSOURCE          
			tSource_getAllList: tSource_getAllList,
			tSource_getAll: tSource_getAll,
			tSource_get: tSource_get,
			tSource_getByCode: tSource_getByCode,


			//-- SOURCE
			source_getAllList: source_getAllList,

			//-- RUOLO AMM
			tRuoloAmm_get: tRuoloAmm_get,

			//-- RUOLO AMM
			tRuoloDid_get: tRuoloDid_get,


			//-- QUERY
			query_countByFilter: query_countByFilter,
			query_getAllByFilter: query_getAllByFilter,
			queryEntity_download: queryEntity_download,
			queryEntity_countByFilter: queryEntity_countByFilter,
			queryEntity_getAllByFilter: queryEntity_getAllByFilter,

			//-- NOTIFICATION
			notification_countByFilter: notification_countByFilter,
			notification_getAllByFilter: notification_getAllByFilter,

			//-- NOTIFICATION da BackOffice
			notification_getAll: notification_getAll,
			notification_countAll: notification_countAll,
			notification_getDto: notification_getDto,
			notification_add: notification_add,
			notification_update: notification_update,
			notification_delete: notification_delete,

			//-- NOTIFICATION-VISIBILITY
			notificationVisibility_getAll: notificationVisibility_getAll,
			notificationVisibility_add: notificationVisibility_add,
			notificationVisibility_update: notificationVisibility_update,
			notificationVisibility_delete: notificationVisibility_delete,

			//-- NOTIFICATION-USER
			notificationUser_getAll: notificationUser_getAll,
			notificationUser_push: notificationUser_push,
			notificationUser_update: notificationUser_update,
			notificationUser_delete: notificationUser_delete,

			//-- DOWNLOAD
			download_countByFilter: download_countByFilter,
			download_getAllByFilter: download_getAllByFilter,

			//-- DOWNLOAD da BackOffice
			download_getAll: download_getAll,
			download_countAll: download_countAll,
			download_getDto: download_getDto,
			download_add: download_add,
			download_update: download_update,
			download_delete: download_delete,

			//-- DOWNLOAD-VISIBILITY
			downloadVisibility_getAll: downloadVisibility_getAll,
			downloadVisibility_addRole: downloadVisibility_addRole,
			downloadVisibility_updateRole: downloadVisibility_updateRole,
			downloadVisibility_deleteRole: downloadVisibility_deleteRole,


			//-- TRACCIATO
			tracciato_export: tracciato_export,
			tracciato_resetExp: tracciato_resetExp,


			//-- CANDIDATURE: ACCREDITAMENTO
			cndAccreditamento_getAllList: cndAccreditamento_getAllList,
			cndAccreditamento_getAll: cndAccreditamento_getAll,
			cndAccreditamento_countAll: cndAccreditamento_countAll,
			cndAccreditamento_exists: cndAccreditamento_exists,
			cndAccreditamento_get: cndAccreditamento_get,
			cndAccreditamento_getByUID: cndAccreditamento_getByUID,
			cndAccreditamento_unlock: cndAccreditamento_unlock,
			cndAccreditamento_setStatus: cndAccreditamento_setStatus,
			cndAccreditamento_printPDFAll: cndAccreditamento_printPDFAll,
			cndAccreditamento_printRicevuta: cndAccreditamento_printRicevuta,
			cndAccreditamento_findPDFAll: cndAccreditamento_findPDFAll,
			cndAccreditamento_add: cndAccreditamento_add,
			cndAccreditamento_update: cndAccreditamento_update,
			cndAccreditamento_delete: cndAccreditamento_delete,
			cndAccreditamento_setAnnulled: cndAccreditamento_setAnnulled,

			//-- CNDAccreditamento-SEDE
			cndAccreditamentoSede_getAllList: cndAccreditamentoSede_getAllList,
			cndAccreditamentoSede_getAll: cndAccreditamentoSede_getAll,
			cndAccreditamentoSede_countAll: cndAccreditamentoSede_countAll,
			cndAccreditamentoSede_get: cndAccreditamentoSede_get,
			cndAccreditamentoSede_add: cndAccreditamentoSede_add,
			cndAccreditamentoSede_update: cndAccreditamentoSede_update,
			cndAccreditamentoSede_delete: cndAccreditamentoSede_delete,
			cndAccreditamentoSede_exists: cndAccreditamentoSede_exists,

			//-- CANDIDATURE: DOMANDA DI ADESIONE
			cndDomandaAdesione_getAllList: cndDomandaAdesione_getAllList,
			cndDomandaAdesione_getAll: cndDomandaAdesione_getAll,
			cndDomandaAdesione_countAll: cndDomandaAdesione_countAll,
			cndDomandaAdesione_exists: cndDomandaAdesione_exists,
			cndDomandaAdesione_assign: cndDomandaAdesione_assign,
			cndDomandaAdesione_statusCF: cndDomandaAdesione_statusCF,
			cndDomandaAdesione_get: cndDomandaAdesione_get,
			cndDomandaAdesione_getByUID: cndDomandaAdesione_getByUID,
			cndDomandaAdesione_unlock: cndDomandaAdesione_unlock,
			cndDomandaAdesione_setStatus: cndDomandaAdesione_setStatus,
			cndDomandaAdesione_printPDFAll: cndDomandaAdesione_printPDFAll,
			cndDomandaAdesione_printRicevuta: cndDomandaAdesione_printRicevuta,
			cndDomandaAdesione_findPDFAll: cndDomandaAdesione_findPDFAll,
			cndDomandaAdesione_add: cndDomandaAdesione_add,
			cndDomandaAdesione_update: cndDomandaAdesione_update,
			cndDomandaAdesione_delete: cndDomandaAdesione_delete,
			cndDomandaAdesione_setAnnulled: cndDomandaAdesione_setAnnulled,
			cndDomandaAdesione_setFieldsISEE: cndDomandaAdesione_setFieldsISEE,

			//-- SEND LINK ACCESSO FROM EMAIL AND CODICE FISCALE
			cndProgetto_sendLnkAccesso: cndProgetto_sendLnkAccesso,

			//-- CANDIDATURE: DOMANDA DI ADESIONE
			cndProgetto_getAllList: cndProgetto_getAllList,
			cndProgetto_getAll: cndProgetto_getAll,
			cndProgetto_countAll: cndProgetto_countAll,
			cndProgetto_get: cndProgetto_get,
			cndProgetto_getByUID: cndProgetto_getByUID,
			cndProgetto_add: cndProgetto_add,
			cndProgetto_update: cndProgetto_update,
			cndProgetto_delete: cndProgetto_delete,

			//-- CANDIDATURE: Curriculum Vitae
			cndCV_getAllList: cndCV_getAllList,
			cndCV_getAll: cndCV_getAll,
			cndCV_countAll: cndCV_countAll,
			cndCV_get: cndCV_get,
			cndCV_getByDomandaId: cndCV_getByDomandaId,
			cndCV_getByDomandaUID: cndCV_getByDomandaUID,
			cndCV_unlock: cndCV_unlock,
			cndCV_printPDF: cndCV_printPDF,
			cndCV_findCV: cndCV_findCV,
			cndCV_add: cndCV_add,
			cndCV_update: cndCV_update,
			cndCV_delete: cndCV_delete,

			//-- CANDIDATURE: CV Abilit
			cndCVAbilit_getAllList: cndCVAbilit_getAllList,
			cndCVAbilit_getAll: cndCVAbilit_getAll,
			cndCVAbilit_countAll: cndCVAbilit_countAll,
			cndCVAbilit_get: cndCVAbilit_get,
			cndCVAbilit_add: cndCVAbilit_add,
			cndCVAbilit_update: cndCVAbilit_update,
			cndCVAbilit_delete: cndCVAbilit_delete,

			//-- CANDIDATURE: CV Servizio
			cndCVServizio_getAllList: cndCVServizio_getAllList,
			cndCVServizio_getAll: cndCVServizio_getAll,
			cndCVServizio_countAll: cndCVServizio_countAll,
			cndCVServizio_get: cndCVServizio_get,
			cndCVServizio_add: cndCVServizio_add,
			cndCVServizio_saveAll: cndCVServizio_saveAll,
			cndCVServizio_update: cndCVServizio_update,
			cndCVServizio_delete: cndCVServizio_delete,

			//-- CANDIDATURE: CV Corso
			cndCVCorso_getAllList: cndCVCorso_getAllList,
			cndCVCorso_getAll: cndCVCorso_getAll,
			cndCVCorso_countAll: cndCVCorso_countAll,
			cndCVCorso_get: cndCVCorso_get,
			cndCVCorso_add: cndCVCorso_add,
			cndCVCorso_update: cndCVCorso_update,
			cndCVCorso_delete: cndCVCorso_delete,

			//-- CANDIDATURE: CV Pubb
			cndCVPubb_getAllList: cndCVPubb_getAllList,
			cndCVPubb_getAll: cndCVPubb_getAll,
			cndCVPubb_countAll: cndCVPubb_countAll,
			cndCVPubb_get: cndCVPubb_get,
			cndCVPubb_add: cndCVPubb_add,
			cndCVPubb_update: cndCVPubb_update,
			cndCVPubb_delete: cndCVPubb_delete,

			//-- CANDIDATURE: CV Spec
			cndCVSpec_getAllList: cndCVSpec_getAllList,
			cndCVSpec_getAll: cndCVSpec_getAll,
			cndCVSpec_countAll: cndCVSpec_countAll,
			cndCVSpec_get: cndCVSpec_get,
			cndCVSpec_add: cndCVSpec_add,
			cndCVSpec_saveAll: cndCVSpec_saveAll,
			cndCVSpec_update: cndCVSpec_update,
			cndCVSpec_delete: cndCVSpec_delete,

			//-- CANDIDATURE: CV Idoneita
			cndCVIdoneita_getAllList: cndCVIdoneita_getAllList,
			cndCVIdoneita_getAll: cndCVIdoneita_getAll,
			cndCVIdoneita_countAll: cndCVIdoneita_countAll,
			cndCVIdoneita_get: cndCVIdoneita_get,
			cndCVIdoneita_add: cndCVIdoneita_add,
			cndCVIdoneita_update: cndCVIdoneita_update,
			cndCVIdoneita_delete: cndCVIdoneita_delete,

			//--VALIDAZIONE CF E IBAN
			validazione_cf: validazione_cf,
			validazione_piva: validazione_piva,
			validazione_iban: validazione_iban,
			validazione_fieldsCF: validazione_fieldsCF,

			//--ACCOUNT
			account_getDaysValidityPassword: account_getDaysValidityPassword,

			//--PARAMS
			params_get: params_get,

			//-- TTirocinanteProfilo          
			tTirocinanteProfilo_getAllList: tTirocinanteProfilo_getAllList,
			tTirocinanteProfilo_get: tTirocinanteProfilo_get,

			//-- TTirocinanteProfilo          
			tTirocinio_getAllList: tTirocinio_getAllList,
			tTirocinio_get: tTirocinio_get,

			//-- TTirocinanteProfilo          
			tTirocinioDLG_getAllList: tTirocinioDLG_getAllList,
			tTirocinioDLG_get: tTirocinioDLG_get,

			//-- TProfiloDD
			tProfiloDD_getAllList: tProfiloDD_getAllList,
			tProfiloDD_getAll: tProfiloDD_getAll,
			tProfiloDD_get: tProfiloDD_get,


			//-- TRuoloSoggetto
			tRuoloSoggetto_getAll: tRuoloSoggetto_getAll,
			tRuoloSoggetto_get: tRuoloSoggetto_get,

			//-- TLavoro          
			tLavoro_getAllList: tLavoro_getAllList,
			tLavoro_get: tLavoro_get,

			//-- TFormaGiuridica          
			tFormaGiuridica_getAllList: tFormaGiuridica_getAllList,
			tFormaGiuridica_get: tFormaGiuridica_get,

			//-- TAteco          
			tAteco_getAllList: tAteco_getAllList,
			tAteco_get: tAteco_get,
			tAteco_getByText: tAteco_getByText,

			//-- TTitoloStudio          
			tTitoloStudio_getAllList: tTitoloStudio_getAllList,
			tTitoloStudio_get: tTitoloStudio_get,

			//-- TCondizioneMercato          
			tCondizioneMercato_getAllList: tCondizioneMercato_getAllList,
			tCondizioneMercato_get: tCondizioneMercato_get,

			//-- TDurataRicerca          
			tDurataRicerca_getAllList: tDurataRicerca_getAllList,
			tDurataRicerca_get: tDurataRicerca_get,

			//-- TGruppoVulnerabilita          
			tGruppoVulnerabilita_getAllList: tGruppoVulnerabilita_getAllList,
			tGruppoVulnerabilita_get: tGruppoVulnerabilita_get,

			//-- TStatoPartecipante          
			tStatoPartecipante_getAllList: tStatoPartecipante_getAllList,
			tStatoPartecipante_get: tStatoPartecipante_get,

			//-- TCPI          
			tCPI_getAllList: tCPI_getAllList,
			tCPI_getAll: tCPI_getAll,
			tCPI_get: tCPI_get,

			//-- TTirociniSpese         
			tTirociniSpese_getAllList: tTirociniSpese_getAllList,
			tTirociniSpese_get: tTirociniSpese_get,

			//-- TAteco          
			contenutoFormativo_getAllList: contenutoFormativo_getAllList,
			contenutoFormativo_get: contenutoFormativo_get,

			//-- TEST
			test_getAllList: test_getAllList,
			test_getAllListExclude: test_getAllListExclude,
			test_count: test_count,
			test_countByFilter: test_countByFilter,
			test_getAll: test_getAll,
			test_getAllByFilter: test_getAllByFilter,
			test_get: test_get,
			test_update: test_update,
			test_delete: test_delete,
			test_add: test_add,

			//-- question
			question_getAllList: question_getAllList,
			question_getAllListInTest: question_getAllListInTest,
			question_getAllListNotInTest: question_getAllListNotInTest,
			question_count: question_count,
			question_countByFilter: question_countByFilter,
			question_getAll: question_getAll,
			question_getAllByFilter: question_getAllByFilter,
			question_getAllByTest: question_getAllByTest,
			question_get: question_get,
			question_update: question_update,
			question_delete: question_delete,
			question_add: question_add,
			question_addToTest: question_addToTest,
			question_upload: question_upload,
			question_deleteFiles: question_deleteFiles,

			//-- choice
			choice_getAllList: choice_getAllList,
			choice_count: choice_count,
			choice_countByFilter: choice_countByFilter,
			choice_getAll: choice_getAll,
			choice_getAllByQuestion: choice_getAllByQuestion,
			choice_get: choice_get,
			choice_update: choice_update,
			choice_delete: choice_delete,
			choice_add: choice_add,
			choice_upload: choice_upload,

			//-- questionTest
			questionTest_getAllList: questionTest_getAllList,
			questionTest_count: questionTest_count,
			questionTest_countByFilter: questionTest_countByFilter,
			questionTest_getAll: questionTest_getAll,
			questionTest_getAllByFilter: questionTest_getAllByFilter,
			questionTest_getAllByTest: questionTest_getAllByTest,
			questionTest_getAllByQuestion: questionTest_getAllByQuestion,
			questionTest_get: questionTest_get,
			questionTest_update: questionTest_update,
			questionTest_changeSequence: questionTest_changeSequence,
			questionTest_delete: questionTest_delete,
			questionTest_add: questionTest_add,
			questionTest_importList: questionTest_importList,
			questionTest_addByParams: questionTest_addByParams,

			//-- SESSION
			session_getAllList: session_getAllList,
			session_count: session_count,
			session_countByFilter: session_countByFilter,
			session_getAll: session_getAll,
			session_getAllByFilter: session_getAllByFilter,
			session_get: session_get,
			session_add: session_add,
			session_update: session_update,
			session_delete: session_delete,
			session_activate: session_activate,
			session_inactivate: session_inactivate,

			//-- SESSION STUDENTE
			studenteSession_getAllList: studenteSession_getAllList,
			studenteSession_addList: studenteSession_addList,
			studenteSession_count: studenteSession_count,
			studenteSession_countByFilter: studenteSession_countByFilter,
			studenteSession_getAll: studenteSession_getAll,
			studenteSession_getAllByFilter: studenteSession_getAllByFilter,
			studenteSession_get: studenteSession_get,
			studenteSession_update: studenteSession_update,
			studenteSession_delete: studenteSession_delete,

			//--- DASHBOARD - APP
			dashboard_get: dashboard_get,
			dashboard_getByProfileId: dashboard_getByProfileId,
			dashboard_getAllProfiles: dashboard_getAllProfiles,

			//System Method
			getWhoAmI: getWhoAmI
		};
		return service;

		// ******************************
		//  Funzioni Generiche
		function getAll(objName) {
			console.log("getAll(%s)", objName);
			return $http.get(urlAPI + '/' + objName + '/GetAll')
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getAll for %s: %s', objName, message);
					return message.status;
				});
		}

		function getAllList(objName) {
			console.log("getAllList(%s)", objName);
			return $http.get(urlAPI + '/' + objName + '/GetAllList')
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getAllList for %s: %s', objName, message);
					return message.status;
				});
		}

		function getAllNoParam(objName, actionName) {
			var url = urlAPI + '/' + objName + '/' + actionName;
			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getAll NO Param for %s: %s', objName, message);
					return message.status;
				});
		}

		function getAllByParam(objName, actionName, paramName, paramValue) {
			var url = urlAPI + '/' + objName + '/' + actionName + '?' + paramName + '=' + paramValue;
			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getAll for %s: %s', objName, message);
					return message.status;
				});
		}

		function getAllByParams(objName, actionName, paramArray) {
			var url = urlAPI + '/' + objName + '/' + actionName;

			var numParams = paramArray.length;
			if (numParams > 0) {
				url += '?'
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += paramArray[i].name + '=' + paramArray[i].value;
			}

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getAllByParams for %s: %s', objName, message);
					return message.status;
				});
		}

		function getById(objName, id) {
			return $http.get(urlAPI + '/' + objName + '/Get/' + id)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getById for %s: %s', objName, message);
					return message.status;
				});
		}

		function getBaseById(objName, id) {
			return $http.get(urlAPI + '/' + objName + '/GetBase/' + id)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getBaseById for %s: %s', objName, message);
					return message.status;
				});
		}

		function addObj(objName, objValue) {
			return $http.post(urlAPI + '/' + objName + '/Post', objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed addObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function updateObj(objName, objValue) {
			return $http.put(urlAPI + '/' + objName + '/Put', objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function mergeObj(objName, objValue) {
			return $http.put(urlAPI + '/' + objName + '/Merge', objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed mergeObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function deleteObj(objName, id) {
			return $http.delete(urlAPI + '/' + objName + '/Delete/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed deleteObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function postMethod(objName, objMethod, objValue) {
			return $http.post(urlAPI + '/' + objName + '/' + objMethod, objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed postObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function putMethod(objName, objMethod, objValue) {
			return $http.put(urlAPI + '/' + objName + '/' + objMethod, objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}
		//  END - Funzioni Generiche
		// ******************************


		// ***************************************************
		// ***************************************************
		//  Funzioni Pubbliche - esposte su interfaccia Service
		// ***************************************************
		// ***************************************************

		function root_getURL() {
			return urlROOT + '/';
		}

		function accreditamento_getURL() {
			return urlROOT + controllerAccreditamento + '/';
		}

		function adesione_getURL() {
			return urlROOT + controllerAdesione + '/';
		}


		function upload_getURL() {
			var controller = 'Attach';
			var action = 'Upload';

			return urlAPI + '/' + controller + '/' + action + '/';
		}

		function download_getURL() {
			var controller = 'Download';
			var action = 'Upload';

			return urlAPI + '/' + controller + '/' + action + '/';
		}

		function mail_upload_getURL() {
			var controller = 'Newsletter_Attachment';
			var action = 'Upload';

			return urlAPI + '/' + controller + '/' + action + '/';
		}

		// ******************************
		//  Metodi init per array condivisi
		function arrAziende() {
			if (_arrAziende.length == 0) {
				return getAllList('classe').then(function (data) {
					_arrAziende = data;
					return _arrAziende;
				});
			}
			return $q.when(_arrAziende);
		}

		function arrProfili() {
			if (_arrProfili.length == 0) {
				return getAll('profilo').then(function (data) {
					_arrProfili = data;
					return _arrProfili;
				});
			}
			return $q.when(_arrProfili);
		}

		function arrProfiliANPAL() {
			if (_arrProfiliANPAL.length == 0) {
				return getAll('profiloANPAL').then(function (data) {
					_arrProfiliANPAL = data;
					return _arrProfiliANPAL;
				});
			}
			return $q.when(_arrProfiliANPAL);
		}

		function arrProfiliDocente() {
			if (_arrProfiliDocente.length == 0) {
				return getAll('profiloDocente').then(function (data) {
					_arrProfiliDocente = data;
					return _arrProfiliDocente;
				});
			}
			return $q.when(_arrProfiliDocente);
		}


		function arrProvince() {
			if (_arrProvince.length == 0) {
				return getAll('provincia').then(function (data) {
					_arrProvince = data;
					return _arrProvince;
				});
			}
			return $q.when(_arrProvince);
		}

		function arrProvinceByReg(regioneId) {
			if (_arrProvinceByReg.length == 0) {
				if (typeof regioneId == 'undefined') { regioneId = 0; }
				var params = [];
				params.push({ name: 'regioneId', value: regioneId });

				_arrProvinceByReg = getAllByParams('provincia', 'GetAllByRegId', params);
				return _arrProvinceByReg;
			}
			return $q.when(_arrProvinceByReg);
		}

		function arrPaesi() {
			if (_arrPaesi.length == 0) {
				return getAll('paese').then(function (data) {
					_arrPaesi = data;
					return _arrPaesi;
				});
			}
			return $q.when(_arrPaesi);
		}


		function arrRisorse() {
			if (_arrRisorse.length == 0) {
				return getAllNoParam('risorsa', 'GetAllBase').then(function (data) {
					_arrRisorse = data;
					return _arrRisorse;
				});
			}
			return $q.when(_arrRisorse);
		}

		function arrTipoStatoRichieste() {
			if (_arrTipoStatoRichieste.length == 0) {
				return getAll('tipoStatoRichiesta').then(function (data) {
					_arrTipoStatoRichieste = data;
					return _arrTipoStatoRichieste;
				});
			}
			return $q.when(_arrTipoStatoRichieste);
		}

		function arrTipoRegistrazione() {
			if (_arrTipoRegistrazione.length == 0) {
				return getAll('tipoRegistrazione').then(function (data) {
					_arrTipoRegistrazione = data;
					return _arrTipoRegistrazione;
				});
			}
			return $q.when(_arrTipoRegistrazione);
		}

		//Inizializzazione array statici delle tabelle tipo
		//T45, da TC24 a TC32, TCPI

		function arrTipoLavoro() {
			if (_arrTipoLavoro.length == 0) {
				return getAllList('tLavoro').then(function (data) {
					_arrTipoLavoro = data;
					return _arrTipoLavoro;
				});
			}
			return $q.when(_arrTipoLavoro);
		}

		function arrFormaGiuridica() {
			if (_arrFormaGiuridica.length == 0) {
				return getAllList('tFormaGiuridica').then(function (data) {
					_arrFormaGiuridica = data;
					return _arrFormaGiuridica;
				});
			}
			return $q.when(_arrFormaGiuridica);
		}

		function arrTipoAteco() {
			if (_arrTipoAteco.length == 0) {
				return getAllList('tAteco').then(function (data) {
					_arrTipoAteco = data;
					return _arrTipoAteco;
				});
			}
			return $q.when(_arrTipoAteco);
		}

		function arrTitoloStudio() {
			if (_arrTitoloStudio.length == 0) {
				return getAllList('tTitoloStudio').then(function (data) {
					_arrTitoloStudio = data;
					return _arrTitoloStudio;
				});
			}
			return $q.when(_arrTitoloStudio);
		}

		function arrCondizioneMercato() {
			if (_arrCondizioneMercato.length == 0) {
				return getAllList('tCondizioneMercato').then(function (data) {
					_arrCondizioneMercato = data;
					return _arrCondizioneMercato;
				});
			}
			return $q.when(_arrCondizioneMercato);
		}

		function arrDurataRicerca() {
			if (_arrDurataRicerca.length == 0) {
				return getAllList('tDurataRicerca').then(function (data) {
					_arrDurataRicerca = data;
					return _arrDurataRicerca;
				});
			}
			return $q.when(_arrDurataRicerca);
		}

		function arrGruppoVulnerabilita() {
			if (_arrGruppoVulnerabilita.length == 0) {
				return getAllList('tGruppoVulnerabilita').then(function (data) {
					_arrGruppoVulnerabilita = data;
					return _arrGruppoVulnerabilita;
				});
			}
			return $q.when(_arrGruppoVulnerabilita);
		}

		function arrStatoPartecipante() {
			if (_arrStatoPartecipante.length == 0) {
				return getAllList('tStatoPartecipante').then(function (data) {
					_arrStatoPartecipante = data;
					return _arrStatoPartecipante;
				});
			}
			return $q.when(_arrStatoPartecipante);
		}

		function arrTCPI() {
			if (_arrTCPI.length == 0) {
				return getAllList('tCPI').then(function (data) {
					_arrTCPI = data;
					return _arrTCPI;
				});
			}
			return $q.when(_arrTCPI);
		}

		function arrAziendeCPI() {
			if (_arrAziendeCPI.length == 0) {
				return azienda_getAllList('', 3, 0, 0, -1, 1, 0, 0).then(function (data) {
					_arrAziendeCPI = data;
					return _arrAziendeCPI;
				});
			}
			return $q.when(_arrAziendeCPI);
		}

		function arrTTirocini() {
			if (_arrTTirocini.length == 0) {
				return getAllList('tTirocinio').then(function (data) {
					_arrTTirocini = data;
					return _arrTTirocini;
				});
			}
			return $q.when(_arrTTirocini);
		}

		function arrTTirociniDLG() {
			if (_arrTTirociniDLG.length == 0) {
				return getAllList('tTirocinioDLG').then(function (data) {
					_arrTTirociniDLG = data;
					return _arrTTirociniDLG;
				});
			}
			return $q.when(_arrTTirociniDLG);
		}

		function arrTTirociniSpese() {
			if (_arrTTirociniSpese.length == 0) {
				return getAllList('tTirocinioSpesa').then(function (data) {
					_arrTTirociniSpese = data;
					return _arrTTirociniSpese;
				});
			}
			return $q.when(_arrTTirociniSpese);
		}

		function arrContenutoFormativo() {
			if (_arrContenutoFormativo.length == 0) {
				return getAllList('contenutoFormativo').then(function (data) {
					_arrContenutoFormativo = data;
					return _arrContenutoFormativo;
				});
			}
			return $q.when(_arrContenutoFormativo);
		}

        /*
		function arrParams() {
		    if (_arrParams.length == 0) {
		        return getAllList('Params').then(function (data) {
		            _arrParams = data;
		            return _arrParams;
		        });
		    }
		    return $q.when(_arrParams);
		}
        */

		function arrParams() {
			if (_arrParams.length == 0) {
				return getAll('Params').then(function (data) {
					_arrParams = data;
					return _arrParams;
				});
			}
			return $q.when(_arrParams);
		}

		function arrStatiCivili() {
			if (_arrStatiCivili.length == 0) {
				return getAll('StatoCivile').then(function (data) {
					_arrStatiCivili = data;
					return _arrStatiCivili;
				});
			}
			return $q.when(_arrStatiCivili);
		}

		function arrStatiOccup() {
			if (_arrStatiOccup.length == 0) {
				return getAll('StatoOccup').then(function (data) {
					_arrStatiOccup = data;
					return _arrStatiOccup;
				});
			}
			return $q.when(_arrStatiOccup);
		}

		function arrTitoliStudio() {
			if (_arrTitoliStudio.length == 0) {
				return getAllList('TitoloStudio').then(function (data) {
					_arrTitoliStudio = data;
					return _arrTitoliStudio;
				});
			}
			return $q.when(_arrTitoliStudio);
		}

		function arrCittadinanze() {
			if (_arrCittadinanze.length == 0) {
				return getAll('Cittadinanza').then(function (data) {
					_arrCittadinanze = data;
					return _arrCittadinanze;
				});
			}
			return $q.when(_arrCittadinanze);
		}

		function arrTCittadinanza() {
			if (_arrTCittadinanza.length == 0) {
				return getAllList('TCittadinanza').then(function (data) {
					_arrTCittadinanza = data;
					return _arrTCittadinanza;
				});
			}
			return $q.when(_arrTCittadinanza);
		}

		function arrTQualifica() {
			if (_arrTQualifica.length == 0) {
				return getAllList('TQualifica').then(function (data) {
					_arrTQualifica = data;
					return _arrTQualifica;
				});
			}
			return $q.when(_arrTQualifica);
		}

		function arrTRapportoLavoro() {
			if (_arrTRapportoLavoro.length == 0) {
				return getAllList('TRapportoLavoro').then(function (data) {
					_arrTRapportoLavoro = data;
					return _arrTRapportoLavoro;
				});
			}
			return $q.when(_arrTRapportoLavoro);
		}

		function arrTAltraQualifica() {
			if (_arrTAltraQualifica.length == 0) {
				return getAllList('TAltraQualifica').then(function (data) {
					_arrTAltraQualifica = data;
					return _arrTAltraQualifica;
				});
			}
			return $q.when(_arrTAltraQualifica);
		}

		function arrTImpresa() {
			if (_arrTImpresa.length == 0) {
				return getAllList('TImpresa').then(function (data) {
					_arrTImpresa = data;
					return _arrTImpresa;
				});
			}
			return $q.when(_arrTImpresa);
		}

		function arrTClasseImpresa() {
			if (_arrTClasseImpresa.length == 0) {
				return getAllList('TClasseImpresa').then(function (data) {
					_arrTClasseImpresa = data;
					return _arrTClasseImpresa;
				});
			}
			return $q.when(_arrTClasseImpresa);
		}

		function arrTIndirizzo() {
			if (_arrTIndirizzo.length == 0) {
				return getAllList('TIndirizzo').then(function (data) {
					_arrTIndirizzo = data;
					return _arrTIndirizzo;
				});
			}
			return $q.when(_arrTIndirizzo);
		}

		function arrCNDCV_TPubb() {
			if (_arrCNDCV_TPubbi.length == 0) {
				return getAll('CNDCV_TPubb').then(function (data) {
					_arrCNDCV_TPubb = data;
					return _arrCNDCV_TPubb;
				});
			}
			return $q.when(_arrCNDCV_TPubb);
		}

		function arrCNDTProfili() {
			if (_arrCNDTProfili.length == 0) {
				return getAll('CNDTProfilo').then(function (data) {
					_arrCNDTProfili = data;
					return _arrCNDTProfili;
				});
			}
			return $q.when(_arrCNDTProfili);
		}

		function cndTProfilo_getAll(progettoId) {
			if (typeof progettoId == 'undefined') { progettoId = 0; }

			var params = [];
			params.push({ name: 'progettoId', value: progettoId });

			var data = getAllByParams('CNDTProfilo', 'GetAllByFilter', params);
			return $q.when(data);

		}

		// ******************************
		//  DESTINATARIO DIRETTO
		function destinatariodiretto_getAllList() {
			return risorsa_getAllList('', 5, 0, 0, '', 0, 0, 0, 0, '', 0, 0);
		}

		function destinatariodiretto_getAll(pageSize, page, nominativo, aziendaId, tirocinioId, provinciaId, comuneId, misura, cpiId, iStato, order) {
			return risorsa_getAll(pageSize, page, nominativo, 5, 0, aziendaId, '', 0, tirocinioId, provinciaId, comuneId, misura, cpiId, iStato, order);
		}

		function destinatariodiretto_countAll(nominativo, aziendaId, tirocinioId, provinciaId, comuneId, misura, cpiId, iStato) {
			return risorsa_countAll(nominativo, 5, 0, aziendaId, '', 0, tirocinioId, provinciaId, comuneId, misura, cpiId, iStato);
		}

		function destinatariodiretto_existsCF(destinatariodirettoId, codiceFiscale) {
			return risorsa_existsCF(destinatariodirettoId, codiceFiscale);
		}

		function destinatariodiretto_getAllByClasse(id) {
			var data = getAllByParam('risorsa', 'GetAllByClasse', 'id', id);
			return $q.when(data);
		}



		function destinatariodiretto_get(id) {
			var data = getById('risorsa', id);
			return $q.when(data);
		}

		function destinatariodiretto_add(item) {
			var data = addObj('risorsa', item);
			return $q.when(data);
		}

		function destinatariodiretto_update(item) {
			var data = updateObj('risorsa', item);
			return $q.when(data);
		}

		function destinatariodiretto_delete(id) {
			var data = deleteObj('risorsa', id);
			return $q.when(data);
		}


		// ******************************
		//  OMLS
		function omls_getAllList() {
			return risorsa_getAllList('', 6, 0, 0, '', 0, 0, 0, 0, '', 0, 0);
		}

		function omls_getAll(pageSize, page, nominativo, aziendaId, tirocinioId, iStato, order) {
			return risorsa_getAll(pageSize, page, nominativo, 6, 0, aziendaId, '', 0, tirocinioId, 0, 0, '', 0, iStato, order);
		}

		function omls_countAll(nominativo, aziendaId, tirocinioId, iStato) {
			return risorsa_countAll(nominativo, 6, 0, aziendaId, '', 0, tirocinioId, 0, 0, '', 0, iStato);
		}

		function omls_existsCF(omlsId, codiceFiscale) {
			return risorsa_existsCF(omlsId, codiceFiscale);
		}

		function omls_getAllByClasse(id) {
			var data = getAllByParam('risorsa', 'GetAllByClasse', 'id', id);
			return $q.when(data);
		}

		function omls_statusCF(codiceFiscale, aziendaId) {
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			var params = [];
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'aziendaId', value: aziendaId });

			var data = getAllByParams('risorsa', 'StatusCF', params);
			return $q.when(data);
		}

		function omls_assign(codiceFiscale, aziendaId) {
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			var params = [];
			params.push({ name: 'CodiceFiscale', value: codiceFiscale });
			params.push({ name: 'aziendaId', value: aziendaId });

			var item = {};
			item.codiceFiscale = codiceFiscale;
			item.AziendaId = aziendaId;

			var data = putMethod('risorsa', 'Assign', item);
			return $q.when(data);
		}



		function omls_get(id) {
			var data = getById('risorsa', id);
			return $q.when(data);
		}

		function omls_add(item) {
			var data = addObj('risorsa', item);
			return $q.when(data);
		}

		function omls_update(item) {
			var data = updateObj('risorsa', item);
			return $q.when(data);
		}

		function omls_delete(id) {
			var data = deleteObj('risorsa', id);
			return $q.when(data);
		}

		// ******************************
		//  TUTOR
		function tutor_getAllList() {
			return risorsa_getAllList('', 7, 0, 0, '', 0, 0, 0, 0, '', 0, 0);
		}

		function tutor_getAll(pageSize, page, nominativo, aziendaId, tRuoloSoggettoCode, realizzatoreId, tirocinioId, iStato, order) {
			return risorsa_getAll(pageSize, page, nominativo, 7, 0, aziendaId, tRuoloSoggettoCode, realizzatoreId, tirocinioId, 0, 0, '', 0, iStato, order);
		}

		function tutor_countAll(nominativo, aziendaId, tRuoloSoggettoCode, realizzatoreId, tirocinioId, iStato) {
			return risorsa_countAll(nominativo, 7, 0, aziendaId, tRuoloSoggettoCode, realizzatoreId, tirocinioId, 0, 0, '', 0, iStato);
		}

		function tutor_existsCF(tutorId, codiceFiscale) {
			return risorsa_existsCF(tutorId, codiceFiscale);
		}

		function tutor_get(id) {
			var data = getById('risorsa', id);
			return $q.when(data);
		}

		function tutor_add(item) {
			var data = addObj('risorsa', item);
			return $q.when(data);
		}

		function tutor_update(item) {
			var data = updateObj('risorsa', item);
			return $q.when(data);
		}

		function tutor_delete(id) {
			var data = deleteObj('risorsa', id);
			return $q.when(data);
		}

		// ******************************
		//  DIPENDENTE
		function dipendente_getAllList() {
			return risorsa_getAllList('', 11, 0, 0, '', 0, 0, 0, 0, '', 0, 0);
		}

		function dipendente_getAll(pageSize, page, nominativo, aziendaId, tRuoloSoggettoCode, realizzatoreId, tirocinioId, iStato, order) {
			return risorsa_getAll(pageSize, page, nominativo, 11, 0, aziendaId, tRuoloSoggettoCode, realizzatoreId, tirocinioId, 0, 0, '', 0, iStato, order);
		}

		function dipendente_countAll(nominativo, aziendaId, tRuoloSoggettoCode, realizzatoreId, tirocinioId, iStato) {
			return risorsa_countAll(nominativo, 11, 0, aziendaId, tRuoloSoggettoCode, realizzatoreId, tirocinioId, 0, 0, '', 0, iStato);
		}

		function dipendente_existsCF(dipId, codiceFiscale) {
			return risorsa_existsCF(dipId, codiceFiscale);
		}

		function dipendente_get(id) {
			var data = getById('risorsa', id);
			return $q.when(data);
		}

		function dipendente_add(item) {
			var data = addObj('risorsa', item);
			return $q.when(data);
		}

		function dipendente_update(item) {
			var data = updateObj('risorsa', item);
			return $q.when(data);
		}

		function dipendente_delete(id) {
			var data = deleteObj('risorsa', id);
			return $q.when(data);
		}


		// ******************************
		//  ASSEGNAZIONE
		function assegnazione_getAll() {
			var data = getAll('assegnazione');
			return $q.when(data);
		}

		function assegnazione_getAllByCorso(id) {
			var data = getAllByParam('assegnazione', 'GetAllByCorso', 'id', id);
			return $q.when(data);
		}

		function assegnazione_getAllByRisorsa(id) {
			var data = getAllByParam('assegnazione', 'GetAllByRisorsa', 'id', id);
			return $q.when(data);
		}

		function assegnazione_getAllBySede(id) {
			var data = getAllByParam('assegnazione', 'GetAllBySede', 'id', id);
			return $q.when(data);
		}

		function assegnazione_get(id) {
			var data = getById('assegnazione', id);
			return $q.when(data);
		}

		function assegnazione_add(item) {
			var data = addObj('assegnazione', item);
			return $q.when(data);
		}

		function assegnazione_update(item) {
			var data = updateObj('assegnazione', item);
			return $q.when(data);
		}

		function assegnazione_delete(id) {
			var data = deleteObj('assegnazione', id);
			return $q.when(data);
		}

		// ******************************
		//  CLASSE - NUOVI METODI
		function classe_getAllList(bAttivo, bCompleted) {
			if (typeof bAttivo == 'undefined') { bAttivo = 0; }
			if (typeof bCompleted == 'undefined') { bCompleted = 0; }
			var params = [];
			params.push({ name: 'bAttivo', value: bAttivo });
			params.push({ name: 'bCompleted', value: bCompleted });

			var data = getAllByParams('classe', 'GetAllList', params);

			return $q.when(data);
		}

		function classe_getAllMemberDidList(gruppoDidId, bCompleted) {
			if (typeof gruppoDidId == 'undefined') { gruppoDidId = 0; }
			if (typeof bCompleted == 'undefined') { bCompleted = 0; }
			var params = [];
			params.push({ name: 'filterMemberDid', value: 0 }); //filtro: solo soggetti che appartengono gi� al gruppo
			params.push({ name: 'gruppoDidId', value: gruppoDidId });
			params.push({ name: 'bCompleted', value: bCompleted });
			params.push({ name: 'aplId', value: 0 });
			params.push({ name: 'cpiId', value: 0 });


			var data = getAllByParams('classe', 'GetAllListByFilter', params);

			return $q.when(data);
		}

		function classe_getAllNoMemberDidList(gruppoDidId, bCompleted) {
			if (typeof gruppoDidId == 'undefined') { gruppoDidId = 0; }
			if (typeof bCompleted == 'undefined') { bCompleted = 0; }
			var params = [];
			params.push({ name: 'filterMemberDid', value: 1 }); //filtro: solo soggetti che non appartengono gi� al gruppo
			params.push({ name: 'gruppoDidId', value: gruppoDidId });
			params.push({ name: 'bCompleted', value: bCompleted });
			params.push({ name: 'aplId', value: 0 });
			params.push({ name: 'cpiId', value: 0 });

			var data = getAllByParams('classe', 'GetAllListByFilter', params);

			return $q.when(data);
		}

		function classe_getAll(pageSize, page, bAttivo, bCompleted, isWhole, classe, istitutoId, corsoId, misuraId, provinciaId, aplId, cpiId, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof bAttivo == 'undefined') { bAttivo = 0; }
			if (typeof bCompleted == 'undefined') { bCompleted = 0; }
			if (typeof isWhole == 'undefined') { isWhole = 0; }
			if (typeof classe == 'undefined') { classe = ''; }
			if (typeof istitutoId == 'undefined') { istitutoId = 0; }
			if (typeof corsoId == 'undefined') { corsoId = 0; }
			if (typeof misuraId == 'undefined') { misuraId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			var gruppoDidId = 0;
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'bAttivo', value: bAttivo });
			params.push({ name: 'bCompleted', value: bCompleted });
			params.push({ name: 'isWhole', value: isWhole });
			params.push({ name: 'classe', value: classe });
			params.push({ name: 'istitutoId', value: istitutoId });
			params.push({ name: 'corsoId', value: corsoId });
			params.push({ name: 'misuraId', value: misuraId });
			params.push({ name: 'gruppoDidId', value: gruppoDidId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('classe', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function classe_countAllMemberDidList(gruppoDidId) {
			if (typeof gruppoDidId == 'undefined') { gruppoDidId = 0; }
			var params = [];
			params.push({ name: 'filterMemberDid', value: 0 }); //filtro: solo soggetti che appartengono gi� al gruppo
			params.push({ name: 'gruppoDidId', value: gruppoDidId });
			params.push({ name: 'aplId', value: 0 });
			params.push({ name: 'cpiId', value: 0 });

			var data = getAllByParams('classe', 'CountByFilter', params);

			return $q.when(data);
		}

		function classe_countAllNoMemberDidList(gruppoDidId) {
			if (typeof gruppoDidId == 'undefined') { gruppoDidId = 0; }
			var params = [];
			params.push({ name: 'filterMemberDid', value: 1 }); //filtro: solo soggetti che non appartengono gi� al gruppo
			params.push({ name: 'gruppoDidId', value: gruppoDidId });
			params.push({ name: 'aplId', value: 0 });
			params.push({ name: 'cpiId', value: 0 });

			var data = getAllByParams('classe', 'CountByFilter', params);

			return $q.when(data);
		}

		function classe_countAll(bAttivo, bCompleted, isWhole, classe, istitutoId, corsoId, misuraId, provinciaId, aplId, cpiId) {
			if (typeof bAttivo == 'undefined') { bAttivo = 0; }
			if (typeof bCompleted == 'undefined') { bCompleted = 0; }
			if (typeof isWhole == 'undefined') { isWhole = 0; }
			if (typeof classe == 'undefined') { classe = ''; }
			if (typeof istitutoId == 'undefined') { istitutoId = 0; }
			if (typeof corsoId == 'undefined') { corsoId = 0; }
			if (typeof misuraId == 'undefined') { misuraId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }

			var gruppoDidId = 0;

			var params = [];
			params.push({ name: 'bAttivo', value: bAttivo });
			params.push({ name: 'bCompleted', value: bCompleted });
			params.push({ name: 'isWhole', value: isWhole });
			params.push({ name: 'classe', value: classe });
			params.push({ name: 'istitutoId', value: istitutoId });
			params.push({ name: 'corsoId', value: corsoId });
			params.push({ name: 'misuraId', value: misuraId });
			params.push({ name: 'gruppoDidId', value: gruppoDidId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'cpiId', value: cpiId });

			var data = getAllByParams('classe', 'CountByFilter', params);
			return $q.when(data);
		}


		function classe_getAllByCorso(id) {
			var data = getAllByParam('classe', 'GetAllByCorso', 'id', id);
			return $q.when(data);
		}

		function classe_getAllByIstituto(id) {
			var data = getAllByParam('classe', 'GetAllByIstituto', 'id', id);
			return $q.when(data);
		}

		function classe_get(id) {
			var data = getById('classe', id);
			return $q.when(data);
		}

		function classe_add(item) {
			var data = addObj('classe', item);
			return $q.when(data);
		}

		function classe_update(item) {
			var data = updateObj('classe', item);
			return $q.when(data);
		}

		function classe_delete(id) {
			var data = deleteObj('classe', id);
			return $q.when(data);
		}

		function classe_existsCUP(classeId, cup) {
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof cup == 'undefined') { cup = ''; }
			var params = [];
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'cup', value: cup });

			var data = getAllByParams('classe', 'ExistsCUP', params);
			return $q.when(data);
		}


		function classe_unlock(item) {
			var objName = 'classe';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		// ******************************
		//  CORSO
		function corso_getAllList() {
			var data = getAllList('corso');
			return $q.when(data);
		}

		function corso_getListByFilter(aplId, titolo) {
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof titolo == 'undefined') { titolo = ''; }

			var params = [];
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'titolo', value: titolo });

			var data = getAllByParams('corso', 'GetListByFilter', params);
			return $q.when(data);
		}

		function corso_getAll(pageSize, page, aplId, titolo) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof titolo == 'undefined') { titolo = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'titolo', value: titolo });

			var data = getAllByParams('corso', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function corso_countAll(aplId, titolo) {
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof titolo == 'undefined') { titolo = ''; }
			var params = [];
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'titolo', value: titolo });

			var data = getAllByParams('corso', 'CountByFilter', params);
			return $q.when(data);
		}

		function corso_get(id) {
			var data = getById('corso', id);
			return $q.when(data);
		}

		function corso_getBase(id) {
			console.log("getCorsoBase(%d)", id);

			var data = getBaseById('corso', id);
			return $q.when(data);
		}

		function corso_add(item) {
			var data = addObj('corso', item);
			return $q.when(data);
		}

		function corso_update(item) {
			var data = updateObj('corso', item);
			return $q.when(data);
		}

		function corso_delete(id) {
			var data = deleteObj('corso', id);
			return $q.when(data);
		}


		// ******************************
		//  DETTAGLIO ORA
		function dettaglioOra_getAll(classeId, dt, dw) {
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof dt == 'undefined') { dt = ''; }
			if (typeof dw == 'undefined') { dw = -1; }
			var params = [];
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'dt', value: dt });
			params.push({ name: 'dw', value: dw });

			var data = getAllByParams('dettaglioOra', 'GetAll', params);
			return $q.when(data);

		}

		function dettaglioOra_get(id) {
			var data = getById('dettaglioOra', id);
			return $q.when(data);
		}

		function dettaglioOra_add(item) {
			var data = addObj('dettaglioOra', item);
			return $q.when(data);
		}

		function dettaglioOra_update(item) {
			var data = updateObj('dettaglioOra', item);
			return $q.when(data);
		}

		function dettaglioOra_delete(id) {
			var data = deleteObj('dettaglioOra', id);
			return $q.when(data);
		}

		function dettaglioOra_saveFoglio(objValue) {
			var objName = 'dettaglioOra';
			var objMethod = 'SaveAll';

			return postMethod(objName, objMethod, objValue);
            /*
		    return $http.post(urlAPI + '/' + objName + '/SaveAll', objValue)
                                    .then(function (response) {
                                        return response.data;
                                    })
                                    .catch(function (message) {
                                        console.info('XHR Failed updateObj for %s: %s', objName, message);
                                        return message.status;
                                    });*/
		}


		// ******************************
		//  DATO CONSUNTIVO
		function datoConsuntivo_getMinuteByFilter(risorsaId, dtInizio, dtFine, tipoRegistrazioneId) {
			if (typeof risorsaId == 'undefined') { risorsaId = 0; }
			if (typeof dtInizio == 'undefined') { dtInizio = '1/1/2015'; }
			if (typeof dtFine == 'undefined') { dtFine = '1/1/2015'; }
			if (typeof tipoRegistrazioneId == 'undefined') { tipoRegistrazioneId = -1; }
			var params = [];
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'dtInizio', value: dtInizio });
			params.push({ name: 'dtFine', value: dtFine });
			params.push({ name: 'tipoRegistrazioneId', value: tipoRegistrazioneId });


			var data = getAllByParams('datoConsuntivo', 'MinuteByFilter', params);
			return $q.when(data);
		}

		function datoConsuntivo_getDatiRisorsaByFilter(anno, mese) {
			if (typeof anno == 'undefined') { anno = '2000'; }
			if (typeof mese == 'undefined') { mese = '1'; }
			var params = [];
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });


			var data = getAllByParams('datoConsuntivo', 'DatiRisorsa', params);
			return $q.when(data);
		}

		// ******************************
		//  DOCENZA
		function docenza_getAll() {
			var data = getAll('docenza');
			return $q.when(data);
		}

		function docenza_getAllByClasse(id) {
			var data = getAllByParam('docenza', 'GetAllByClasse', 'id', id);
			return $q.when(data);
		}

		function docenza_getAllByRisorsa(id) {
			var data = getAllByParam('docenza', 'GetAllByRisorsa', 'id', id);
			return $q.when(data);
		}

		function docenza_getAllByMateria(classeId, materiaId) {
			if (typeof classeId == 'undefined') { classeId = '0'; }
			if (typeof materiaId == 'undefined') { materiaId = '0'; }
			var params = [];
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'materiaId', value: materiaId });

			var data = getAllByParams('docenza', 'GetAllByMateria', params);
			return $q.when(data);
		}

		function docenza_get(id) {
			var data = getById('docenza', id);
			return $q.when(data);
		}

		function docenza_add(item) {
			var data = addObj('docenza', item);
			return $q.when(data);
		}

		function docenza_update(item) {
			var data = updateObj('docenza', item);
			return $q.when(data);
		}

		function docenza_delete(id) {
			var data = deleteObj('docenza', id);
			return $q.when(data);
		}

		// ******************************
		//  GRUPPO AMMINISTRATIVO
		function gruppoAmm_getAllList() {
			var data = getAllList('gruppoAmm');
			return $q.when(data);
		}


		function gruppoAmm_getAll(pageSize, page, risorsaId, titolo, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof risorsaId == 'undefined') { risorsaId = '0'; }
			if (typeof titolo == 'undefined') { titolo = ''; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'titolo', value: titolo });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('gruppoAmm', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function gruppoAmm_countAll(risorsaId, titolo) {
			if (typeof risorsaId == 'undefined') { risorsaId = '0'; }
			if (typeof titolo == 'undefined') { titolo = ''; }

			var params = [];
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'titolo', value: titolo });

			var data = getAllByParams('gruppoAmm', 'CountByFilter', params);
			return $q.when(data);
		}

		function gruppoAmm_get(id) {
			var data = getById('gruppoAmm', id);
			return $q.when(data);
		}

		function gruppoAmm_add(item) {
			var data = addObj('gruppoAmm', item);
			return $q.when(data);
		}

		function gruppoAmm_update(item) {
			var data = updateObj('gruppoAmm', item);
			return $q.when(data);
		}

		function gruppoAmm_delete(id) {
			var data = deleteObj('gruppoAmm', id);
			return $q.when(data);
		}

		// Gruppo Amministrativo - Membro
		function gruppoAmm_membroAdd(item) {
			var data = addObj('gruppoAmmMembro', item);
			return $q.when(data);
		}
		function gruppoAmm_membroDelete(id) {
			var data = deleteObj('gruppoAmmMembro', id);
			return $q.when(data);
		}


		function gruppoAmm_membroChangeRuolo(id, ruolo) {
			if (typeof id == 'undefined') { id = 0; }
			if (typeof ruolo == 'undefined') { ruolo = 0; }

			var url = urlAPI + '/gruppoAmmMembro/ChangeRuolo?id=' + id + "&ruolo=" + ruolo;
			return $http.post(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed activate for user: %s', message);
					return message.status;
				});
		}

		function gruppoAmm_membriByGruppo(id, ruolo) {
			if (typeof id == 'undefined') { id = 0; }
			if (typeof ruolo == 'undefined') { ruolo = -1; }
			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'ruolo', value: ruolo });

			var data = getAllByParams('gruppoAmmMembro', 'GetAllByGruppo', params);
			return $q.when(data);
		}




		// ******************************
		//  GRUPPO DIDATTICO
		function gruppoDid_getAllList() {
			var data = getAllList('gruppoDid');
			return $q.when(data);
		}


		function gruppoDid_getAll(pageSize, page, risorsaId, titolo, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof risorsaId == 'undefined') { risorsaId = '0'; }
			if (typeof titolo == 'undefined') { titolo = ''; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'titolo', value: titolo });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('gruppoDid', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function gruppoDid_countAll(risorsaId, titolo) {
			if (typeof risorsaId == 'undefined') { risorsaId = '0'; }
			if (typeof titolo == 'undefined') { titolo = ''; }

			var params = [];
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'titolo', value: titolo });

			var data = getAllByParams('gruppoDid', 'CountByFilter', params);
			return $q.when(data);
		}

		function gruppoDid_get(id) {
			var data = getById('gruppoDid', id);
			return $q.when(data);
		}

		function gruppoDid_add(item) {
			var data = addObj('gruppoDid', item);
			return $q.when(data);
		}

		function gruppoDid_update(item) {
			var data = updateObj('gruppoDid', item);
			return $q.when(data);
		}

		function gruppoDid_delete(id) {
			var data = deleteObj('gruppoDid', id);
			return $q.when(data);
		}

		// Gruppo Didattico - Membro
		function gruppoDid_membroAdd(item) {
			var data = addObj('gruppoDidMembro', item);
			return $q.when(data);
		}
		function gruppoDid_membroDelete(id) {
			var data = deleteObj('gruppoDidMembro', id);
			return $q.when(data);
		}


		function gruppoDid_membroChangeRuolo(id, ruolo) {
			if (typeof id == 'undefined') { id = 0; }
			if (typeof ruolo == 'undefined') { ruolo = 0; }

			var url = urlAPI + '/gruppoDidMembro/ChangeRuolo?id=' + id + "&ruolo=" + ruolo;
			return $http.post(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed activate for user: %s', message);
					return message.status;
				});
		}

		function gruppoDid_membriByGruppo(id, ruolo) {
			if (typeof id == 'undefined') { id = 0; }
			if (typeof ruolo == 'undefined') { ruolo = -1; }
			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'ruolo', value: ruolo });

			var data = getAllByParams('gruppoDidMembro', 'GetAllByGruppo', params);
			return $q.when(data);
		}

		function gruppoDid_gruppiByRisorsa(id, ruolo) {
			if (typeof id == 'undefined') { id = 0; }
			if (typeof ruolo == 'undefined') { ruolo = -1; }
			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'ruolo', value: ruolo });

			var data = getAllByParams('gruppoDidMembro', 'GetAllByRisorsa', params);
			return $q.when(data);
		}

		// Gruppo Amministrativo - classe
		function gruppoDid_classeAdd(item) {
			var data = addObj('gruppoDidClasse', item);
			return $q.when(data);
		}
		function gruppoDid_classeDelete(id) {
			var data = deleteObj('gruppoDidClasse', id);
			return $q.when(data);
		}


		function gruppoDid_classiByGruppo(id) {
			if (typeof id == 'undefined') { id = 0; }
			var params = [];
			params.push({ name: 'id', value: id });

			var data = getAllByParams('gruppoDidClasse', 'GetAllByGruppo', params);
			return $q.when(data);
		}

		// Gruppo Amministrativo - azienda
		function gruppoDid_aziendaAdd(item) {
			var data = addObj('gruppoDidAzienda', item);
			return $q.when(data);
		}
		function gruppoDid_aziendaDelete(id) {
			var data = deleteObj('gruppoDidAzienda', id);
			return $q.when(data);
		}


		function gruppoDid_aziendeByGruppo(id) {
			if (typeof id == 'undefined') { id = 0; }
			var params = [];
			params.push({ name: 'id', value: id });

			var data = getAllByParams('gruppoDidAzienda', 'GetAllByGruppo', params);
			return $q.when(data);
		}

		// Gruppo Amministrativo - tirocinio
		function gruppoDid_tirocinioAdd(item) {
			var data = addObj('gruppoDidTirocinio', item);
			return $q.when(data);
		}
		function gruppoDid_tirocinioDelete(id) {
			var data = deleteObj('gruppoDidTirocinio', id);
			return $q.when(data);
		}

		function gruppoDid_tirociniByGruppo(id) {
			if (typeof id == 'undefined') { id = 0; }
			var params = [];
			params.push({ name: 'id', value: id });

			var data = getAllByParams('gruppoDidTirocinio', 'GetAllByGruppo', params);
			return $q.when(data);
		}

		// Gruppo Amministrativo - project
		function gruppoDid_projectAdd(item) {
			var data = addObj('gruppoDidProject', item);
			return $q.when(data);
		}
		function gruppoDid_projectDelete(id) {
			var data = deleteObj('gruppoDidProject', id);
			return $q.when(data);
		}


		function gruppoDid_projectsByGruppo(id) {
			if (typeof id == 'undefined') { id = 0; }
			var params = [];
			params.push({ name: 'id', value: id });

			var data = getAllByParams('gruppoDidProject', 'GetAllByGruppo', params);
			return $q.when(data);
		}

		// Gruppo Amministrativo - ticket
		function gruppoDid_ticketAdd(item) {
			var data = addObj('gruppoDidTicket', item);
			return $q.when(data);
		}

		function gruppoDid_ticketDelete(id) {
			var data = deleteObj('gruppoDidTicket', id);
			return $q.when(data);
		}


		function gruppoDid_ticketsByGruppo(id) {
			if (typeof id == 'undefined') { id = 0; }
			var params = [];
			params.push({ name: 'id', value: id });

			var data = getAllByParams('gruppoDidTicket', 'GetAllByGruppo', params);
			return $q.when(data);
		}

		/*
		function getGruppiAmm() {
				var data = getAll('gruppoAmm');
				return $q.when(data);
		}

		function getGruppiAmmByFilter(page, nome) {
				var params = [];
				params.push({ name: 'page', value: page });
				params.push({ name: 'nome', value: nome });

				var data = getAllByParams('gruppoAmm', 'GetAllByFilter', params);
				return $q.when(data);

		}

		function countGruppiAmmByFilter(nome) {
				var params = [];
				params.push({ name: 'nome', value: nome });

				var data = getAllByParams('gruppoAmm', 'CountByFilter', params);
				return $q.when(data);
		}

		function getGruppiAmmList() {
				var data = getList('gruppoAmm');
				return $q.when(data);
		}

		function getGruppoAmm(id) {
				var data = getById('gruppoAmm', id);
				return $q.when(data);
		}

		function getGruppoAmmBase(id) {
				var data = getBaseById('gruppoAmm', id);
				return $q.when(data);
		}

		function addGruppoAmm(item) {
				var data = addObj('gruppoAmm', item);
				return $q.when(data);
		}

		function updateGruppoAmm(item) {
				var data = updateObj('gruppoAmm', item);
				return $q.when(data);
		}

		function deleteGruppoAmm(id) {
				console.log("deleteGruppoAmm(%s)", id);

				var data = deleteObj('gruppoAmm', id);
				return $q.when(data);
		}

		
		*/

		// ******************************
		//  GRUPPO DIDATTICO
		/*
		function getGruppiDid() {
				var data = getAll('gruppoDid');
				return $q.when(data);
		}

		function getGruppiDidByFilter(page, nome) {
				var params = [];
				params.push({ name: 'page', value: page });
				params.push({ name: 'nome', value: nome });

				var data = getAllByParams('gruppoDid', 'GetAllByFilter', params);
				return $q.when(data);

		}

		function countGruppiDidByFilter(nome) {
				var params = [];
				params.push({ name: 'nome', value: nome });

				var data = getAllByParams('gruppoDid', 'CountByFilter', params);
				return $q.when(data);
		}

		function getGruppiDidList() {
				var data = getList('gruppoDid');
				return $q.when(data);
		}

		function getGruppoDid(id) {
				var data = getById('gruppoDid', id);
				return $q.when(data);
		}

		function getGruppoDidBase(id) {
				var data = getBaseById('gruppoDid', id);
				return $q.when(data);
		}

		function addGruppoDid(item) {
				var data = addObj('gruppoDid', item);
				return $q.when(data);
		}

		function updateGruppoDid(item) {
				var data = updateObj('gruppoDid', item);
				return $q.when(data);
		}

		function deleteGruppoDid(id) {
				var data = deleteObj('gruppoDid', id);
				return $q.when(data);
		}

		// Gruppo Amministrativo - Membro
		function getGruppoDidMembriByGruppo(id) {
				var data = getAllByParam('gruppoDidMembro', 'GetAllByGruppo', 'id', id);
				return $q.when(data);
		}
		*/

		// ******************************
		//  TICKET
		function ticket_getAllList(tTicketId, statusId, idParent, toRead, gruppoDidId, nominativo) {
			if (typeof tTicketId == 'undefined') { tTicketId = 0; }
			if (typeof statusId == 'undefined') { statusId = 0; }
			if (typeof idParent == 'undefined') { idParent = 0; }
			if (typeof toRead == 'undefined') { toRead = 0; }
			if (typeof gruppoDidId == 'undefined') { gruppoDidId = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }

			var params = [];
			params.push({ name: 'tTicketId', value: tTicketId });
			params.push({ name: 'statusId', value: statusId });
			params.push({ name: 'idParent', value: idParent });
			params.push({ name: 'toRead', value: toRead });
			params.push({ name: 'gruppoDidId', value: gruppoDidId });
			params.push({ name: 'nominativo', value: nominativo });

			var data = getAllByParams('ticket', 'GetList', params);
			return $q.when(data);
		}

		function ticket_getAll(pageSize, page, tTicketId, statusId, idParent, toRead, gruppoDidId, nominativo, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof tTicketId == 'undefined') { tTicketId = 0; }
			if (typeof statusId == 'undefined') { statusId = 0; }
			if (typeof idParent == 'undefined') { idParent = -1; }
			if (typeof toRead == 'undefined') { toRead = 0; }
			if (typeof gruppoDidId == 'undefined') { gruppoDidId = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'tTicketId', value: tTicketId });
			params.push({ name: 'statusId', value: statusId });
			params.push({ name: 'idParent', value: idParent });
			params.push({ name: 'toRead', value: toRead });
			params.push({ name: 'gruppoDidId', value: gruppoDidId });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('ticket', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function ticket_countAll(tTicketId, statusId, idParent, toRead, gruppoDidId, nominativo) {
			if (typeof tTicketId == 'undefined') { tTicketId = 0; }
			if (typeof statusId == 'undefined') { statusId = 0; }
			if (typeof idParent == 'undefined') { idParent = -1; }
			if (typeof toRead == 'undefined') { toRead = 0; }
			if (typeof gruppoDidId == 'undefined') { gruppoDidId = 0; }
			if (typeof nominativo == 'undefined') { nominativo = 0; }

			var params = [];
			params.push({ name: 'tTicketId', value: tTicketId });
			params.push({ name: 'statusId', value: statusId });
			params.push({ name: 'idParent', value: idParent });
			params.push({ name: 'toRead', value: toRead });
			params.push({ name: 'gruppoDidId', value: gruppoDidId });
			params.push({ name: 'nominativo', value: nominativo });

			var data = getAllByParams('ticket', 'CountByFilter', params);
			return $q.when(data);
		}

		function ticket_get(id) {
			var data = getById('ticket', id);
			return $q.when(data);
		}

		function ticket_add(item) {
			var data = addObj('ticket', item);
			return $q.when(data);
		}

		function ticket_update(item) {
			var data = updateObj('ticket', item);
			return $q.when(data);
		}

		function ticket_setRead(ticketId) {
			if (typeof ticketId == 'undefined') { ticketId = 0; }

			var item = {};
			item.TicketId = ticketId;

			return $http.put(urlAPI + '/ticket/SetRead', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for SetRead: %s', message);
					return message.status;
				});
		}

		function ticket_delete(id) {
			console.log("deleteticket(%s)", id);

			var data = deleteObj('ticket', id);
			return $q.when(data);
		}

		function ticket_unlock(item) {
			var objName = 'ticket';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		// ******************************
		//  TTICKET
		function tTicket_getAllList() {
			var data = getAllList('tTicket');
			return $q.when(data);
		}

		function tTicket_getListFiltered() {
			var data = getAllNoParam('tTicket', 'GetListFiltered');
			return $q.when(data);
		}

		function tTicket_getAll(pageSize, page, nome, projectId, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof projectId == 'undefined') { projectId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'projectId', value: projectId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('tTicket', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function tTicket_countAll(tTicketId, status, projectId) {
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof projectId == 'undefined') { projectId = 0; }

			var params = [];
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'projectId', value: projectId });

			var data = getAllByParams('tTicket', 'CountByFilter', params);
			return $q.when(data);
		}

		function tTicket_get(id) {
			var data = getById('tTicket', id);
			return $q.when(data);
		}

		function tTicket_add(item) {
			var data = addObj('tTicket', item);
			return $q.when(data);
		}

		function tTicket_update(item) {
			var data = updateObj('tTicket', item);
			return $q.when(data);
		}

		function tTicket_delete(id) {
			console.log("deleteticket(%s)", id);

			var data = deleteObj('tTicket', id);
			return $q.when(data);
		}

		// ******************************
		//  PROJECT
		function project_getAllList() {
			var data = getAllList('project');
			return $q.when(data);
		}

		function project_getAllListByUsername() {
			var data = getAllNoParam('project', 'GetAllListByUsername');
			return $q.when(data);
		}

		function project_getAll(pageSize, page, name, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof name == 'undefined') { name = ''; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'name', value: name });
			params.push({ name: 'provinciaId', value: provinciaId });

			var data = getAllByParams('project', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function project_countAll(name) {
			if (typeof name == 'undefined') { name = ''; }

			var params = [];
			params.push({ name: 'name', value: name });

			var data = getAllByParams('project', 'CountByFilter', params);
			return $q.when(data);
		}

		function project_get(id) {
			var data = getById('project', id);
			return $q.when(data);
		}

		function project_add(item) {
			var data = addObj('project', item);
			return $q.when(data);
		}

		function project_update(item) {
			var data = updateObj('project', item);
			return $q.when(data);
		}

		function project_delete(id) {
			console.log("deleteproject(%s)", id);

			var data = deleteObj('project', id);
			return $q.when(data);
		}

		// ******************************
		//  STATUS
		function status_getAllList() {
			var data = getAllList('status');
			return $q.when(data);
		}

		function status_getAll(pageSize, page, name, stato, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof name == 'undefined') { name = ''; }
			if (typeof stato == 'undefined') { stato = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'name', value: name });
			params.push({ name: 'stato', value: stato });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('status', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function status_countAll(name, stato) {
			if (typeof name == 'undefined') { name = ''; }
			if (typeof stato == 'undefined') { stato = 0; }

			var params = [];
			params.push({ name: 'name', value: name });
			params.push({ name: 'stato', value: stato });

			var data = getAllByParams('status', 'CountByFilter', params);
			return $q.when(data);
		}

		function status_get(id) {
			var data = getById('status', id);
			return $q.when(data);
		}

		function status_add(item) {
			var data = addObj('status', item);
			return $q.when(data);
		}

		function status_update(item) {
			var data = updateObj('status', item);
			return $q.when(data);
		}

		function status_delete(id) {
			console.log("deletestatus(%s)", id);

			var data = deleteObj('status', id);
			return $q.when(data);
		}

		// ******************************
		//  TRACE
		function trace_getAllList() {
			var data = getAllList('trace');
			return $q.when(data);
		}

		function trace_getAll(pageSize, page, nome, ticketId, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof ticketId == 'undefined') { ticketId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'ticketId', value: ticketId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('trace', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function trace_countAll(traceId, status, ticketId) {
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof ticketId == 'undefined') { ticketId = 0; }

			var params = [];
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'ticketId', value: ticketId });

			var data = getAllByParams('trace', 'CountByFilter', params);
			return $q.when(data);
		}

		function trace_get(id) {
			var data = getById('trace', id);
			return $q.when(data);
		}

		function trace_add(item) {
			var data = addObj('trace', item);
			return $q.when(data);
		}

		function trace_update(item) {
			var data = updateObj('trace', item);
			return $q.when(data);
		}

		function trace_delete(id) {
			console.log("deleteticket(%s)", id);

			var data = deleteObj('trace', id);
			return $q.when(data);
		}

		// ******************************
		//  ISTAT
		function istat_comune_getAllList(idprov) {
			var data = getAllByParam('comune', 'GetAllByIdProv', 'id', idprov);
			return $q.when(data);
		}

		function istat_comune_get(id) {
			var data = getById('comune', id);
			return $q.when(data);
		}


		// ******************************
		//  INCARICO
		function incarico_getAll(pageSize, page, nominativo, profiloId, classeId) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof profiloId == 'undefined') { profiloId = 0; }
			if (typeof classeId == 'undefined') { classeId = 0; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'profiloId', value: profiloId });
			params.push({ name: 'classeId', value: classeId });

			var data = getAllByParams('incarico', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function incarico_countAll(nominativo, profiloId, classeId) {
			var params = [];
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'profiloId', value: profiloId });
			params.push({ name: 'classeId', value: classeId });

			var data = getAllByParams('incarico', 'CountByFilter', params);
			return $q.when(data);
		}

		function incarico_getAllByClasse(id) {
			var data = getAllByParam('incarico', 'GetAllByClasse', 'id', id);
			return $q.when(data);
		}

		function incarico_getAllByRisorsa(id) {
			var data = getAllByParam('incarico', 'GetAllByRisorsa', 'id', id);
			return $q.when(data);
		}

		function incarico_get(id) {
			var data = getById('incarico', id);
			return $q.when(data);
		}

		function incarico_getBase(id) {
			var data = getBaseById('incarico', id);
			return $q.when(data);
		}

		function incarico_add(item) {
			var data = addObj('incarico', item);
			return $q.when(data);
		}

		function incarico_update(item) {
			var data = updateObj('incarico', item);
			return $q.when(data);
		}

		function incarico_delete(id) {
			var data = deleteObj('incarico', id);
			return $q.when(data);
		}

		// ******************************
		//  ISTITUTO
		function istituto_getAllList() {
			var data = getAllList('istituto');
			return $q.when(data);
		}

		function istituto_getListByFilter(nome, aplId, sedeId) {
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof sedeId == 'undefined') { sedeId = 0; }

			var params = [];
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'sedeId', value: sedeId });

			var data = getAllByParams('istituto', 'GetListByFilter', params);
			return $q.when(data);

		}

		function istituto_getAll(pageSize, page, nome, aplId, sedeId) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof sedeId == 'undefined') { sedeId = 0; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'sedeId', value: sedeId });

			var data = getAllByParams('istituto', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function istituto_countAll(nome, aplId, sedeId) {
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof sedeId == 'undefined') { sedeId = 0; }

			var params = [];
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'sedeId', value: sedeId });

			var data = getAllByParams('istituto', 'CountByFilter', params);
			return $q.when(data);
		}

		function istituto_getAllBySede(id) {
			var data = getAllByParam('istituto', 'GetAllBySede', 'id', id);
			return $q.when(data);
		}

		function istituto_get(id) {
			var data = getById('istituto', id);
			return $q.when(data);
		}

		function istituto_getBase(id) {
			var data = getBaseById('istituto', id);
			return $q.when(data);
		}

		function istituto_add(item) {
			var data = addObj('istituto', item);
			return $q.when(data);
		}

		function istituto_update(item) {
			var data = updateObj('istituto', item);
			return $q.when(data);
		}

		function istituto_delete(id) {
			var data = deleteObj('istituto', id);
			return $q.when(data);
		}

		// ******************************
		//  LEZIONE
		function lezione_getAll(pageSize, page, docenteId, classeId, data, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof docenteId == 'undefined') { docenteId = 0; }
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof data == 'undefined') { data = ''; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'docenteId', value: docenteId });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'data', value: data });
			params.push({ name: 'order', value: order });


			var data1 = getAllByParams('lezione', 'GetAllByFilter', params);
			return $q.when(data1);

		}

		function lezione_countAll(docenteId, classeId, data) {
			if (typeof docenteId == 'undefined') { docenteId = 0; }
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof data == 'undefined') { data = ''; }

			var params = [];
			params.push({ name: 'docenteId', value: docenteId });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'data', value: data });

			var data1 = getAllByParams('lezione', 'CountByFilter', params);
			return $q.when(data1);
		}



		function lezione_get(id) {
			var data = getById('lezione', id);
			return $q.when(data);
		}


		function lezione_add(dataEffettiva, classeId, materiaId, docenteId) {
			if (typeof dataEffettiva == 'undefined') { dataEffettiva = ''; }
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof materiaId == 'undefined') { materiaId = 0; }
			if (typeof docenteId == 'undefined') { docenteId = 0; }

			var params = [];
			params.push({ name: 'dataEffettiva', value: dataEffettiva });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'materiaId', value: materiaId });
			params.push({ name: 'docenteId', value: docenteId });

			var objName = 'lezione';
			var actionName = 'Post';
			var url = urlAPI + '/' + objName + '/' + actionName;

			var numParams = params.length;
			if (numParams > 0) {
				url += '?'
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}


			return $http.post(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed addObj for %s: %s', objName, message);
					return message.status;
				});
			/*
			var data = addObj('lezione', item);
			return $q.when(data);
			*/
		}

		function lezione_update(lezione, dettaglioOre) {
			if (typeof lezione == 'undefined') { lezione = {}; }

			var params = [];


			var objName = 'lezione';
			var actionName = 'Put';
			var url = urlAPI + '/' + objName + '/' + actionName;

			var myData = {};
			myData.lezione = lezione;
			myData.dettaglioOre = dettaglioOre;

			return $http.post(url, myData)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
            /*

			return $http.put(url)
									.then(function (response) {
										return response.data;
									})
									.catch(function (message) {
										console.info('XHR Failed addObj for %s: %s', objName, message);
										return message.status;
									});
                                    */
			/*
			var data = updateObj('lezione', item);
			return $q.when(data);
			*/
		}

		function lezione_delete(id) {
			var data = deleteObj('lezione', id);
			return $q.when(data);
		}

		// ******************************
		//  PRESENZA
		function presenza_getAll(pageSize, page, lezioneId, studenteId, data, classeId) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof lezioneId == 'undefined') { lezioneId = 0; }
			if (typeof studenteId == 'undefined') { studenteId = 0; }
			if (typeof data == 'undefined') { data = ''; }
			if (typeof classeId == 'undefined') { classeId = 0; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'lezioneId', value: lezioneId });
			params.push({ name: 'studenteId', value: studenteId });
			params.push({ name: 'data', value: data });
			params.push({ name: 'classeId', value: classeId });


			var data1 = getAllByParams('presenza', 'GetAllByFilter', params);
			return $q.when(data1);

		}

		function presenza_getByFoglio(data, classeId) {
			if (typeof data == 'undefined') { data = ''; }
			if (typeof classeId == 'undefined') { classeId = 0; }

			var params = [];
			params.push({ name: 'pageSize', value: 0 });
			params.push({ name: 'page', value: 0 });
			params.push({ name: 'lezioneId', value: 0 });
			params.push({ name: 'studenteId', value: 0 });
			params.push({ name: 'data', value: data });
			params.push({ name: 'classeId', value: classeId });


			var data1 = getAllByParams('presenza', 'GetAllByFilter', params);
			return $q.when(data1);

		}

		function presenza_saveFoglio(objValue) {
			var objName = 'presenza';
			return $http.post(urlAPI + '/' + objName + '/SaveAll', objValue)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		/*
		function presenza_getAllByProc(classeId, data, studenteId) {
				if (typeof classeId == 'undefined') { classeId = 0; }
				if (typeof data == 'undefined') { data = ''; }
				if (typeof studenteId == 'undefined') { studenteId = 0; }
				var params = [];
				params.push({ name: 'classeId', value: classeId });
				params.push({ name: 'data', value: data });
				params.push({ name: 'studenteId', value: studenteId });


				var data = getAllByParams('presenza', 'GetAllByProc', params);
				return $q.when(data);

		}
		*/

		function presenza_countAll(lezioneId, studenteId, data) {
			if (typeof lezioneId == 'undefined') { lezioneId = 0; }
			if (typeof studenteId == 'undefined') { studenteId = 0; }
			if (typeof data == 'undefined') { data = ''; }

			var params = [];
			params.push({ name: 'lezioneId', value: lezioneId });
			params.push({ name: 'studenteId', value: studenteId });
			params.push({ name: 'data', value: data });

			var data1 = getAllByParams('presenza', 'CountByFilter', params);
			return $q.when(data1);
		}



		function presenza_get(id) {
			var data = getById('presenza', id);
			return $q.when(data);
		}


		function presenza_add(item) {
			var data = addObj('presenza', item);
			return $q.when(data);
		}

		function presenza_update(item) {
			var data = updateObj('presenza', item);
			return $q.when(data);
		}

		function presenza_delete(id) {
			var data = deleteObj('presenza', id);
			return $q.when(data);
		}

		function presenza_setStato(studenteId, lezioneId, stato, ore, minuti) {
			if (typeof studenteId == 'undefined') { studenteId = 0; }
			if (typeof lezioneId == 'undefined') { lezioneId = 0; }
			if (typeof stato == 'undefined') { stato = 0; }
			if (typeof ore == 'undefined') { ore = 0; }
			if (typeof minuti == 'undefined') { minuti = 0; }

			var params = [];
			params.push({ name: 'lezioneId', value: lezioneId });
			params.push({ name: 'studenteId', value: studenteId });
			params.push({ name: 'stato', value: stato });
			params.push({ name: 'ore', value: ore });
			params.push({ name: 'minuti', value: minuti });

			var data = getAllByParams('presenza', 'SetStato', params);
			return $q.when(data);
		}

		function presenza_setStatoClasse(classeId, lezioneId, stato) {
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof lezioneId == 'undefined') { lezioneId = 0; }
			if (typeof stato == 'undefined') { stato = 0; }

			var params = [];
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'lezioneId', value: lezioneId });
			params.push({ name: 'stato', value: stato });

			var data = getAllByParams('presenza', 'SetStatoClasse', params);
			return $q.when(data);
		}

		function presenza_inizializzaClasse(classeId, stato, dt) {
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof stato == 'undefined') { stato = 0; }
			if (typeof dt == 'undefined') { dt = 0; }

			var params = [];
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'stato', value: stato });
			params.push({ name: 'dt', value: dt });

			var data = getAllByParams('presenza', 'InizializzaClasse', params);
			return $q.when(data);
		}


		// ******************************
		//  REGISTRO ATTIVITA
		function regAttivita_getAll(pageSize, page, azId, sourceId, risorsaId, data, anno, mese, dtStart, dtEnd, iStato) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof azId == 'undefined') { azId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof risorsaId == 'undefined') { risorsaId = 0; }
			if (typeof data == 'undefined') { data = ''; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof dtStart == 'undefined') { dtStart = ''; }
			if (typeof dtEnd == 'undefined') { dtEnd = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'azId', value: azId });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'data', value: data });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'dtStart', value: dtStart });
			params.push({ name: 'dtEnd', value: dtEnd });
			params.push({ name: 'iStato', value: iStato });


			var data1 = getAllByParams('regAttivita', 'GetAllByFilter', params);
			return $q.when(data1);

		}

		function regAttivita_getByFoglio(azId, sourceId, risorsaId, data, anno, mese, iStato) {
			if (typeof azId == 'undefined') { azId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof risorsaId == 'undefined') { risorsaId = 0; }
			if (typeof data == 'undefined') { data = ''; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'pageSize', value: 0 });
			params.push({ name: 'page', value: 0 });
			params.push({ name: 'azId', value: azId });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'data', value: data });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'dtStart', value: '' });
			params.push({ name: 'dtEnd', value: '' });
			params.push({ name: 'iStato', value: iStato });


			var data1 = getAllByParams('regAttivita', 'GetAllByFilter', params);
			return $q.when(data1);

		}

		function regAttivita_saveFoglio(objValue) {
			var objName = 'regAttivita';
			return $http.post(urlAPI + '/' + objName + '/SaveAll', objValue)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

        /*
		function regAttivita_countAll(azId, sourceId, risorsaId, data) {
		    if (typeof azId == 'undefined') { azId = 0; }
		    if (typeof sourceId == 'undefined') { sourceId = 0; }
		    if (typeof risorsaId == 'undefined') { risorsaId = 0; }
		    if (typeof data == 'undefined') { data = ''; }

		    var params = [];
		    params.push({ name: 'azId', value: azId });
		    params.push({ name: 'sourceId', value: sourceId });
		    params.push({ name: 'risorsaId', risorsaId: risorsaId });
		    params.push({ name: 'data', value: data });

		    var data1 = getAllByParams('regAttivita', 'CountByFilter', params);
		    return $q.when(data1);
		}
        */


		function regAttivita_get(id) {
			var data = getById('regAttivita', id);
			return $q.when(data);
		}


		function regAttivita_add(item) {
			var data = addObj('regAttivita', item);
			return $q.when(data);
		}

		function regAttivita_update(item) {
			var data = updateObj('regAttivita', item);
			return $q.when(data);
		}

		function regAttivita_delete(id) {
			var data = deleteObj('regAttivita', id);
			return $q.when(data);
		}

		function regAttivita_exists(azId, sourceId, data, regAttId) {
			if (typeof azId == 'undefined') { azId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof data == 'undefined') { data = ''; }
			if (typeof regAttId == 'undefined') { regAttId = 0; }

			var params = [];
			params.push({ name: 'azId', value: azId });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'data', value: data });
			params.push({ name: 'regAttId', value: regAttId });

			var data1 = getAllByParams('regAttivita', 'Exists', params);
			return $q.when(data1);
		}

		function regAttivita_saveAndCompleted(item) {
			var objName = 'regAttivita';

			return $http.put(urlAPI + '/' + objName + '/SaveAndCompleted/', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed SaveAndCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		function regAttivita_setCompleted(id) {
			var objName = 'regAttivita';

			return $http.put(urlAPI + '/' + objName + '/SetCompleted/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed regAttivita_SetCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		function regAttivita_unsetCompleted(id) {
			var objName = 'attach';

			return $http.put(urlAPI + '/' + objName + '/UnsetCompleted/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed regAttivita_UnsetCompleted for %s: %s', objName, message);
					return message.status;
				});
		}
        /*
		function regAttivita_setStato(azId, risorsaId, data, ore1, minuti1, ore2, minuti2, ore3, minuti3, ore4, minuti4) {
		    if (typeof azId == 'undefined') { azId = 0; }
		    if (typeof risorsaId == 'undefined') { risorsaId = 0; }
		    if (typeof data == 'undefined') { data = ''; }
		    if (typeof ore1 == 'undefined') { ore1 = 0; }
		    if (typeof minuti1 == 'undefined') { minuti1 = 0; }
		    if (typeof ore2 == 'undefined') { ore2 = 0; }
		    if (typeof minuti2 == 'undefined') { minuti2 = 0; }
		    if (typeof ore3 == 'undefined') { ore3 = 0; }
		    if (typeof minuti3 == 'undefined') { minuti3 = 0; }
		    if (typeof ore4 == 'undefined') { ore4 = 0; }
		    if (typeof minuti4 == 'undefined') { minuti4 = 0; }

		    var params = [];
		    params.push({ name: 'azId', value: azId });
		    params.push({ name: 'risorsaId', value: risorsaId });
		    params.push({ name: 'data', value: data });
		    params.push({ name: 'ore1', value: ore1 });
		    params.push({ name: 'minuti1', value: minuti1 });
		    params.push({ name: 'ore2', value: ore2 });
		    params.push({ name: 'minuti2', value: minuti2 });
		    params.push({ name: 'ore3', value: ore3 });
		    params.push({ name: 'minuti3', value: minuti3 });
		    params.push({ name: 'ore4', value: ore4 });
		    params.push({ name: 'minuti4', value: minuti4 });

		    var data = getAllByParams('regAttivita', 'SetStato', params);
		    return $q.when(data);
		}
        
		function regAttivita_setStatoClasse(classeId, lezioneId, stato) {
		    if (typeof classeId == 'undefined') { classeId = 0; }
		    if (typeof lezioneId == 'undefined') { lezioneId = 0; }
		    if (typeof stato == 'undefined') { stato = 0; }

		    var params = [];
		    params.push({ name: 'classeId', value: classeId });
		    params.push({ name: 'lezioneId', value: lezioneId });
		    params.push({ name: 'stato', value: stato });

		    var data = getAllByParams('regAttivita', 'SetStatoClasse', params);
		    return $q.when(data);
		}
        
		function regAttivita_inizializzaClasse(classeId, stato, dt) {
		    if (typeof classeId == 'undefined') { classeId = 0; }
		    if (typeof stato == 'undefined') { stato = 0; }
		    if (typeof dt == 'undefined') { dt = 0; }

		    var params = [];
		    params.push({ name: 'classeId', value: classeId });
		    params.push({ name: 'stato', value: stato });
		    params.push({ name: 'dt', value: dt });

		    var data = getAllByParams('regAttivita', 'InizializzaClasse', params);
		    return $q.when(data);
		}
        */

		// ******************************
		//  tRegAttivita
		function tRegAttivita_getAllList(paramId, parentId) {
			if (typeof paramId == 'undefined') { paramId = 0; }
			if (typeof parentId == 'undefined') { parentId = 0; }
			var params = [];
			params.push({ name: 'paramId', value: paramId });
			params.push({ name: 'parentId', value: parentId });

			var data = getAllByParams('TRegAttivita', 'GetAllList', params);
			return $q.when(data);
		}


		function tRegAttivita_get(id) {
			var data = getById('RegAttivita', id);
			return $q.when(data);
		}

		// ******************************
		//  MATERIA
		function materia_getAllList() {
			//var data = getAllByParam('materia', 'GetAllList');
			var data = getAllList('materia');
			return $q.when(data);
		}

		function materia_getAllByCorso(id) {
			var data = getAllByParam('materia', 'GetAllByCorso', 'id', id);
			return $q.when(data);

		}



		function materia_get(id) {
			var data = getById('materia', id);
			return $q.when(data);
		}

		function materia_add(item) {
			var data = addObj('materia', item);
			return $q.when(data);
		}

		function materia_update(item) {
			var data = updateObj('materia', item);
			return $q.when(data);
		}

		function materia_delete(id) {
			var data = deleteObj('materia', id);
			return $q.when(data);
		}

		// ******************************
		//  MISURA
		function misura_getAllList() {
			var data = getAllList('misura', 'GetAllList');
			return $q.when(data);
		}

		function misura_getAll(pageSize, page, title) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof title == 'undefined') { title = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'title', value: title });

			var data = getAllByParams('misura', 'GetAllByFilter', params);
			return $q.when(data);

		}


		function misura_get(id) {
			var data = getById('misura', id);
			return $q.when(data);
		}



		// ******************************
		//  RIMBORSO
		function rimborso_getAllList() {
			var data = getAllList('rimborso');
			return $q.when(data);
		}

		function rimborso_getAll(pageSize, page, bStato, descrizione, classeId, misuraId) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof classeId == 'undefined') { classeId = 1; }
			if (typeof misuraId == 'undefined') { misuraId = 0; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'misuraId', value: misuraId });

			var data = getAllByParams('rimborso', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function rimborso_countAll(bStato, descrizione, classeId, misuraId) {
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof misuraId == 'undefined') { misuraId = 0; }
			var params = [];
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'misuraId', value: misuraId });

			var data = getAllByParams('rimborso', 'CountByFilter', params);
			return $q.when(data);
		}

		function rimborso_get(id) {
			var data = getById('rimborso', id);
			return $q.when(data);
		}


		function rimborso_add(item) {
			var data = addObj('rimborso', item);
			return $q.when(data);
		}

		function rimborso_update(item) {
			var data = updateObj('rimborso', item);
			return $q.when(data);
		}

		function rimborso_updateDatiAssess(item) {
			var objName = 'rimborso';
			var objValue = item;

			return $http.put(urlAPI + '/' + objName + '/PutDatiAssess', objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function rimborso_delete(id) {
			var data = deleteObj('rimborso', id);
			return $q.when(data);
		}

		function rimborso_unlock(item) {
			var objName = 'rimborso';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		// ******************************
		//  RISORSA
		function risorsa_getAllList(testuale, profiloId, classeId, aziendaId, tRuoloSoggettoCode, realizzatoreId, tirocinioId, provinciaId, comuneId, misura, cpiId, iStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof profiloId == 'undefined') { profiloId = 0; }
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof tRuoloSoggettoCode == 'undefined') { tRuoloSoggettoCode = ''; }
			if (typeof realizzatoreId == 'undefined') { realizzatoreId = 0; }
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }
			if (typeof misura == 'undefined') { misura = ''; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'profiloId', value: profiloId });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'tRuoloSoggettoCode', value: tRuoloSoggettoCode });
			params.push({ name: 'realizzatoreId', value: realizzatoreId });
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'comuneId', value: comuneId });
			params.push({ name: 'misura', value: misura });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('risorsa', 'GetAllListByFilter', params);

			return $q.when(data);
		}

		function risorsa_getAllListByText(searchText, profiloId, iStato) {
			if (typeof searchText == 'undefined') { searchText = ''; }
			if (typeof profiloId == 'undefined') { profiloId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'searchText', value: searchText });
			params.push({ name: 'profiloId', value: profiloId });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('risorsa', 'GetAllListByText', params);
			return $q.when(data);
		}

		function risorsa_getByUsernameList() {
			var data = getAllNoParam('risorsa', 'GetByUsernameList');
			return $q.when(data);
		}

		function risorsa_getAll(pageSize, page, testuale, profiloId, classeId, aziendaId, tRuoloSoggettoCode, realizzatoreId, tirocinioId, provinciaId, comuneId, misura, cpiId, iStato, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof order == 'undefined') { order = ''; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof profiloId == 'undefined') { profiloId = 0; }
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof tRuoloSoggettoCode == 'undefined') { tRuoloSoggettoCode = ''; }
			if (typeof realizzatoreId == 'undefined') { realizzatoreId = 0; }
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }
			if (typeof misura == 'undefined') { misura = ''; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }


			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'order', value: order });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'profiloId', value: profiloId });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'tRuoloSoggettoCode', value: tRuoloSoggettoCode });
			params.push({ name: 'realizzatoreId', value: realizzatoreId });
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'comuneId', value: comuneId });
			params.push({ name: 'misura', value: misura });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('risorsa', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function risorsa_countAll(testuale, profiloId, classeId, aziendaId, tRuoloSoggettoCode, realizzatoreId, tirocinioId, provinciaId, comuneId, misura, cpiId, iStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof profiloId == 'undefined') { profiloId = 0; }
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof tRuoloSoggettoCode == 'undefined') { tRuoloSoggettoCode = ''; }
			if (typeof realizzatoreId == 'undefined') { realizzatoreId = 0; }
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }
			if (typeof misura == 'undefined') { misura = ''; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'profiloId', value: profiloId });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'tRuoloSoggettoCode', value: tRuoloSoggettoCode });
			params.push({ name: 'realizzatoreId', value: realizzatoreId });
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'comuneId', value: comuneId });
			params.push({ name: 'misura', value: misura });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('risorsa', 'CountByFilter', params);
			return $q.when(data);
		}

		function risorsa_existsCF(risorsaId, codiceFiscale) {
			if (typeof risorsaId == 'undefined') { risorsaId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			var params = [];
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });

			var data = getAllByParams('risorsa', 'ExistsCF', params);
			return $q.when(data);
		}

		function risorsa_getByUsername() {
			var data = getAllNoParam('risorsa', 'GetByUsername');
			return $q.when(data);
		}

		function risorsa_getByUsername2(username) {
			var data = getAllByParam('risorsa', 'GetByUsername2', 'username', username);
			return $q.when(data);
		}

		function risorsa_get(id) {
			var data = getById('risorsa', id);
			return $q.when(data);
		}

		function risorsa_add(item) {
			var data = addObj('risorsa', item);
			return $q.when(data);
		}

		function risorsa_update(item) {
			var data = updateObj('risorsa', item);
			return $q.when(data);
		}

		function risorsa_delete(id) {
			var data = deleteObj('risorsa', id);
			return $q.when(data);
		}

		function risorsa_setRinuncia(objValue) {
			var objName = 'risorsa';
			return $http.put(urlAPI + '/' + objName + '/SetRinuncia', objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed SetRinunciaObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function risorsa_setDecaduto(objValue) {
			var objName = 'risorsa';
			return $http.put(urlAPI + '/' + objName + '/SetDecaduto', objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed SetDecadutoObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function risorsa_setNewAssign(objValue) {
			var objName = 'risorsa';
			return $http.put(urlAPI + '/' + objName + '/SetNewAssign', objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		// *********************************
		// RISORSA AZIONE
		function risorsaAzione_getList(testuale, risorsaId, cpiId, profiloANPALId, rinunciaCPIId) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof risorsaId == 'undefined') { risorsaId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof profiloANPALId == 'undefined') { profiloANPALId = 0; }
			if (typeof rinunciaCPIId == 'undefined') { rinunciaCPIId = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'profiloANPALId', value: profiloANPALId });
			params.push({ name: 'rinunciaCPIId', value: rinunciaCPIId });

			var data = getAllByParams('risorsaAzione', 'GetAllList', params);
			return $q.when(data);
		}

		function risorsaAzione_getAll(pageSize, page, testuale, risorsaId, cpiId, profiloANPALId, rinunciaCPIId, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof risorsaId == 'undefined') { risorsaId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof profiloANPALId == 'undefined') { profiloANPALId = 0; }
			if (typeof rinunciaCPIId == 'undefined') { rinunciaCPIId = 0; }
			if (typeof order == 'undefined') { order = 'alfabetico'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'profiloANPALId', value: profiloANPALId });
			params.push({ name: 'rinunciaCPIId', value: rinunciaCPIId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('risorsaAzione', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function risorsaAzione_countAll(testuale, risorsaId, cpiId, profiloANPALId, rinunciaCPIId) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof risorsaId == 'undefined') { risorsaId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof profiloANPALId == 'undefined') { profiloANPALId = 0; }
			if (typeof rinunciaCPIId == 'undefined') { rinunciaCPIId = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'profiloANPALId', value: profiloANPALId });
			params.push({ name: 'rinunciaCPIId', value: rinunciaCPIId });

			var data = getAllByParams('risorsaAzione', 'CountByFilter', params);
			return $q.when(data);
		}

		function risorsaAzione_get(id) {
			var data = getById('risorsaAzione', id);
			return $q.when(data);
		}

		function risorsaAzione_add(item) {
			var data = addObj('risorsaAzione', item);
			return $q.when(data);
		}

		function risorsaAzione_update(item) {
			var data = updateObj('risorsaAzione', item);
			return $q.when(data);
		}

		function risorsaAzione_delete(id) {
			var data = deleteObj('risorsaAzione', id);
			return $q.when(data);
		}

		function risorsaAzione_unlock(item) {
			var objName = 'risorsaAzione';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		// ******************************
		//  DDPROFILING
		function ddProfiling_getAllList(nominativo, destinatarioId, dtProfiling, iStato) {
			if (typeof (nominativo) == 'undefined') { nominativo = ''; }
			if (typeof (destinatarioId) == 'undefined') { destinatarioId = 0; }
			if (typeof (dtProfiling) == 'undefined') { dtProfiling = ''; }
			if (typeof (iStato) == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'dtProfiling', value: dtProfiling });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('ddProfiling', 'getAllList', params);
			return $q.when(data);
		}

		function ddProfiling_getAll(pageSize, page, nominativo, destinatarioId, dtProfiling, iStato, order) {
			if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
			if (typeof (page) == 'undefined') { page = 1; }
			if (typeof (nominativo) == 'undefined') { nominativo = ''; }
			if (typeof (destinatarioId) == 'undefined') { destinatarioId = 0; }
			if (typeof (dtProfiling) == 'undefined') { dtProfiling = ''; }
			if (typeof (iStato) == 'undefined') { iStato = 0; }
			if (typeof (order) == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'dtProfiling', value: dtProfiling });
			params.push({ name: 'iStato', value: iStato });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('ddProfiling', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function ddProfiling_countAll(nominativo, destinatarioId, dtProfiling, iStato) {
			if (typeof (nominativo) == 'undefined') { nominativo = ''; }
			if (typeof (destinatarioId) == 'undefined') { destinatarioId = 0; }
			if (typeof (dtProfiling) == 'undefined') { dtProfiling = ''; }
			if (typeof (iStato) == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'dtProfiling', value: dtProfiling });
			params.push({ name: 'iStato', value: iStato });


			var data = getAllByParams('ddProfiling', 'CountByFilter', params);
			return $q.when(data);
		}

		function ddProfiling_getAllByDestinatario(destinatarioId) {
			if (typeof (destinatarioId) == 'undefined') { destinatarioId = 0; }

			var params = [];
			params.push({ name: 'pageSize', value: 0 });
			params.push({ name: 'page', value: 0 });
			params.push({ name: 'nominativo', value: '' });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'dtProfiling', value: '' });
			params.push({ name: 'iStato', value: 0 });
			params.push({ name: 'order', value: 'DataProfiling' });

			var data = getAllByParams('ddProfiling', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function ddProfiling_get(id) {
			var data = getById('ddProfiling', id);
			return $q.when(data);
		}

		function ddProfiling_add(item) {
			var data = addObj('ddProfiling', item);
			return $q.when(data);
		}

		function ddProfiling_update(item) {
			var data = updateObj('ddProfiling', item);
			return $q.when(data);
		}

		function ddProfiling_delete(id) {
			console.log("deleteddProfiling(%s)", id);

			var data = deleteObj('ddProfiling', id);
			return $q.when(data);
		}

		function ddProfiling_unlock(item) {
			var objName = 'ddProfiling';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function ddProfiling_print(ddProfilingId) {
			if (typeof ddProfilingId == 'undefined') { ddProfilingId = 0; }

			var params = [];
			params.push({ name: 'ddProfilingId', value: ddProfilingId });

			var data = getAllByParams('PDF', 'PrintProfilingAll8', params);
			return $q.when(data);
		}

		// *********************************
		// VISITA ISPETTIVA
		function visitaIspettiva_getList(testuale, tSourceId, sourceId, cpiId, iStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('visitaIspettiva', 'GetAllList', params);
			return $q.when(data);
		}

		function visitaIspettiva_getAll(pageSize, page, testuale, tSourceId, sourceId, cpiId, iStato, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }
			if (typeof order == 'undefined') { order = 'source'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'iStato', value: iStato });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('visitaIspettiva', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function visitaIspettiva_countAll(testuale, tSourceId, sourceId, cpiId, iStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('visitaIspettiva', 'CountByFilter', params);
			return $q.when(data);
		}

		function visitaIspettiva_get(id) {
			var data = getById('visitaIspettiva', id);
			return $q.when(data);
		}

		function visitaIspettiva_add(item) {
			var data = addObj('visitaIspettiva', item);
			return $q.when(data);
		}

		function visitaIspettiva_update(item) {
			var data = updateObj('visitaIspettiva', item);
			return $q.when(data);
		}

		function visitaIspettiva_delete(id) {
			var data = deleteObj('visitaIspettiva', id);
			return $q.when(data);
		}

		function visitaIspettiva_unlock(item) {
			var objName = 'visitaIspettiva';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}


		// *********************************
		// CHECKLIST
		function checklist_setParams(pageSize, page, testuale, tSourceId, sourceId, cpiId, iStato, order, isGet) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
				if (typeof page == 'undefined') { page = 1; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}			
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'iStato', value: iStato });			

			return params;
		}

		function checklist_getList(testuale, tSourceId, sourceId, cpiId, iStato) {
			var params = checklist_setParams(0, 0, testuale, tSourceId, sourceId, cpiId, iStato, '', false);
			var data = getAllByParams('checklist', 'GetAllList', params);
			return $q.when(data);
		}

		function checklist_getAll(pageSize, page, testuale, tSourceId, sourceId, cpiId, iStato, order) {
			var params = checklist_setParams(pageSize, page, testuale, tSourceId, sourceId, cpiId, iStato, order, true);
			var data = getAllByParams('checklist', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function checklist_countAll(testuale, tSourceId, sourceId, cpiId, iStato) {
			var params = checklist_setParams(0, 0, testuale, tSourceId, sourceId, cpiId, iStato, '', false);
			var data = getAllByParams('checklist', 'CountByFilter', params);
			return $q.when(data);
		}

		function checklist_get(id) {
			var data = getById('checklist', id);
			return $q.when(data);
		}

		function checklist_add(item) {
			var data = addObj('checklist', item);
			return $q.when(data);
		}

		function checklist_update(item) {
			var data = updateObj('checklist', item);
			return $q.when(data);
		}

		function checklist_delete(id) {
			var data = deleteObj('checklist', id);
			return $q.when(data);
		}

		function checklist_unlock(item) {
			var objName = 'checklist';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed checklist_unlock for %s: %s', objName, message);
					return message.status;
				});
		}

		function checklist_unlockSent(item) {
			var objName = 'checklist';

			return $http.put(urlAPI + '/' + objName + '/UnlockSent', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed checklist_unlockSent for %s: %s', objName, message);
					return message.status;
				});
		}

		function checklist_isValidHelper(item) {
			var objName = 'checklist';

			return $http.put(urlAPI + '/' + objName + '/IsValidHelper', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed isValidObj for %s: %s', objName, message);
					return message.status;
				});
		}

		// *********************************
		// ORIENTAMENTO
		function orientamento_getList(testuale, destinatarioId, omlsId, cpiId, data, stato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }
			if (typeof omlsId == 'undefined') { omlsId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof data == 'undefined') { data = ''; }
			if (typeof stato == 'undefined') { stato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'omlsId', value: omlsId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'data', value: data });
			params.push({ name: 'stato', value: stato });

			var data1 = getAllByParams('orientamento', 'GetAllList', params);
			return $q.when(data1);
		}

		function orientamento_getAll(pageSize, page, testuale, destinatarioId, omlsId, cpiId, data, stato, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }
			if (typeof omlsId == 'undefined') { omlsId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof data == 'undefined') { data = ''; }
			if (typeof stato == 'undefined') { stato = 0; }
			if (typeof order == 'undefined') { order = 'destinatario'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'omlsId', value: omlsId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'data', value: data });
			params.push({ name: 'stato', value: stato });
			params.push({ name: 'order', value: order });

			var data1 = getAllByParams('orientamento', 'GetAllByFilter', params);
			return $q.when(data1);
		}

		function orientamento_countAll(testuale, destinatarioId, omlsId, cpiId, data, stato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }
			if (typeof omlsId == 'undefined') { omlsId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof data == 'undefined') { data = null; }
			if (typeof stato == 'undefined') { stato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'omlsId', value: omlsId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'data', value: data });
			params.push({ name: 'stato', value: stato });

			var data1 = getAllByParams('orientamento', 'CountByFilter', params);
			return $q.when(data1);
		}

		function orientamento_get(id) {
			var data = getById('orientamento', id);
			return $q.when(data);
		}

		function orientamento_add(item) {
			var data = addObj('orientamento', item);
			return $q.when(data);
		}

		function orientamento_update(item) {
			var data = updateObj('orientamento', item);
			return $q.when(data);
		}

		function orientamento_delete(id) {
			var data = deleteObj('orientamento', id);
			return $q.when(data);
		}

		function orientamento_unlock(item) {
			var objName = 'orientamento';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		//--PROFILO ANPAL
		function profiloANPAL_getAll() {
			var params = [];
			var data = getAllNoParam('ProfiloANPAL', 'GetAll');
			return $q.when(data);
		}


		//--PROFILO DOCENTE
		function profiloDocente_getAll() {
			var params = [];
			var data = getAllNoParam('ProfiloDocente', 'GetAll');
			return $q.when(data);
		}



		// ******************************
		//  SEDE
		function sede_getAllList() {
			var data = getAllList('sede');
			return $q.when(data);
		}

		function sede_getAll(pageSize, page, nome, provinciaId) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'provinciaId', value: provinciaId });

			var data = getAllByParams('sede', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function sede_countAll(nome, provinciaId) {
			var params = [];
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'provinciaId', value: provinciaId });

			var data = getAllByParams('sede', 'CountByFilter', params);
			return $q.when(data);
		}

		function sede_get(id) {
			var data = getById('sede', id);
			return $q.when(data);
		}

		function sede_getBase(id) {
			var data = getBaseById('sede', id);
			return $q.when(data);
		}

		function sede_add(item) {
			var data = addObj('sede', item);
			return $q.when(data);
		}

		function sede_update(item) {
			var data = updateObj('sede', item);
			return $q.when(data);
		}

		function sede_delete(id) {
			console.log("deleteSede(%s)", id);

			var data = deleteObj('sede', id);
			return $q.when(data);
		}

		// ******************************
		//  SIGNATURE
		function signature_getAllList() {
			var data = getAllList('signature');
			return $q.when(data);
		}

		function signature_getAll(pageSize, page, nome, cognome, dtAcq, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof cognome == 'undefined') { cognome = ''; }
			if (typeof dtAcq == 'undefined') { dtAcq = ''; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'cognome', value: cognome });
			params.push({ name: 'dtAcq', value: dtAcq });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('signature', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function signature_countAll(nome, cognome, dtAcq) {
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof cognome == 'undefined') { cognome = ''; }
			if (typeof dtAcq == 'undefined') { dtAcq = ''; }
			var params = [];
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'cognome', value: cognome });
			params.push({ name: 'dtAcq', value: dtAcq });

			var data = getAllByParams('signature', 'CountByFilter', params);
			return $q.when(data);
		}

		function signature_upload(filename, file) {
			var objName = 'signature';
			var method = 'Upload';

			if (typeof filename == 'undefined') { filename = ''; }
			if (typeof file == 'undefined') { file = {}; }

			var url = urlAPI + '/' + objName + '/' + method;

			var item = {};
			item.filename = filename;
			item.file = file;


			return $http.post(url, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed signature_upload for %s: %s', objName, message);
					return message.status;
				});

		}

		function signature_get(id) {
			var data = getById('signature', id);
			return $q.when(data);
		}

		function signature_add(item) {
			var data = addObj('signature', item);
			return $q.when(data);
		}

		function signature_update(item) {
			var data = updateObj('signature', item);
			return $q.when(data);
		}

		function signature_delete(id) {
			console.log("deleteSede(%s)", id);

			var data = deleteObj('signature', id);
			return $q.when(data);
		}


		// ******************************
		//  STUDENTE
		function studente_getAllList() {
			var data = getAllList('studente');
			return $q.when(data);
		}

		function studente_getAll(pageSize, page, isWhole, nominativo, classeId, aziendaId, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof isWhole == 'undefined') { isWhole = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'isWhole', value: isWhole });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('studente', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function studente_countAll(isWhole, nominativo, classeId, aziendaId) {
			if (typeof isWhole == 'undefined') { isWhole = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			var params = [];
			params.push({ name: 'isWhole', value: isWhole });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'aziendaId', value: aziendaId });

			var data = getAllByParams('studente', 'CountByFilter', params);
			return $q.when(data);
		}

		function studente_getAllByUsername(pageSize, page, isWhole, nominativo, classeId, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof isWhole == 'undefined') { isWhole = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'isWhole', value: isWhole });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'aziendaId', value: 0 });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('studente', 'GetAllByUsername', params);
			return $q.when(data);

		}

		function studente_countAllByUsername(isWhole, nominativo, classeId) {
			if (typeof isWhole == 'undefined') { isWhole = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof classeId == 'undefined') { classeId = 0; }
			var params = [];
			params.push({ name: 'isWhole', value: isWhole });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'aziendaId', value: 0 });

			var data = getAllByParams('studente', 'CountByUsername', params);
			return $q.when(data);
		}

		function studente_existsCF(studenteId, codiceFiscale) {
			if (typeof studenteId == 'undefined') { studenteId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			var params = [];
			params.push({ name: 'studenteId', value: studenteId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });

			var data = getAllByParams('studente', 'ExistsCF', params);
			return $q.when(data);
		}

		function studente_getAllByClasse(id) {
			var data = getAllByParam('studente', 'GetAllByClasse', 'id', id);
			return $q.when(data);
		}

		function studente_getAllByClasse_Data(id, dt) {
			if (typeof id == 'undefined') { id = 0; }
			if (typeof dt == 'undefined') { dt = ''; }
			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'dt', value: dt });

			var data = getAllByParams('studente', 'GetAllByClasse_Data', params);
			//var data = getAllByParams('studente', 'GetAllByClasse', 'id', id);
			return $q.when(data);
		}

		function studente_getListNotInClasse(classeId, notClasseId) {
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof notClasseId == 'undefined') { notClasseId = false; }
			var params = [];

			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'notClasseId', value: notClasseId });

			var data = getAllByParams('studente', 'GetListNotInClasse', params);
			return $q.when(data);
		}

		function studente_get(id) {
			var data = getById('studente', id);
			return $q.when(data);
		}

		function studente_add(item) {
			var data = addObj('studente', item);
			return $q.when(data);
		}

		function studente_update(item) {
			var data = updateObj('studente', item);
			return $q.when(data);
		}

		function studente_delete(id) {
			var data = deleteObj('studente', id);
			return $q.when(data);
		}


		// ******************************
		//  DOCENTE
		function docente_getAllList() {
			return risorsa_getAllList('', 4, 0, 0, '', 0, 0, 0, 0, '', 0, 0);
		}

		function docente_getAll(pageSize, page, nominativo, classeId, aziendaId, order) {
			return risorsa_getAll(pageSize, page, nominativo, 4, classeId, aziendaId, '', 0, 0, 0, 0, '', 0, 0, order);
		}

		function docente_countAll(nominativo, classeId, aziendaId) {
			return risorsa_countAll(nominativo, 0, classeId, aziendaId, '', 0, 0, 0, 0, '', 0, 0);
		}

		function docente_existsCF(docenteId, codiceFiscale) {
			return risorsa_existsCF(docenteId, codiceFiscale);
		}

		function docente_getAllByClasse(id) {
			var data = getAllByParam('risorsa', 'GetAllByClasse', 'id', id);
			return $q.when(data);
		}



		function docente_get(id) {
			var data = getById('risorsa', id);
			return $q.when(data);
		}

		function docente_add(item) {
			var data = addObj('risorsa', item);
			return $q.when(data);
		}

		function docente_update(item) {
			var data = updateObj('risorsa', item);
			return $q.when(data);
		}

		function docente_delete(id) {
			var data = deleteObj('risorsa', id);
			return $q.when(data);
		}

		// ******************************
		//  AZIENDA
		function azienda_getAllList(testuale, ruoloSoggettoId, tAtecoId, tFormaGiuridicaId, iAPL, iCPI, parentId, iStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }
			if (typeof tAtecoId == 'undefined') { tAtecoId = 0; }
			if (typeof tFormaGiuridicaId == 'undefined') { tFormaGiuridicaId = 0; }
			if (typeof iAPL == 'undefined') { iAPL = -1; }
			if (typeof iCPI == 'undefined') { iCPI = -1; }
			if (typeof parentId == 'undefined') { parentId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });
			params.push({ name: 'tAtecoId', value: tAtecoId });
			params.push({ name: 'tFormaGiuridicaId', value: tFormaGiuridicaId });
			params.push({ name: 'iAPL', value: iAPL });
			params.push({ name: 'iCPI', value: iCPI });
			params.push({ name: 'parentId', value: parentId });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('azienda', 'GetAllList', params);
			return $q.when(data);
		}



		function azienda_getAll(pageSize, page, testuale, ruoloSoggettoId, tAtecoId, tFormaGiuridicaId, iAPL, iCPI, parentId, iStato, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof order == 'undefined') { order = ''; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }
			if (typeof tAtecoId == 'undefined') { tAtecoId = 0; }
			if (typeof tFormaGiuridicaId == 'undefined') { tFormaGiuridicaId = 0; }
			if (typeof iAPL == 'undefined') { iAPL = -1; }
			if (typeof iCPI == 'undefined') { iCPI = -1; }
			if (typeof parentId == 'undefined') { parentId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'order', value: order });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });
			params.push({ name: 'tAtecoId', value: tAtecoId });
			params.push({ name: 'tFormaGiuridicaId', value: tFormaGiuridicaId });
			params.push({ name: 'iAPL', value: iAPL });
			params.push({ name: 'iCPI', value: iCPI });
			params.push({ name: 'parentId', value: parentId });
			params.push({ name: 'iStato', value: iStato });


			var data = getAllByParams('azienda', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function azienda_countAll(testuale, ruoloSoggettoId, tAtecoId, tFormaGiuridicaId, iAPL, iCPI, parentId, iStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }
			if (typeof tAtecoId == 'undefined') { tAtecoId = 0; }
			if (typeof tFormaGiuridicaId == 'undefined') { tFormaGiuridicaId = 0; }
			if (typeof iAPL == 'undefined') { iAPL = -1; }
			if (typeof iCPI == 'undefined') { iCPI = -1; }
			if (typeof parentId == 'undefined') { parentId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }


			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });
			params.push({ name: 'tAtecoId', value: tAtecoId });
			params.push({ name: 'tFormaGiuridicaId', value: tFormaGiuridicaId });
			params.push({ name: 'iAPL', value: iAPL });
			params.push({ name: 'iCPI', value: iCPI });
			params.push({ name: 'parentId', value: parentId });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('azienda', 'CountByFilter', params);
			return $q.when(data);
		}

        /*
        function azienda_getAllMemberDidList(gruppoDidId) {
            var params = [];
            params.push({ name: 'ruoloSoggettoId', value: 0 });
            params.push({ name: 'nome', value: '' });
            params.push({ name: 'filterMemberDid', value: 0 }); //filtro: solo soggetti che appartengono gi� al gruppo
            params.push({ name: 'gruppoDidId', value: gruppoDidId });
            params.push({ name: 'bAPL', value: -1 });
            params.push({ name: 'bCPI', value: -1 });
            params.push({ name: 'bSuspended', value: -1 });

            var data = getAllByParams('azienda', 'GetAllListByFilter', params);

            return $q.when(data);
        }
   
        function azienda_getAllNoMemberDidList(gruppoDidId) {
            var params = [];
            params.push({ name: 'ruoloSoggettoId', value: 0 });
            params.push({ name: 'nome', value: '' });
            params.push({ name: 'filterMemberDid', value: 1 }); //filtro: solo soggetti che appartengono gi� al gruppo
            params.push({ name: 'gruppoDidId', value: gruppoDidId });
            params.push({ name: 'bAPL', value: -1 });
            params.push({ name: 'bCPI', value: -1 });
            params.push({ name: 'bSuspended', value: -1 });

            var data = getAllByParams('azienda', 'GetAllListByFilter', params);

            return $q.when(data);
        }
		function azienda_countAllMemberDidList(ruoloSoggettoId, gruppoDidId) {
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }
			if (typeof gruppoDidId == 'undefined') { gruppoDidId = 0; }
			var params = [];
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });
			params.push({ name: 'filterMemberDid', value: 0 }); //filtro: solo soggetti che appartengono gi� al gruppo
			params.push({ name: 'gruppoDidId', value: gruppoDidId });
			params.push({ name: 'bSuspended', value: -1 });

			var data = getAllByParams('azienda', 'CountByFilter', params);

			return $q.when(data);
		}

		function azienda_countAllNoMemberDidList(ruoloSoggettoId, gruppoDidId) {
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }
			if (typeof gruppoDidId == 'undefined') { gruppoDidId = 0; }
			var params = [];
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });
			params.push({ name: 'filterMemberDid', value: 1 }); //filtro: solo soggetti che non appartengono gi� al gruppo
			params.push({ name: 'gruppoDidId', value: gruppoDidId });
			params.push({ name: 'bSuspended', value: -1 });

			var data = getAllByParams('azienda', 'CountByFilter', params);

			return $q.when(data);
		}
        */

		function azienda_exists(aziendaId, ruoloSoggettoId, codiceFiscale, piva, ipa) {
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof piva == 'undefined') { piva = ''; }
			if (typeof ipa == 'undefined') { ipa = ''; }
			var params = [];
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'piva', value: piva });
			params.push({ name: 'ipa', value: ipa });

			var data = getAllByParams('azienda', 'Exists', params);
			return $q.when(data);
		}

		function azienda_getByUsername() {
			var data = getAllNoParam('azienda', 'GetByUsername');
			return $q.when(data);
		}

		function azienda_get(id) {
			var data = getById('azienda', id);
			return $q.when(data);
		}

		function azienda_add(item) {
			var data = addObj('azienda', item);
			return $q.when(data);
		}

		function azienda_update(item) {
			var data = updateObj('azienda', item);
			return $q.when(data);
		}

		function azienda_delete(id) {
			var data = deleteObj('azienda', id);
			return $q.when(data);
		}

		function azienda_printAll3Bis(aziendaId) {
			var params = [];
			//params.push({ name: 'progettoUId', value: progettoUId });
			params.push({ name: 'aziendaId', value: aziendaId });
			var data = getAllByParams('PDF', 'StampaAll3Bis', params);
			return $q.when(data);
		}

		// ******************************
		//  PDF
		function pdf_checklist(checklistId) {
			var params = [];
			params.push({ name: 'checklistId', value: checklistId });

			var data = getAllByParams('pdf', 'Checklist_GetAttach', params);
			return $q.when(data);
		}


		// ******************************
		//  AZIENDA SEDI-
		function aziendaSede_setParams(pageSize, page, testuale, aziendaId, provinciaId, comuneId, iStato, order, isGet) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
				if (typeof page == 'undefined') { page = 1; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'comuneId', value: comuneId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function aziendaSede_getAllList(testuale, aziendaId, provinciaId, comuneId, iStato) {
			var params = aziendaSede_setParams(0, 0, testuale, aziendaId, provinciaId, comuneId, iStato, '', false);

			var data = getAllByParams('aziendaSede', 'GetAllList', params);
			return $q.when(data);
		}

		function aziendaSede_getAll(pageSize, page, testuale, aziendaId, provinciaId, comuneId, iStato, order) {
			var params = aziendaSede_setParams(pageSize, page, testuale, aziendaId, provinciaId, comuneId, iStato, order, true);

			var data = getAllByParams('aziendaSede', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function aziendaSede_countAll(testuale, aziendaId, provinciaId, comuneId, iStato) {
			var params = aziendaSede_setParams(0, 0, testuale, aziendaId, provinciaId, comuneId, iStato, '', false);

			var data = getAllByParams('aziendaSede', 'CountByFilter', params);
			return $q.when(data);
		}

		function aziendaSede_get(id) {
			var data = getById('aziendaSede', id);
			return $q.when(data);
		}

		function aziendaSede_add(item) {
			var data = addObj('aziendaSede', item);
			return $q.when(data);
		}

		function aziendaSede_update(item) {
			var data = updateObj('aziendaSede', item);
			return $q.when(data);
		}

		function aziendaSede_delete(id) {
			var data = deleteObj('aziendaSede', id);
			return $q.when(data);
		}

		function aziendaSede_unlock(item) {
			var objName = 'aziendaSede';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed aziendaSede_unlock for %s: %s', objName, message);
					return message.status;
				});
		}

        // *********************************
        // ISSUE-LOG
        function issueLog_getAll(pageSize, page, testuale, tSourceId, sourceId, tDestId, destId, parentId, iState, iRole, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (testuale) == 'undefined') { testuale = ''; }
            if (typeof (tSourceId) == 'undefined') { tSourceId = 0; }
            if (typeof (sourceId) == 'undefined') { sourceId = 0; }
            if (typeof (tDestId) == 'undefined') { tDestId = 0; }
            if (typeof (destId) == 'undefined') { destId = 0; }
            if (typeof (parentId) == 'undefined') { parentId = 0; }
            if (typeof (iState) == 'undefined') { iState = -2; }
            if (typeof (iRole) == 'undefined') { iRole = 0; }

            if (typeof (order) == 'undefined') { order = 'data'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'testuale', value: testuale });
            params.push({ name: 'tSourceId', value: tSourceId });
            params.push({ name: 'sourceId', value: sourceId });
            params.push({ name: 'tDestId', value: tDestId });
            params.push({ name: 'destId', value: destId });
            params.push({ name: 'parentId', value: parentId });
            params.push({ name: 'iState', value: iState });
            params.push({ name: 'iRole', value: iRole });

            params.push({ name: 'order', value: order });

            var data = getAllByParams('IssueLog', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function issueLog_countAll(testuale, tSourceId, sourceId, tDestId, destId, parentId, iState, iRole) {
            if (typeof (testuale) == 'undefined') { testuale = ''; }
            if (typeof (tSourceId) == 'undefined') { tSourceId = 0; }
            if (typeof (sourceId) == 'undefined') { sourceId = 0; }
            if (typeof (tDestId) == 'undefined') { tDestId = 0; }
            if (typeof (destId) == 'undefined') { destId = 0; }
            if (typeof (parentId) == 'undefined') { parentId = 0; }
            if (typeof (iState) == 'undefined') { iState = -2; }
            if (typeof (iRole) == 'undefined') { iRole = 0; }

            var params = [];
            params.push({ name: 'testuale', value: testuale });
            params.push({ name: 'tSourceId', value: tSourceId });
            params.push({ name: 'sourceId', value: sourceId });
            params.push({ name: 'tDestId', value: tDestId });
            params.push({ name: 'destId', value: destId });
            params.push({ name: 'parentId', value: parentId });
            params.push({ name: 'iState', value: iState });
            params.push({ name: 'iRole', value: iRole });

            var data = getAllByParams('IssueLog', 'CountByFilter', params);
            return $q.when(data);
        }

        function issueLog_get(id) {
            var data = getById('IssueLog', id);
            return $q.when(data);
        }

        function issueLog_add(item) {
            var data = addObj('IssueLog', item);
            return $q.when(data);
        }

        function issueLog_update(item) {
            var data = updateObj('IssueLog', item);
            return $q.when(data);
        }

        function issueLog_delete(id) {
            var data = deleteObj('IssueLog', id);
            return $q.when(data);
        }

        function issueLog_setState(id, iState) {
            /*
                        var item = {};
                        item.Id = id;
                        item.iState = iState;
            
                        var objName = 'issueLog';
            
                        return $http.put(urlAPI + '/' + objName + '/SetState', item)
                            .then(function (response) {
                                return response.status;
                            })
                            .catch(function (message) {
                                console.log('XHR Failed att_SetCompleted for %s: %s', objName, message);
                                return message.status;
                            });
                            */

            if (typeof (id) == 'undefined') { id = 0; }
            if (typeof (iState) == 'undefined') { iState = -1; }

            var params = [];
            params.push({ name: 'id', value: id });
            params.push({ name: 'iState', value: iState });

            var data = getAllByParams('IssueLog', 'SetState', params);
            return $q.when(data);
        }

		// ******************************
		//  TIROCINANTE
		function tirocinante_getAllList(nominativo, aziendaId, ruoloSoggettoId, nascProvId, cpiId) {
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }
			if (typeof nascProvId == 'undefined') { nascProvId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }

			var params = [];
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });
			params.push({ name: 'nascProvId', value: nascProvId });
			params.push({ name: 'cpiId', value: cpiId });

			var data = getAllByParams('tirocinante', 'getAllList', params);
			return $q.when(data);
		}

		function tirocinante_getAll(pageSize, page, bCompleted, bSent, isWhole, nominativo, aziendaId, ruoloSoggettoId, nascProvId, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof bCompleted == 'undefined') { bCompleted = 0; }
			if (typeof bSent == 'undefined') { bSent = 0; }
			if (typeof isWhole == 'undefined') { isWhole = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }
			if (typeof nascProvId == 'undefined') { nascProvId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'bCompleted', value: bCompleted });
			params.push({ name: 'bSent', value: bSent });
			params.push({ name: 'isWhole', value: isWhole });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });
			params.push({ name: 'nascProvId', value: nascProvId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('tirocinante', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function tirocinante_countAll(bCompleted, bSent, isWhole, nominativo, aziendaId, ruoloSoggettoId, nascProvId) {
			if (typeof bCompleted == 'undefined') { bCompleted = 0; }
			if (typeof bSent == 'undefined') { bSent = 0; }
			if (typeof isWhole == 'undefined') { isWhole = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }
			if (typeof nascProvId == 'undefined') { nascProvId = 0; }

			var params = [];
			params.push({ name: 'bCompleted', value: bCompleted });
			params.push({ name: 'bSent', value: bSent });
			params.push({ name: 'isWhole', value: isWhole });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });
			params.push({ name: 'nascProvId', value: nascProvId });


			var data = getAllByParams('tirocinante', 'CountByFilter', params);
			return $q.when(data);
		}
		/*
		function tirocinante_getAllByUsername(pageSize, page, nominativo, aziendaId, ruoloSoggettoId, nascProvId, cpiId, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }
			if (typeof nascProvId == 'undefined') { nascProvId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });
			params.push({ name: 'nascProvId', value: nascProvId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('tirocinante', 'GetAllByUsername', params);
			return $q.when(data);
		}

		function tirocinante_countAllByUsername(nominativo, aziendaId, ruoloSoggettoId, nascProvId, cpiId) {
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }
			if (typeof nascProvId == 'undefined') { nascProvId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }

			var params = [];
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });
			params.push({ name: 'nascProvId', value: nascProvId });
			params.push({ name: 'cpiId', value: cpiId });

			var data = getAllByParams('tirocinante', 'CountByUsername', params);
			return $q.when(data);
		}
		*/

		function tirocinante_existsCF(tirocinanteId, codiceFiscale) {
			if (typeof tirocinanteId == 'undefined') { tirocinanteId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			var params = [];
			params.push({ name: 'tirocinanteId', value: tirocinanteId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });

			var data = getAllByParams('tirocinante', 'ExistsCF', params);
			return $q.when(data);
		}

		function tirocinante_statusCF(codiceFiscale, aziendaId) {
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			var params = [];
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'aziendaId', value: aziendaId });

			var data = getAllByParams('tirocinante', 'StatusCF', params);
			return $q.when(data);
		}

		function tirocinante_assign(codiceFiscale, aziendaId) {

			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			var params = [];
			params.push({ name: 'CodiceFiscale', value: codiceFiscale });
			params.push({ name: 'aziendaId', value: aziendaId });

			var item = {};
			item.codiceFiscale = codiceFiscale;
			item.AziendaId = aziendaId;

			var data = putMethod('tirocinante', 'Assign', item);
			return $q.when(data);
		}

		function tirocinante_getAllByAzienda(id) {
			var data = getAllByParam('tirocinante', 'GetAllByAzienda', 'id', id);
			return $q.when(data);
		}

		function tirocinante_getAllByAzienda_Data(id, dt) {
			if (typeof id == 'undefined') {
				id = 0;
			}
			if (typeof dt == 'undefined') { dt = ''; }
			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'dt', value: dt });

			var data = getAllByParams('tirocinante', 'GetAllByAzienda_Data', params);
			//var data = getAllByParams('tirocinante', 'GetAllByAzienda', 'id', id);
			return $q.when(data);
		}

		function tirocinante_get(id) {
			var data = getById('tirocinante', id);
			return $q.when(data);
		}

		function tirocinante_add(item) {
			var data = addObj('tirocinante', item);
			return $q.when(data);
		}

		function tirocinante_update(item) {
			var data = updateObj('tirocinante', item);
			return $q.when(data);
		}

		function tirocinante_delete(id) {
			console.log("deletetirocinante(%s)", id);

			var data = deleteObj('tirocinante', id);
			return $q.when(data);
		}


		// ******************************
		//  TIROCINIO
		function tirocinio_setParams(pageSize, page, order, testuale, aziendaId, tirocinanteId, cpiId, dtInsert, misura, iStato, isGet) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
				if (typeof page == 'undefined') { page = 1; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof tirocinanteId == 'undefined') { tirocinanteId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof dtInsert == 'undefined') { dtInsert = ''; }
			if (typeof misura == 'undefined') { misura = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'tirocinanteId', value: tirocinanteId });
			params.push({ name: 'ruoloSoggettoId', value: 0 });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'dtInsert', value: dtInsert });
			params.push({ name: 'misura', value: misura });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}		
		function tirocinio_getAllList(testuale, aziendaId, tirocinanteId, cpiId, dtInsert, misura, iStato) {
			var params = tirocinio_setParams(0, 0, '', testuale, aziendaId, tirocinanteId, cpiId, dtInsert, misura, iStato, false);
			var data = getAllByParams('tirocinio', 'GetAllList', params);
			return $q.when(data);
		}
		function tirocinio_getAllListByText(testuale, aziendaId, tirocinanteId, cpiId, dtInsert, misura, iStato) {
			var params = tirocinio_setParams(0, 0, '', testuale, aziendaId, tirocinanteId, cpiId, dtInsert, misura, iStato, false);
			var data = getAllByParams('tirocinio', 'GetAllListByText', params);
			return $q.when(data);
		}
		function tirocinio_getAll(pageSize, page, testuale, aziendaId, tirocinanteId, cpiId, dtInsert, misura, iStato, order) {
			var params = tirocinio_setParams(pageSize, page, order, testuale, aziendaId, tirocinanteId, cpiId, dtInsert, misura, iStato, true);
			var data = getAllByParams('tirocinio', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function tirocinio_countAll(testuale, aziendaId, tirocinanteId, cpiId, dtInsert, misura, iStato) {
			var params = tirocinio_setParams(0, 0, '', testuale, aziendaId, tirocinanteId, cpiId, dtInsert, misura, iStato, false);
			var data = getAllByParams('tirocinio', 'CountByFilter', params);
			return $q.when(data);
		}

		function tirocinio_getByTirocinante(tirocinanteId) {
			if (typeof tirocinanteId == 'undefined') { tirocinanteId = 0; }
			var data = getAllByParam('tirocinio', 'GetByTirocinante', 'tirocinanteId', tirocinanteId);
			return $q.when(data);
		}
		function tirocinio_getAllByAzienda(aziendaId) {
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			var data = getAllByParam('tirocinio', 'GetAllByAzienda', 'aziendaId', aziendaId);
			return $q.when(data);
		}

		function tirocinio_existsTir(tirocinioId, tirocinanteId) {
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof tirocinanteId == 'undefined') { tirocinanteId = 0; }

			var params = [];
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'tirocinanteId', value: tirocinanteId });

			var data = getAllByParams('tirocinio', 'ExistsTir', params);
			return $q.when(data);
		}

		function tirocinio_get(id) {
			var data = getById('tirocinio', id);
			return $q.when(data);
		}

		function tirocinio_add(item) {
			var data = addObj('tirocinio', item);
			return $q.when(data);
		}

		function tirocinio_update(item) {
			var data = updateObj('tirocinio', item);
			return $q.when(data);
		}

		function tirocinio_delete(id) {
			console.log("deletetirocinio(%s)", id);

			var data = deleteObj('tirocinio', id);
			return $q.when(data);
		}

		function tirocinio_unlock(item) {
			var objName = 'tirocinio';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirocinio_setChecked(item) {
			var objName = 'tirocinio';

			return $http.put(urlAPI + '/' + objName + '/SetChecked', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirocinio_setUnchecked(item) {
			var objName = 'tirocinio';

			return $http.put(urlAPI + '/' + objName + '/SetUnchecked', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirocinio_setNoBenefit(item) {
			var objName = 'tirocinio';

			return $http.put(urlAPI + '/' + objName + '/SetNoBenefit', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed setNoBenefit for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirocinio_unsetNoBenefit(item) {
			var objName = 'tirocinio';

			return $http.put(urlAPI + '/' + objName + '/UnsetNoBenefit', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed unsetNoBenefit for %s: %s', objName, message);
					return message.status;
				});
		}


		function tirocinio_disassignRlz(item) {
			var objName = 'tirocinio';

			return $http.put(urlAPI + '/' + objName + '/DisassignRlz', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed disassignRlz for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirocinio_status(aziendaId, codiceFiscale) {
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }

			var params = [];
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });

			var data = getAllByParams('tirocinio', 'Status', params);
			return $q.when(data);
		}

		function tirocinio_assign(item) {
			var data = postMethod('tirocinio', 'Assign', item);
			return $q.when(data);
		}

		function tirocinio_reassign(destinatarioId) {
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }

			var params = [];
			params.push({ name: 'destinatarioId', value: destinatarioId });

			var data = getAllByParams('tirocinio', 'Reassign', params);
			return $q.when(data);
		}

		function tirocinio_rinuncia(tirocinioId, motivazione, yes, bClone) {
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof motivazione == 'undefined') { motivazione = ''; }
			if (typeof yes == 'undefined') { yes = true; }
			if (typeof bClone == 'undefined') { bClone = false; }

			var params = [];
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'motivazione', value: motivazione });
			params.push({ name: 'yes', value: yes });
			params.push({ name: 'bClone', value: bClone });

			var data = getAllByParams('tirocinio', 'Rinuncia', params);
			return $q.when(data);
		}		

		function tirocinio_rlzSuspended(tirocinioId, yes) {
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof yes == 'undefined') { yes = true; }

			var params = [];
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'yes', value: yes });

			var data = getAllByParams('tirocinio', 'RlzSuspended', params);
			return $q.when(data);
		}		

        function tirocinio_unsetPresaIncarico(item) {
            var objName = 'tirocinio';

            return $http.put(urlAPI + '/' + objName + '/RemovePresaIncarico', item)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.info('XHR Failed unlockObj for %s: %s', objName, message);
                    return message.status;
                });
        }

        function tirocinio_unsetPresaIncaricoCPI(item) {
            var objName = 'tirocinio';

            return $http.put(urlAPI + '/' + objName + '/RemovePresaIncaricoCPI', item)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.info('XHR Failed unlockObj for %s: %s', objName, message);
                    return message.status;
                });
        }


		// ******************************
		// TIROCINIO LOG

		function tirLog_setParams(pageSize, page, testuale, tirocinanteId, aziendaId, cpiId, dt, iStato, order, bGet) {
			if (bGet) {
				if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
				if (typeof page == 'undefined') { page = 1; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tirocinanteId == 'undefined') { tirocinanteId = 0; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof dt == 'undefined') { dt = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (bGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tirocinanteId', value: tirocinanteId });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'dt', value: dt });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function tirLog_getAllList(testuale, tirocinanteId, aziendaId, cpiId, dt, iStato) {
			var params = tirLog_setParams(0, 0, testuale, tirocinanteId, aziendaId, cpiId, dt, iStato, '', false);

			var data = getAllByParams('tirLog', 'GetAllList', params);
			return $q.when(data);
		}

		function tirLog_getAll(pageSize, page, testuale, tirocinanteId, aziendaId, cpiId, dt, iStato, order) {
			var params = tirLog_setParams(pageSize, page, testuale, tirocinanteId, aziendaId, cpiId, dt, iStato, order, true);

			var data = getAllByParams('tirLog', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function tirLog_countAll(testuale, tirocinanteId, aziendaId, cpiId, dt, iStato) {
			var params = tirLog_setParams(0, 0, testuale, tirocinanteId, aziendaId, cpiId, dt, iStato, '', false);

			var data = getAllByParams('tirLog', 'CountByFilter', params);
			return $q.when(data);
		}

		function tirLog_get(id) {
			var data = getById('tirLog', id);
			return $q.when(data);
		}

		function tirLog_add(item) {
			var data = addObj('tirLog', item);
			return $q.when(data);
		}

		function tirLog_update(item) {
			var data = updateObj('tirLog', item);
			return $q.when(data);
		}

		function tirLog_delete(id) {
			var data = deleteObj('tirLog', id);
			return $q.when(data);
		}



		// ******************************
		//  TIROCINI-SPESE
		function tirocinioSpesa_getAllList(bAttivo, bCompleted) {
			if (typeof bAttivo == 'undefined') { bAttivo = 0; }
			if (typeof bCompleted == 'undefined') { bCompleted = 0; }
			var params = [];
			params.push({ name: 'bAttivo', value: bAttivo });
			params.push({ name: 'bCompleted', value: bCompleted });

			var data = getAllByParams('TirocinioSpesa', 'GetAllList', params);

			return $q.when(data);
		}

		function tirocinioSpesa_getAll(pageSize, page, nominativo, tirocinioId, iProgr, tipologiaSpesaId, aziendaId, ruoloSoggettoId, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof iProgr == 'undefined') { iProgr = 0; }
			if (typeof tipologiaSpesaId == 'undefined') { tipologiaSpesaId = 0; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'iProgr', value: iProgr });
			params.push({ name: 'tipologiaSpesaId', value: tipologiaSpesaId });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('TirocinioSpesa', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function tirocinioSpesa_countAll(nominativo, tirocinioId, iProgr, tipologiaSpesaId, aziendaId, ruoloSoggettoId) {
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof iProgr == 'undefined') { iProgr = 0; }
			if (typeof tipologiaSpesaId == 'undefined') { tipologiaSpesaId = 0; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }

			var params = [];
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'iProgr', value: iProgr });
			params.push({ name: 'tipologiaSpesaId', value: tipologiaSpesaId });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });

			var data = getAllByParams('TirocinioSpesa', 'CountByFilter', params);
			return $q.when(data);
		}

		function tirocinioSpesa_get(id) {
			var data = getById('TirocinioSpesa', id);
			return $q.when(data);
		}

		function tirocinioSpesa_add(item) {
			var data = addObj('TirocinioSpesa', item);
			return $q.when(data);
		}

		function tirocinioSpesa_update(item) {
			var data = updateObj('TirocinioSpesa', item);
			return $q.when(data);
		}

		function tirocinioSpesa_delete(id) {
			var data = deleteObj('TirocinioSpesa', id);
			return $q.when(data);
		}

		// ******************************
		//  TIROCINI-PAGAMENTI
		function tirocinioPagamento_getAllList(nominativo, tirocinioId, iProgr, tipologiaSpesaId) {
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof iProgr == 'undefined') { iProgr = 0; }
			if (typeof tipologiaSpesaId == 'undefined') { tipologiaSpesaId = 0; }
			var params = [];
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'iProgr', value: iProgr });
			params.push({ name: 'tipologiaSpesaId', value: tipologiaSpesaId });

			var data = getAllByParams('tirocinioPagamento', 'GetAllList', params);

			return $q.when(data);
		}

		function tirocinioPagamento_getAll(pageSize, page, nominativo, tirocinioId, iProgr, tipologiaSpesaId, aziendaId, ruoloSoggettoId, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof iProgr == 'undefined') { iProgr = 0; }
			if (typeof tipologiaSpesaId == 'undefined') { tipologiaSpesaId = 0; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'iProgr', value: iProgr });
			params.push({ name: 'tipologiaSpesaId', value: tipologiaSpesaId });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('tirocinioPagamento', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function tirocinioPagamento_countAll(nominativo, tirocinioId, iProgr, tipologiaSpesaId, aziendaId, ruoloSoggettoId) {
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof iProgr == 'undefined') { iProgr = 0; }
			if (typeof tipologiaSpesaId == 'undefined') { tipologiaSpesaId = 0; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }

			var params = [];
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'iProgr', value: iProgr });
			params.push({ name: 'tipologiaSpesaId', value: tipologiaSpesaId });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });

			var data = getAllByParams('tirocinioPagamento', 'CountByFilter', params);
			return $q.when(data);
		}

		function tirocinioPagamento_get(id) {
			var data = getById('tirocinioPagamento', id);
			return $q.when(data);
		}

		function tirocinioPagamento_add(item) {
			var data = addObj('tirocinioPagamento', item);
			return $q.when(data);
		}

		function tirocinioPagamento_update(item) {
			var data = updateObj('tirocinioPagamento', item);
			return $q.when(data);
		}

		function tirocinioPagamento_delete(id) {
			var data = deleteObj('tirocinioPagamento', id);
			return $q.when(data);
		}

		// ******************************
		//  TIROCINIO RIMBORSO
		function tirRimborso_setParams(pageSize, page, bStato, descrizione, APLId, CPIId, tirocinioId, order, isGet) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
				if (typeof page == 'undefined') { page = 1; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof APLId == 'undefined') { APLId = 0; }
			if (typeof CPIId == 'undefined') { CPIId = 0; }
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			
			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'APLId', value: APLId });
			params.push({ name: 'CPIId', value: CPIId });
			params.push({ name: 'tirocinioId', value: tirocinioId });

			return params;
		}

		function tirRimborso_getAllList(bStato, descrizione, APLId, CPIId, tirocinioId) {
			var params = tirRimborso_setParams(0, 0, bStato, descrizione, APLId, CPIId, tirocinioId, '', false);
			var data = getAllByParams('tirRimborso', 'GetAllList', params);
			return $q.when(data);
		}
		function tirRimborso_getAll(pageSize, page, bStato, descrizione, APLId, CPIId, tirocinioId, order) {
			var params = tirRimborso_setParams(pageSize, page, bStato, descrizione, APLId, CPIId, tirocinioId, order, true);
			var data = getAllByParams('tirRimborso', 'GetAllByFilter', params);
			return $q.when(data);

		}
		function tirRimborso_countAll(bStato, descrizione, APLId, CPIId, tirocinioId) {
			var params = tirRimborso_setParams(0, 0, bStato, descrizione, APLId, CPIId, tirocinioId, '', false);
			var data = getAllByParams('tirRimborso', 'CountByFilter', params);
			return $q.when(data);
		}

		function tirRimborso_get(id) {
			var data = getById('tirRimborso', id);
			return $q.when(data);
		}

		function tirRimborso_add(item) {
			var data = addObj('tirRimborso', item);
			return $q.when(data);
		}

		function tirRimborso_update(item) {
			var data = updateObj('tirRimborso', item);
			return $q.when(data);
		}

		function tirRimborso_changePeriodo(item) {
			var objName = 'tirRimborso';
			var objValue = item;

			return $http.put(urlAPI + '/' + objName + '/ChangePeriodo', objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirRimborso_calcolaImportoRichiesto(tirocinioId, dtInizio, dtFine) {
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof dtInizio == 'undefined') { dtInizio = ''; }
			if (typeof dtFine == 'undefined') { dtFine = ''; }

			var params = [];
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'dtInizio', value: dtInizio });
			params.push({ name: 'dtFine', value: dtFine });

			var data = getAllByParams('tirRimborso', 'CalcolaImportoRichiesto', params);
			return $q.when(data);
		}

		function tirRimborso_updateDatiAssess(item) {
			var objName = 'tirRimborso';
			var objValue = item;

			return $http.put(urlAPI + '/' + objName + '/PutDatiAssess', objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirRimborso_changeState(item) {
			var objName = 'tirRimborso';

			return $http.put(urlAPI + '/' + objName + '/ChangeState', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed sentObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirRimborso_delete(id) {
			var data = deleteObj('tirRimborso', id);
			return $q.when(data);
		}

		function tirRimborso_unlock(item) {
			var objName = 'tirRimborso';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirRimborso_unsetPresaIncarico(item) {
			var objName = 'tirRimborso';

			return $http.put(urlAPI + '/' + objName + '/RemovePresaIncarico', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

        function tirRimborso_unsetPresaIncaricoCPI(item) {
            var objName = 'tirRimborso';

            return $http.put(urlAPI + '/' + objName + '/RemovePresaIncaricoCPI', item)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.info('XHR Failed unlockObj for %s: %s', objName, message);
                    return message.status;
                });
        }

        

        function tirRimborso_unsetIssuePay(item) {
            var objName = 'tirRimborso';

			return $http.put(urlAPI + '/' + objName + '/RemoveIssuePay', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirRimborso_printAllegato7(tirRimborsoId) {
			var data = getAllByParam('pdf', 'GetAllegato7', 'tirRimborsoId', tirRimborsoId);
			return $q.when(data);
		}

		function tirRimborso_changeState2(tirRmbId, nState, iState) {
			if (typeof tirRmbId == 'undefined') { tirRmbId = 0; }
			if (typeof nState == 'undefined') { nState = ''; }
			if (typeof iState == 'undefined') { iState = -1; }

			var params = [];
			params.push({ name: 'tirRmbId', value: tirRmbId });
			params.push({ name: 'nState', value: nState });
			params.push({ name: 'iState', value: iState });

			var data = getAllByParams('tirRimborso', 'ChangeState2', params);
			return $q.when(data);
		}

		// ******************************
		//  TIROCINIO RIMBORSO DTL
		function tirRimborsoDtl_setParams(pageSize, page, order, bGet, testuale, tirRimborsoId, tirocinioId, aplId, cpiId, anno, mese, iStato) {
			if (bGet) {
				if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
				if (typeof page == 'undefined') { page = 1; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tirRimborsoId == 'undefined') { tirRimborsoId = 0; }
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (bGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tirRimborsoId', value: tirRimborsoId });
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function tirRimborsoDtl_getAllList(testuale, tirRimborsoId, tirocinioId, aplId, cpiId, anno, mese, iStato) {
			var params = tirRimborsoDtl_setParams(0, 0, '', false, testuale, tirRimborsoId, tirocinioId, aplId, cpiId, anno, mese, iStato);

			var data = getAllByParams('tirRimborsoDtl', 'GetAllList', params);
			return $q.when(data);
		}
		function tirRimborsoDtl_getAll(pageSize, page, testuale, tirRimborsoId, tirocinioId, aplId, cpiId, anno, mese, iStato, order) {
			var params = tirRimborsoDtl_setParams(pageSize, page, order, true, testuale, tirRimborsoId, tirocinioId, aplId, cpiId, anno, mese, iStato);

			var data = getAllByParams('tirRimborsoDtl', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function tirRimborsoDtl_countAll(testuale, tirRimborsoId, tirocinioId, aplId, cpiId, anno, mese, iStato) {
			var params = tirRimborsoDtl_setParams(0, 0, '', false, testuale, tirRimborsoId, tirocinioId, aplId, cpiId, anno, mese, iStato);

			var data = getAllByParams('tirRimborsoDtl', 'CountByFilter', params);
			return $q.when(data);
		}

		function tirRimborsoDtl_get(id) {
			var data = getById('tirRimborsoDtl', id);
			return $q.when(data);
		}

		function tirRimborsoDtl_add(item) {
			var data = addObj('tirRimborsoDtl', item);
			return $q.when(data);
		}

		function tirRimborsoDtl_update(item) {
			var data = updateObj('tirRimborsoDtl', item);
			return $q.when(data);
		}

		function tirRimborsoDtl_delete(id) {
			var data = deleteObj('tirRimborsoDtl', id);
			return $q.when(data);
		}

		// ******************************
		//  TIROCINIO SOSPENSIONE
		function tirSospensione_getAllByTirocinioId(tirocinioId, iFestivo) {
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof iFestivo == 'undefined') { iFestivo = 0; }

			var params = [];
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'iFestivo', value: iFestivo });

			var data = getAllByParams('tirSospensione', 'GetAllByTirocinioId', params);
			return $q.when(data);

		}

		// ******************************
		// MY LOG

		function myLog_setParams(pageSize, page, testuale, tabella, anno, mese, dt, dtStart, dtEnd, iStato, order, bGet) {
			if (bGet) {
				if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
				if (typeof page == 'undefined') { page = 1; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tabella == 'undefined') { tabella = ''; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof dt == 'undefined') { dt = ''; }
			if (typeof dtStart == 'undefined') { dtStart = ''; }
			if (typeof dtEnd == 'undefined') { dtEnd = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (bGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tabella', value: tabella });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'dt', value: dt });
			params.push({ name: 'dtStart', value: dtStart });
			params.push({ name: 'dtEnd', value: dtEnd });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function myLog_getAllList(testuale, tabella, anno, mese, dt, dtStart, dtEnd, iStato) {
			var params = myLog_setParams(0, 0, testuale, tabella, anno, mese, dt, dtStart, dtEnd, iStato, '', false);

			var data = getAllByParams('myLog', 'GetAllList', params);
			return $q.when(data);
		}

		function myLog_getAll(pageSize, page, testuale, tabella, anno, mese, dt, dtStart, dtEnd, iStato, order) {
			var params = myLog_setParams(pageSize, page, testuale, tabella, anno, mese, dt, dtStart, dtEnd, iStato, order, true);

			var data = getAllByParams('myLog', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function myLog_countAll(testuale, tabella, anno, mese, dt, dtStart, dtEnd, iStato) {
			var params = myLog_setParams(0, 0, testuale, tabella, anno, mese, dt, dtStart, dtEnd, iStato, '', false);

			var data = getAllByParams('myLog', 'CountByFilter', params);
			return $q.when(data);
		}

		function myLog_get(id) {
			var data = getById('myLog', id);
			return $q.when(data);
		}

		function myLog_add(item) {
			var data = addObj('myLog', item);
			return $q.when(data);
		}

		function myLog_update(item) {
			var data = updateObj('myLog', item);
			return $q.when(data);
		}

		function myLog_merge(item) {
			var data = mergeObj('myLog', item);
			return $q.when(data);
		}

		function myLog_delete(id) {
			var data = deleteObj('myLog', id);
			return $q.when(data);
		}

		function tirSospensione_get(id) {
			var data = getById('tirSospensione', id);
			return $q.when(data);
		}


		function tirSospensione_add(item) {
			var data = addObj('tirSospensione', item);
			return $q.when(data);
		}

		function tirSospensione_update(item) {
			var data = updateObj('tirSospensione', item);
			return $q.when(data);
		}

		function tirSospensione_delete(id) {
			var data = deleteObj('tirSospensione', id);
			return $q.when(data);
		}




		// ******************************
		//  COLLOCAMENTO
		function collocamento_getAllList() {
			var data = getAllList('collocamento');
			return $q.when(data);
		}

		function collocamento_getAllListByRmbDtl(collRimborsoId, collocamentoId) {
			if (typeof collRimborsoId == 'undefined') { collRimborsoId = 0; }
			if (typeof collocamentoId == 'undefined') { collocamentoId = 0; }

			var params = [];
			params.push({ name: 'collRimborsoId', value: collRimborsoId });
			params.push({ name: 'collocamentoId', value: collocamentoId });

			var data = getAllByParams('collocamento', 'GetAllListByRmbDtl', params);
			return $q.when(data);
		}

		function collocamento_getAll(pageSize, page, bCompleted, bSent, isWhole, bProroga, nominativo, aziendaId, ruoloSoggettoId, cpiId, dtInsert, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof bCompleted == 'undefined') { bCompleted = 0; }
			if (typeof bSent == 'undefined') { bSent = 0; }
			if (typeof isWhole == 'undefined') { isWhole = 0; }
			if (typeof bProroga == 'undefined') { bProroga = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof dtInsert == 'undefined') { dtInsert = ''; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'bCompleted', value: bCompleted });
			params.push({ name: 'bSent', value: bSent });
			params.push({ name: 'isWhole', value: isWhole });
			params.push({ name: 'bProroga', value: bProroga });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'dtInsert', value: dtInsert });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('collocamento', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function collocamento_countAll(bCompleted, bSent, isWhole, bProroga, nominativo, aziendaId, ruoloSoggettoId, cpiId, dtInsert) {
			if (typeof bCompleted == 'undefined') { bCompleted = 0; }
			if (typeof bSent == 'undefined') { bSent = 0; }
			if (typeof isWhole == 'undefined') { isWhole = 0; }
			if (typeof bProroga == 'undefined') { bProroga = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof dtInsert == 'undefined') { dtInsert = ''; }

			var params = [];
			params.push({ name: 'bCompleted', value: bCompleted });
			params.push({ name: 'bSent', value: bSent });
			params.push({ name: 'isWhole', value: isWhole });
			params.push({ name: 'bProroga', value: bProroga });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'dtInsert', value: dtInsert });

			var data = getAllByParams('collocamento', 'CountByFilter', params);
			return $q.when(data);
		}

		function collocamento_existsTir(collocamentoId, tirocinanteId) {
			if (typeof collocamentoId == 'undefined') { collocamentoId = 0; }
			if (typeof tirocinanteId == 'undefined') { tirocinanteId = 0; }
			var params = [];
			params.push({ name: 'collocamentoId', value: collocamentoId });
			params.push({ name: 'tirocinanteId', value: tirocinanteId });

			var data = getAllByParams('collocamento', 'ExistsTir', params);
			return $q.when(data);
		}

		function collocamento_statusCF(codiceFiscale, aziendaId) {
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }

			var params = [];
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'aziendaId', value: aziendaId });

			var data = getAllByParams('collocamento', 'StatusCF', params);
			return $q.when(data);
		}

		function collocamento_assign(codiceFiscale, aziendaId, cpiId) {
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }

			var params = [];
			params.push({ name: 'CodiceFiscale', value: codiceFiscale });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'cpiId', value: cpiId });

			var item = {};
			item.G_CodiceFiscale = codiceFiscale;
			item.APLId = aziendaId;
			item.CPIId = cpiId;

			var data = postMethod('collocamento', 'Assign', item);
			return $q.when(data);
		}

		function collocamento_get(id) {
			var data = getById('collocamento', id);
			return $q.when(data);
		}

		function collocamento_add(item) {
			var data = addObj('collocamento', item);
			return $q.when(data);
		}

		function collocamento_update(item) {
			var data = updateObj('collocamento', item);
			return $q.when(data);
		}

		function collocamento_delete(id) {
			console.log("deletetirocinio(%s)", id);

			var data = deleteObj('collocamento', id);
			return $q.when(data);
		}

		function collocamento_unlock(item) {
			var objName = 'collocamento';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}


		function collocamento_proroga(id, dtEndPrev) {
			var objName = 'collocamento';
			if (typeof id == 'undefined') { id = 0; }
			if (typeof dtEndPrev == 'undefined') { dtEndPrev = ''; }


			var item = {};
			item.Id = id;
			item.DtEndPrev = dtEndPrev;

			return $http.put(urlAPI + '/' + objName + '/Proroga', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function collocamento_unlockProroga(item) {
			var objName = 'collocamento';

			return $http.put(urlAPI + '/' + objName + '/UnlockProroga', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		// ******************************
		//  COLL-RIMBORSO
		function collRimborso_getAllList() {
			var data = getAllList('collRimborso');
			return $q.when(data);
		}

		function collRimborso_getAll(pageSize, page, bStato, descrizione, aziendaId, cpiId) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'cpiId', value: cpiId });

			var data = getAllByParams('collRimborso', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function collRimborso_countAll(bStato, descrizione, aziendaId, cpiId) {
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }

			var params = [];
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'cpiId', value: cpiId });


			var data = getAllByParams('collRimborso', 'CountByFilter', params);
			return $q.when(data);
		}

		function collRimborso_get(id) {
			var data = getById('collRimborso', id);
			return $q.when(data);
		}


		function collRimborso_add(item) {
			var data = addObj('collRimborso', item);
			return $q.when(data);
		}

		function collRimborso_update(item) {
			var data = updateObj('collRimborso', item);
			return $q.when(data);
		}

		function collRimborso_updateDatiAssess(item) {
			var objName = 'collRimborso';
			var objValue = item;

			return $http.put(urlAPI + '/' + objName + '/PutDatiAssess', objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function collRimborso_delete(id) {
			var data = deleteObj('collRimborso', id);
			return $q.when(data);
		}

		function collRimborso_unlock(item) {
			var objName = 'collRimborso';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}


		// ******************************
		//--  TContratto 
		function tContratto_getAllList() {
			var data = getAllList('tContratto');
			return $q.when(data);
		}

		function tContratto_get(id) {
			var data = getById('tContratto', id);
			return $q.when(data);
		}

		// ******************************
		//  COLL-SERVIZIO
		function collServizio_getAllList() {
			var data = getAllList('collServizio');
			return $q.when(data);
		}

		function collServizio_getAll(pageSize, page, bStato, descrizione, collocamentoId, tContrattoId) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof collocamentoId == 'undefined') { collocamentoId = 0; }
			if (typeof tContrattoId == 'undefined') { tContrattoId = 0; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'collocamentoId', value: collocamentoId });
			params.push({ name: 'tContrattoId', value: tContrattoId });

			var data = getAllByParams('collServizio', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function collServizio_countAll(bStato, descrizione, collocamentoId, tContrattoId) {
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof collocamentoId == 'undefined') { collocamentoId = 0; }
			if (typeof tContrattoId == 'undefined') { tContrattoId = 0; }

			var params = [];
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'collocamentoId', value: collocamentoId });
			params.push({ name: 'tContrattoId', value: tContrattoId });


			var data = getAllByParams('collServizio', 'CountByFilter', params);
			return $q.when(data);
		}

		function collServizio_get(id) {
			var data = getById('collServizio', id);
			return $q.when(data);
		}


		function collServizio_add(item) {
			var data = addObj('collServizio', item);
			return $q.when(data);
		}

		function collServizio_update(item) {
			var data = updateObj('collServizio', item);
			return $q.when(data);
		}

		function collServizio_delete(id) {
			var data = deleteObj('collServizio', id);
			return $q.when(data);
		}

		function collServizio_unlock(item) {
			var objName = 'collServizio';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}


		// ******************************
		//  COLL-CONTRATTO (ASSUNZIONE)
		function collContratto_getAllList() {
			var data = getAllList('collContratto');
			return $q.when(data);
		}

		function collContratto_getAll(pageSize, page, bStato, descrizione, collocamentoId) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof collocamentoId == 'undefined') { collocamentoId = 0; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'collocamentoId', value: collocamentoId });

			var data = getAllByParams('collContratto', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function collContratto_countAll(bStato, descrizione, collocamentoId) {
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof collocamentoId == 'undefined') { collocamentoId = 0; }

			var params = [];
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'collocamentoId', value: collocamentoId });


			var data = getAllByParams('collContratto', 'CountByFilter', params);
			return $q.when(data);
		}

		function collContratto_get(id) {
			var data = getById('collContratto', id);
			return $q.when(data);
		}


		function collContratto_add(item) {
			var data = addObj('collContratto', item);
			return $q.when(data);
		}

		function collContratto_update(item) {
			var data = updateObj('collContratto', item);
			return $q.when(data);
		}

		function collContratto_delete(id) {
			var data = deleteObj('collContratto', id);
			return $q.when(data);
		}

		function collContratto_unlock(item) {
			var objName = 'collContratto';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		// ******************************
		//  COLL-RIMBORSO DETAIL
		function collRmbDtl_getAllList() {
			var data = getAllList('collRmbDtl');
			return $q.when(data);
		}

		function collRmbDtl_getAll(pageSize, page, bStato, descrizione, collocamentoId, collRimborsoId, tCPIId) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof collocamentoId == 'undefined') { collocamentoId = 0; }
			if (typeof collRimborsoId == 'undefined') { collRimborsoId = 0; }
			if (typeof tCPIId == 'undefined') { tCPIId = 0; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'collocamentoId', value: collocamentoId });
			params.push({ name: 'collRimborsoId', value: collRimborsoId });
			params.push({ name: 'tCPIId', value: tCPIId });

			var data = getAllByParams('collRmbDtl', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function collRmbDtl_countAll(bStato, descrizione, collocamentoId, collRimborsoId, tCPIId) {
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof collocamentoId == 'undefined') { collocamentoId = 0; }
			if (typeof collRimborsoId == 'undefined') { collRimborsoId = 0; }
			if (typeof tCPIId == 'undefined') { tCPIId = 0; }

			var params = [];
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'collocamentoId', value: collocamentoId });
			params.push({ name: 'collRimborsoId', value: collRimborsoId });
			params.push({ name: 'tCPIId', value: tCPIId });


			var data = getAllByParams('collRmbDtl', 'CountByFilter', params);
			return $q.when(data);
		}

		function collRmbDtl_get(id) {
			var data = getById('collRmbDtl', id);
			return $q.when(data);
		}


		function collRmbDtl_add(item) {
			var data = addObj('collRmbDtl', item);
			return $q.when(data);
		}

		function collRmbDtl_update(item) {
			var data = updateObj('collRmbDtl', item);
			return $q.when(data);
		}

		function collRmbDtl_delete(id) {
			var data = deleteObj('collRmbDtl', id);
			return $q.when(data);
		}

		function collRmbDtl_unlock(item) {
			var objName = 'collRmbDtl';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}


		// AUTHORIZATION
		function authorization_get(area) {
			if (typeof area == 'undefined') { area = ''; }

			var params = [];
			params.push({ name: 'area', value: area });

			var data = getAllByParams('user', 'GetAuthorization', params);
			return $q.when(data);

		    /*
			var objName = 'user';
			var actionName = 'GetAuthorization';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?'
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.get(url)
										.then(function (response) {
											return response.data;
										})
										.catch(function (message) {
											console.info('XHR Failed authorization_get for %s: %s', objName, message);
											return message.status;
										});
            */
		}

		function authorization_getAllByFilter(pageSize, page, userId, roleId, areaId, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof userId == 'undefined') { userId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof areaId == 'undefined') { areaId = -1; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'userId', value: userId });
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'areaId', value: areaId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('user', 'Auth_GetAllByFilter', params);
			return $q.when(data);

		    /*
		    var url = urlAPI + '/' + objName + '/' + actionName;
		    var numParams = params.length;
		    if (numParams > 0) {
		        url += '?'
		    }

		    for (var i = 0; i < numParams; i++) {
		        if (i > 0) url += '&';
		        url += params[i].name + '=' + params[i].value;
		    }

		    return $http.get(url)
										.then(function (response) {
										    return response.data;
										})
										.catch(function (message) {
										    console.info('XHR Failed authorization_getAllByFilter for %s: %s', objName, message);
										    return message.status;
										});
                                        */
		}

		function authorization_countAllByFilter(userId, roleId, areaId) {
			if (typeof userId == 'undefined') { userId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof areaId == 'undefined') { areaId = -1; }

			var params = [];
			params.push({ name: 'userId', value: userId });
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'areaId', value: areaId });

			var data = getAllByParams('user', 'Auth_CountAllByFilter', params);
			return $q.when(data);

		    /*
		    var objName = 'user';
		    var actionName = 'Auth_CountAllByFilter';
		    var url = urlAPI + '/' + objName + '/' + actionName;
		    var numParams = params.length;
		    if (numParams > 0) {
		        url += '?'
		    }

		    for (var i = 0; i < numParams; i++) {
		        if (i > 0) url += '&';
		        url += params[i].name + '=' + params[i].value;
		    }

		    return $http.get(url)
										.then(function (response) {
										    return response.data;
										})
										.catch(function (message) {
										    console.info('XHR Failed authorization_countAllByFilter for %s: %s', objName, message);
										    return message.status;
										});
                                        */
		}

		function authorization_getById(id) {
			if (typeof id == 'undefined') { id = 0; }

			var params = [];
			params.push({ name: 'id', value: id });

			var data = getAllByParams('user', 'Auth_Get', params);
			return $q.when(data);

		    /*
		    var objName = 'user';
		    var actionName = 'Auth_Get';
		    var url = urlAPI + '/' + objName + '/' + actionName;
		    var numParams = params.length;
		    if (numParams > 0) {
		        url += '?'
		    }

		    for (var i = 0; i < numParams; i++) {
		        if (i > 0) url += '&';
		        url += params[i].name + '=' + params[i].value;
		    }

		    return $http.get(url)
										.then(function (response) {
										    return response.data;
										})
										.catch(function (message) {
										    console.info('XHR Failed authorization_getById for %s: %s', objName, message);
										    return message.status;
										});
            */
		}

        /*
		function authorization_getAllByUser(userId) {
		    if (typeof userId == 'undefined') { userId = 0; }

		    var params = [];
		    params.push({ name: 'userId', value: userId });

		    var data = getAllByParams('user', 'Auth_GetAllByUser', params);
		    return $q.when(data);

            
		    var objName = 'user';
		    var actionName = 'Auth_GetAllByUser';
		    var url = urlAPI + '/' + objName + '/' + actionName;
		    var numParams = params.length;
		    if (numParams > 0) {
		        url += '?'
		    }

		    for (var i = 0; i < numParams; i++) {
		        if (i > 0) url += '&';
		        url += params[i].name + '=' + params[i].value;
		    }

		    return $http.get(url)
						.then(function (response) {
							return response.data;
						})
						.catch(function (message) {
							console.info('XHR Failed authorization_getAllByUser for %s: %s', objName, message);
							return message.status;
						});
                    
		}
        */

		function authorization_getAllByUser(userId) {
			if (typeof userId == 'undefined') { userId = 0; }

			var params = [];
			params.push({ name: 'userId', value: userId });

			var data = getAllByParams('user', 'Auth_GetAllByUser', params);
			return $q.when(data);
		}

		function authorization_add(item) {
			var objName = 'user';
			var actionName = 'Auth_Post';

			return $http.post(urlAPI + '/' + objName + '/' + actionName, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed authorization_add for %s: %s', objName, message);
					return message.status;
				});
		}

		function authorization_update(item) {
			var objName = 'user';
			var actionName = 'Auth_Put';

			return $http.put(urlAPI + '/' + objName + '/' + actionName, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed authorization_update for %s: %s', objName, message);
					return message.status;
				});
		}

		function authorization_delete(id) {
			var objName = 'user';
			var actionName = 'Auth_Delete';
			return $http.delete(urlAPI + '/' + objName + '/' + actionName + '/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed authorization_delete for %s: %s', objName, message);
					return message.status;
				});
		}

		// AREA

		function area_getAllList() {
			var objName = 'user';
			var actionName = 'GetAllListAreas';
			return $http.get(urlAPI + '/' + objName + '/' + actionName)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getAllList for %s: %s', objName, message);
					return message.status;
				});
		}

		function area_getAll() {
			var objName = 'user';
			var actionName = 'Area_GetAll';
			return $http.get(urlAPI + '/' + objName + '/' + actionName)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed area_getAll NO Param for %s: %s', objName, message);
					return message.status;
				});
		}

		function area_getAllByFilter(nominativo) {
			if (typeof nominativo == 'undefined') { nominativo = ''; }

			var params = [];
			params.push({ name: 'nominativo', value: nominativo });

			var data = getAllByParams('user', 'Area_GetAllByFilter', params);
			return $q.when(data);

		}


		function area_getMaxId() {
			var actionName = 'Area_GetMaxId';
			return $http.get(urlAPI + '/User/' + actionName)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed area_getMaxId for %s: %s', objName, message);
					return message.status;
				});
		}

		function area_get(id) {
			var actionName = 'Area_Get';
			return $http.get(urlAPI + '/User/' + actionName + '/' + id)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed area_get for %s: %s', objName, message);
					return message.status;
				});
		}

		function area_add(item) {
			var action = 'Area_Post';
			return $http.post(urlAPI + '/User/' + action, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed area_add for %s: %s', objName, message);
					return message.status;
				});
		}

		function area_update(item) {
			var action = 'Area_Put';
			return $http.put(urlAPI + '/User/' + action, item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed area_update for %s: %s', objName, message);
					return message.status;
				});
		}

		function area_delete(id) {
			var actionName = 'Area_Delete';

			var data = $http.delete(urlAPI + '/User/' + actionName + '/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed area_delete for %s: %s', objName, message);
					return message.status;
				});
			return $q.when(data);
		}

		//============================== NEWSLETTER
		// -- MAIL_EMAIL
		function newsletter_email_getAllList() {
			var data = getAllNoParam('Newsletter_Email', 'GetAllList');
			return $q.when(data);
		}

		function newsletter_email_getAll(pageSize, page, bSent, obj, body, dtSent, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof bSent == 'undefined') { bSent = 0; }
			if (typeof obj == 'undefined') { obj = ''; }
			if (typeof body == 'undefined') { body = ''; }
			if (typeof dtSent == 'undefined') { dtSent = ''; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'bSent', value: bSent });
			params.push({ name: 'obj', value: obj });
			params.push({ name: 'body', value: body });
			params.push({ name: 'dtSent', value: dtSent });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('Newsletter_Email', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function newsletter_email_countAll(pageSize, page, bSent, obj, body, dtSent, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof bSent == 'undefined') { bSent = 0; }
			if (typeof obj == 'undefined') { obj = ''; }
			if (typeof body == 'undefined') { body = ''; }
			if (typeof dtSent == 'undefined') { dtSent = ''; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'bSent', value: bSent });
			params.push({ name: 'obj', value: obj });
			params.push({ name: 'body', value: body });
			params.push({ name: 'dtSent', value: dtSent });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('Newsletter_Email', 'CountByFilter', params);
			return $q.when(data);
		}

		function newsletter_email_get(id) {
			var data = getById('Newsletter_Email', id);
			return $q.when(data);
		}

		function newsletter_email_add(item) {
			var data = addObj('Newsletter_Email', item);
			return $q.when(data);
		}

		function newsletter_email_update(item) {
			var data = updateObj('Newsletter_Email', item);
			return $q.when(data);
		}

		function newsletter_email_confirmSent(item) {
			var objName = 'Newsletter_Email';
			var objAction = 'ConfirmSent';
			return $http.put(urlAPI + '/' + objName + '/' + objAction, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function newsletter_email_delete(id) {
			var data = deleteObj('Newsletter_Email', id);
			return $q.when(data);
		}

		function newsletter_email_invioEmail(email, id) {
			var url = urlAPI + '/Newsletter_Email/invioEmail?email=' + email + '&emailId=' + id;
			return $http.post(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed Reset Password for user: %s', message);
					return message.status;
				});
		}

		function newsletter_email_invioEmails(id) {
			var url = urlAPI + '/Newsletter_Email/invioEmails?emailId=' + id;
			return $http.post(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed Reset Password for user: %s', message);
					return message.status;
				});
		}

		function newsletter_email_getTemplate(template) {
			var url = urlAPI + '/Newsletter_Email/GetTemplate?template=' + template;
			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getTemplate for %s: %s', objName, message);
					return message.status;
				});
		}

		// -- MAIL_ATTACHMENT
		function newsletter_attachment_getAllList() {
			var data = getAllNoParam('Newsletter_Attachment', 'GetAllList');
			return $q.when(data);
		}

		function newsletter_attachment_getAll(pageSize, page, emailId, filename, username, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof emailId == 'undefined') { emailId = 0; }
			if (typeof filename == 'undefined') { filename = ''; }
			if (typeof username == 'undefined') { username = ''; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'emailId', value: emailId });
			params.push({ name: 'filename', value: filename });
			params.push({ name: 'username', value: username });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('Newsletter_Attachment', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function newsletter_attachment_getByEmailId(emailId) {
			var data = getAllByParam('Newsletter_Attachment', 'GetByEmailId', 'emailId', emailId);
			return $q.when(data);
		}

		function newsletter_attachment_countByEmailId(emailId) {
			var data = getAllByParam('Newsletter_Attachment', 'CountByEmailId', 'emailId', emailId);
			return $q.when(data);
		}

		function newsletter_attachment_countAll(emailId, filename, username) {
			if (typeof emailId == 'undefined') { emailId = 0; }
			if (typeof filename == 'undefined') { filename = ''; }
			if (typeof username == 'undefined') { username = ''; }

			var params = [];
			params.push({ name: 'emailId', value: emailId });
			params.push({ name: 'filename', value: filename });
			params.push({ name: 'username', value: username });

			var data = getAllByParams('Newsletter_Attachment', 'CountByFilter', params);
			return $q.when(data);
		}

		function newsletter_attachment_get(id) {
			var data = getById('Newsletter_Attachment', id);
			return $q.when(data);
		}

		function newsletter_attachment_add(item) {
			var data = addObj('Newsletter_Attachment', item);
			return $q.when(data);
		}

		function newsletter_attachment_update(item) {
			var data = updateObj('Newsletter_Attachment', item);
			return $q.when(data);
		}

		function newsletter_attachment_delete(id) {
			var data = deleteObj('Newsletter_Attachment', id);
			return $q.when(data);
		}

		// -- MAIL_TSOURCE
		function newsletter_tSource_getAllList() {
			var data = getAllNoParam('Newsletter_tSource', 'GetAllList');
			return $q.when(data);
		}

		function newsletter_tSource_getAll(pageSize, page, table, keyfield, valuefield, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof table == 'undefined') { table = ''; }
			if (typeof keyfield == 'undefined') { keyfield = ''; }
			if (typeof valuefield == 'undefined') { valuefield = ''; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'table', value: table });
			params.push({ name: 'keyfield', value: keyfield });
			params.push({ name: 'valuefield', value: valuefield });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('Newsletter_tSource', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function newsletter_tSource_countAll(table, keyfield, valuefield) {
			if (typeof table == 'undefined') { table = ''; }
			if (typeof keyfield == 'undefined') { keyfield = ''; }
			if (typeof valuefield == 'undefined') { valuefield = ''; }

			var params = [];
			params.push({ name: 'table', value: table });
			params.push({ name: 'keyfield', value: keyfield });
			params.push({ name: 'valuefield', value: valuefield });

			var data = getAllByParams('Newsletter_tSource', 'CountByFilter', params);
			return $q.when(data);
		}

		function newsletter_tSource_get(id) {
			var data = getById('Newsletter_tSource', id);
			return $q.when(data);
		}

		function newsletter_tSource_getByTable(table) {
			var data = getAllByParam('Newsletter_tSource', 'GetByTable', 'table', table);
			return $q.when(data);
		}

		function newsletter_tSource_Entity_getList(pageSize, page, id, queryParams) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof id == 'undefined') { id = 0; }
			if (typeof queryParams == 'undefined') { queryParams = []; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'id', value: id });
			params.push({ name: 'queryParams', value: queryParams });

			var objName = 'Newsletter_tSource';
			var actionName = 'Entity_GetList';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?'
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.post(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed Exec for %s: %s', objName, message);
					return message.status;
				});
		}

		function newsletter_tSource_Entity_countByFilter(id, queryParams) {
			if (typeof id == 'undefined') { id = ''; }
			if (typeof queryParams == 'undefined') { queryParams = []; }

			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'queryParams', value: queryParams });

			var objName = 'Newsletter_tSource';
			var actionName = 'Entity_CountAll';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?'
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed Exec for %s: %s', objName, message);
					return message.status;
				});
		    /*
					var data = getAllByParams('query', 'Entity_CountAll', params);

					return $q.when(data);
					*/
		}

		function newsletter_tSource_Entity_getAllByFilter(pageSize, page, id, queryParams) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof id == 'undefined') { id = 0; }
			if (typeof queryParams == 'undefined') { queryParams = []; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'id', value: id });
			params.push({ name: 'queryParams', value: queryParams });

			var objName = 'Newsletter_tSource';
			var actionName = 'Entity_GetAllByPage';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?'
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.post(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed Exec for %s: %s', objName, message);
					return message.status;
				});
		}



		// -- MAIL_RECEIVERS
		function newsletter_receivers_getAllList() {
			var data = getAllNoParam('Newsletter_Receivers', 'GetAllList');
			return $q.when(data);
		}

		function newsletter_receivers_getAll(pageSize, page, emailId, address, bSent, bProcessed, tSourceId, sourceId, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof emailId == 'undefined') { emailId = 0; }
			if (typeof address == 'undefined') { address = ''; }
			if (typeof bSent == 'undefined') { bSent = 0; }
			if (typeof bProcessed == 'undefined') { bProcessed = 0; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'emailId', value: emailId });
			params.push({ name: 'address', value: address });
			params.push({ name: 'bSent', value: bSent });
			params.push({ name: 'bProcessed', value: bProcessed });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('Newsletter_Receivers', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function newsletter_receivers_getByEmailId(emailId) {
			var data = getAllByParam('Newsletter_Receivers', 'GetByEmailId', 'emailId', emailId);
			return $q.when(data);
		}

		function newsletter_receivers_countByEmailId(emailId) {
			var data = getAllByParam('Newsletter_Receivers', 'CountByEmailId', 'emailId', emailId);
			return $q.when(data);
		}

		function newsletter_receivers_getByTSourceId(tSourceId) {
			var data = getAllByParam('Newsletter_Receivers', 'GetByTSourceId', 'tSourceId', tSourceId);
			return $q.when(data);
		}

		function newsletter_receivers_countAll(emailId, address, bSent, bProcessed, tSourceId, sourceId) {
			if (typeof emailId == 'undefined') { emailId = 0; }
			if (typeof address == 'undefined') { address = ''; }
			if (typeof bSent == 'undefined') { bSent = 0; }
			if (typeof bProcessed == 'undefined') { bProcessed = 0; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }

			var params = [];
			params.push({ name: 'emailId', value: emailId });
			params.push({ name: 'address', value: address });
			params.push({ name: 'bSent', value: bSent });
			params.push({ name: 'bProcessed', value: bProcessed });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'sourceId', value: sourceId });

			var data = getAllByParams('Newsletter_Receivers', 'CountByFilter', params);
			return $q.when(data);
		}

		function newsletter_receivers_get(id) {
			var data = getById('Newsletter_Receivers', id);
			return $q.when(data);
		}

		function newsletter_receivers_add(item) {
			var data = addObj('Newsletter_Receivers', item);
			return $q.when(data);
		}

		function newsletter_receivers_update(item) {
			var data = updateObj('Newsletter_Receivers', item);
			return $q.when(data);
		}

		function newsletter_receivers_delete(id) {
			var data = deleteObj('Newsletter_Receivers', id);
			return $q.when(data);
		}


		// ******************************
		//  FAQ - NUOVI METODI
		function faq_getAllList(tFaqId, iHomepage, iComunicazione) {
			if (typeof tFaqId == 'undefined') { tFaqId = 0; }
			if (typeof iHomepage == 'undefined') { iHomepage = 0; }
			if (typeof iComunicazione == 'undefined') { iComunicazione = 0; }

			var params = [];
			params.push({ name: 'tFaqId', value: tFaqId });
			params.push({ name: 'iHomepage', value: iHomepage });
			params.push({ name: 'iComunicazione', value: iComunicazione });

			var data = getAllByParams('faq', 'GetAllList', params);
			return $q.when(data);
		}

		function faq_getAll(pageSize, page, tFaqId, iHomepage, iComunicazione, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof tFaqId == 'undefined') { tFaqId = 0; }
			if (typeof iHomepage == 'undefined') { iHomepage = 0; }
			if (typeof iComunicazione == 'undefined') { iComunicazione = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'tFaqId', value: tFaqId });
			params.push({ name: 'iHomepage', value: iHomepage });
			params.push({ name: 'iComunicazione', value: iComunicazione });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('faq', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function faq_countAll(tFaqId, iHomepage, iComunicazione) {
			if (typeof tFaqId == 'undefined') { tFaqId = 0; }
			if (typeof iHomepage == 'undefined') { iHomepage = 0; }
			if (typeof iComunicazione == 'undefined') { iComunicazione = 0; }

			var params = [];
			params.push({ name: 'tFaqId', value: tFaqId });
			params.push({ name: 'iHomepage', value: iHomepage });
			params.push({ name: 'iComunicazione', value: iComunicazione });

			var data = getAllByParams('faq', 'CountByFilter', params);
			return $q.when(data);
		}

		function faq_get(id) {
			var data = getById('faq', id);
			return $q.when(data);
		}

		function faq_add(item) {
			var data = addObj('faq', item);
			return $q.when(data);
		}

		function faq_update(item) {
			var data = updateObj('faq', item);
			return $q.when(data);
		}

		function faq_delete(id) {
			var data = deleteObj('faq', id);
			return $q.when(data);
		}


		// ******************************
		//  tFaq - NUOVI METODI
		function tFaq_getAllList() {
			var data = getAllList('tFaq');
			return $q.when(data);
		}


		function tFaq_get(id) {
			var data = getById('tFaq', id);
			return $q.when(data);
		}


		// ******************************
		//  ATTACH - NUOVI METODI
		function attach_getAllList(tSourceCode, tSourceId, sourceId, tAttachId) {
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof tAttachId == 'undefined') { tAttachId = 0; }

			var params = [];
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'tAttachId', value: tAttachId });

			var data = getAllByParams('attach', 'GetAllList', params);
			return $q.when(data);
		}

		function attach_getAll(pageSize, page, tSourceCode, tSourceId, sourceId, tAttachId, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof tAttachId == 'undefined') { tAttachId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'tAttachId', value: tAttachId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('attach', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function attach_getAllCND(pageSize, page, progettoUID, UID, tSourceCode, tSourceId, sourceId, tAttachId, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof progettoUID == 'undefined') { progettoUID = ''; }
			if (typeof UID == 'undefined') { UID = ''; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof tAttachId == 'undefined') { tAttachId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'progettoUID', value: progettoUID });
			params.push({ name: 'UID', value: UID });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'tAttachId', value: tAttachId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('attach', 'GetAllByFilterCND', params);
			return $q.when(data);
		}


		function attach_countAll(tSourceCode, tSourceId, sourceId, tAttachId) {
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof tAttachId == 'undefined') { tAttachId = 0; }

			var params = [];
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'tAttachId', value: tAttachId });

			var data = getAllByParams('attach', 'CountByFilter', params);
			return $q.when(data);
		}

		function attach_get(id) {
			var data = getById('attach', id);
			return $q.when(data);
		}

		function attach_add(item) {
			var data = addObj('attach', item);
			return $q.when(data);
		}

		function attach_update(item) {
			var data = updateObj('attach', item);
			return $q.when(data);
		}

		function attach_delete(id) {
			var data = deleteObj('attach', id);
			return $q.when(data);
		}

		function attach_setCompleted(id) {
			var objName = 'attach';

			return $http.put(urlAPI + '/' + objName + '/SetCompleted/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed att_SetCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		function attach_unsetCompleted(id) {
			var objName = 'attach';

			return $http.put(urlAPI + '/' + objName + '/UnsetCompleted/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed att_UnsetCompleted for %s: %s', objName, message);
					return message.status;
				});
        }

        function attach_setIssue(item) {
            var objName = 'attach';

            return $http.put(urlAPI + '/' + objName + '/SetIssue/', item)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed att_SetCompleted for %s: %s', objName, message);
                    return message.status;
                });
        }

        function attach_unsetIssue(id) {
            var objName = 'attach';

            return $http.put(urlAPI + '/' + objName + '/UnsetIssue/' + id)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed att_UnsetCompleted for %s: %s', objName, message);
                    return message.status;
                });
        }

  //      function attach_updateIssue(item) {
  //          var objName = 'attach';

  //          return $http.put(urlAPI + '/' + objName + '/UpdateIssue/', item)
  //              .then(function (response) {
  //                  return response.status;
  //              })
  //              .catch(function (message) {
  //                  console.log('XHR Failed att_UnsetCompleted for %s: %s', objName, message);
  //                  return message.status;
  //              });
		//}

		function attach_updateIssue(item, replacedId, bAnomalia) {
			var objName = 'attach';
			var method = 'UpdateIssue';

			if (typeof (item) == 'undefined') { item = {}; }

			var url = urlAPI + '/' + objName + '/' + method + '?replacedId=' + replacedId + '&bAnomalia=' + bAnomalia;

			return $http.put(url, item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed add for %s: %s', objName, message);
					return message.status;
				});
		}

		function attach_unlock(item) {
			var objName = 'attach';

			return $http.put(urlAPI + '/' + objName + '/Unlock/', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed att_SetCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		function attach_download(tSourceCode, sourceId) {
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }

			var params = [];
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });

			var data = getAllByParams('attach', 'Download', params);
			return $q.when(data);
		}

		function attach_extract(id) {
			return $http.get(urlAPI + '/Attach/Extract/' + id)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getById for Extract: %s', message);
					return message.status;
				});
		}

		function attach_extractDigitalSignInfo(id) {
			return $http.get(urlAPI + '/Attach/ExtractDigitalSignInfo/' + id)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getById for Extract: %s', message);
					return message.status;
				});
		}


		// ******************************
		//  TATTACH - NUOVI METODI
		function tAttach_getAllList(tSourceCode, tSourceId, sourceId, onlyMissing) {
			/*
				onlyMissing:
					1: solo mancanti
					0: tutte
					-1: sono presenti
			*/
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof onlyMissing == 'undefined') { onlyMissing = 0; }

			var params = [];
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'onlyMissing', value: onlyMissing });

			var data = getAllByParams('tAttach', 'GetAllList', params);
			return $q.when(data);
		}

		function tAttach_getAllModal(pageSize, page, tSourceCode, tSourceId, sourceId, onlyMissing, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof onlyMissing == 'undefined') { onlyMissing = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'onlyMissing', value: onlyMissing });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('tAttach', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function tAttach_getAll(pageSize, page, tSourceCode, tSourceId, testuale, roleId, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('tAttach', 'GetAllWithoutVisibility', params);
			return $q.when(data);
		}

		function tAttach_countAll(tSourceCode, tSourceId, testuale, roleId) {
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof roleId == 'undefined') { roleId = 0; }

			var params = [];
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'roleId', value: roleId });

			var data = getAllByParams('tAttach', 'CountWithoutVisibility', params);
			return $q.when(data);
		}


		function tAttach_get(id) {
			var data = getById('tAttach', id);
			return $q.when(data);
		}

		function tAttach_add(item) {
			var data = addObj('tAttach', item);
			return $q.when(data);
		}

		function tAttach_update(item) {
			var data = updateObj('tAttach', item);
			return $q.when(data);
		}

		function tAttach_delete(id) {
			var data = deleteObj('tAttach', id);
			return $q.when(data);
		}

		// ******************************
		//  TATTACHVISIBILITY - NUOVI METODI

		function tAttachVisibility_getAuth(tSourceCode) {
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }

			var params = [];
			params.push({ name: 'tSourceCode', value: tSourceCode });

			var data = getAllByParams('TAttach', 'TAttachVisibility_GetAuth', params);
			return $q.when(data);
		}

		function tAttachVisibility_getAll(tAttachId, roleId, tSourceCode) {
			if (typeof tAttachId == 'undefined') { tAttachId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }

			var params = [];
			params.push({ name: 'tAttachId', value: tAttachId });
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'tSourceCode', value: tSourceCode });

			var data = getAllByParams('TAttach', 'TAttachVisibility_GetAllByFilter', params);
			return $q.when(data);
		}

		function tAttachVisibility_add(item) {
			return $http.post(urlAPI + '/TAttach/TAttachVisibility_Add', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed tAttachVisibility_add for TAttach: %s', message);
					return message.status;
				});

		}

		function tAttachVisibility_update(item) {
			return $http.put(urlAPI + '/TAttach/TAttachVisibility_Update', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed tAttachVisibility_update for TAttach: %s', message);
					return message.status;
				});

		}

		function tAttachVisibility_delete(id) {
			return $http.delete(urlAPI + '/TAttach/TAttachVisibility_Delete/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed deleteObj for TAttach: %s', message);
					return message.status;
				});
		}


		// ******************************
		//  TATTACHFILETYPE - NUOVI METODI

		function tAttachFileType_getAll(tAttachId, title, extension) {
			if (typeof tAttachId == 'undefined') { tAttachId = 0; }
			if (typeof title == 'undefined') { title = ''; }
			if (typeof extension == 'undefined') { extension = ''; }

			var params = [];
			params.push({ name: 'tAttachId', value: tAttachId });
			params.push({ name: 'title', value: title });
			params.push({ name: 'extension', value: extension });

			var data = getAllByParams('TAttach', 'TAttachFileType_GetAllByFilter', params);
			return $q.when(data);
		}

		function tAttachFileType_add(item) {
			return $http.post(urlAPI + '/TAttach/TAttachFileType_Add', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed TAttachFileType_Add for TAttach: %s', message);
					return message.status;
				});

		}

		function tAttachFileType_update(item) {
			return $http.put(urlAPI + '/TAttach/TAttachFileType_Update', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed TAttachFileType_Update for TAttach: %s', message);
					return message.status;
				});

		}

		function tAttachFileType_delete(id) {
			return $http.delete(urlAPI + '/TAttach/TAttachFileType_Delete/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed deleteObj for TAttachFileType: %s', message);
					return message.status;
				});
		}

		// ******************************
		//-- TIndirizzo          
		function tIndirizzo_getAllList() {
			var data = getAllList('tIndirizzo');
			return $q.when(data);
		}

		function tIndirizzo_get(id) {
			var data = getById('tIndirizzo', id);
			return $q.when(data);
		}


		// ******************************
		//  TSOURCE - NUOVI METODI
		function tSource_getAllList() {

			var data = getAllList('tSource');
			return $q.when(data);
		}

		function tSource_getAll(order) {
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: 0 });
			params.push({ name: 'page', value: 0 });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('tSource', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function tSource_get(id) {
			var data = getById('tSource', id);
			return $q.when(data);
		}

		function tSource_getByCode(code) {
			var data = getAllByParam('tSource', 'GetByCode', 'code', code);
			return $q.when(data);
		}


		/*     
		function tSource_countAll() {
				var params = [];
				var data = getAllByParams('tSource', 'CountByFilter', params);
				return $q.when(data);
			}




			function tSource_add(item) {
				var data = addObj('tSource', item);
				return $q.when(data);
			}

			function tSource_update(item) {
				var data = updateObj('tSource', item);
				return $q.when(data);
			}

			function tSource_delete(id) {
				var data = deleteObj('tSource', id);
				return $q.when(data);
			}
			*/

		// ******************************
		//  SOURCE 
		function source_getAllList(code) {
			var data = null;
			if (code == 'STD') {
				data = studente_getAllList();
			}
			else if (code == 'CRS') {
				data = aziendaSede_getAllList();
			}
			else if (code == 'CLS') {
				data = classe_getAllList(1, 2);
			}
			else if (code == 'AZD') {
				data = azienda_getAllList(1, 2);
			}
			else if (code == 'TIR') {
				data = tirocinante_getAllList();
			}
			else if (code == 'RMB') {
				data = rimborso_getAllList();
			}
			else if (code == 'TRC') {
				data = tirocinio_getAllList();
			}
			else if (code == 'CRB') {
				data = collRimborso_getAllList();
			}
			return $q.when(data);
		}

		// ******************************
		//  USER
		function user_getAllList() {
			var objName = 'user';
			var actionName = 'GetAllListUsers';
			return $http.get(urlAPI + '/' + objName + '/' + actionName)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getAllList for %s: %s', objName, message);
					return message.status;
				});
		}

		function user_getAllListActive() {
			var objName = 'user';
			var actionName = 'GetAllListUsersActive';
			return $http.get(urlAPI + '/' + objName + '/' + actionName)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getAllList for %s: %s', objName, message);
					return message.status;
				});
		}

		function user_getAll(pageSize, page, testuale, bAttivo, bloccato, order) {
			if (typeof bAttivo == 'undefined') { bAttivo = 1; }
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof bloccato == 'undefined') { bloccato = 0; }
			if (typeof order == 'undefined') { order = 'username'; }
			var params = [];
			params.push({ name: 'bAttivo', value: bAttivo });
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'bloccato', value: bloccato });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('user', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function user_countAll(testuale, bAttivo, bloccato) {
			if (typeof bAttivo == 'undefined') { bAttivo = 1; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof bloccato == 'undefined') { bloccato = 0; }
			var params = [];
			params.push({ name: 'bAttivo', value: bAttivo });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'bloccato', value: bloccato });

			var data = getAllByParams('user', 'CountByFilter', params);
			return $q.when(data);
		}

		function user_createNewAccount(item) {
			var objName = 'user';
			var action = 'CreateNewAccount';
			return $http.post(urlAPI + '/' + objName + '/' + action, item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function user_get(id) {
			var data = getById('user', id);
			return $q.when(data);
		}

		function user_add(item) {
			console.log("user_add(item)");
			//console.dir(item);

			var data = addObj('user', item);
			return $q.when(data);
		}

		function user_update(item) {
			var data = updateObj('user', item);
			return $q.when(data);
		}

		function user_exists(username, email, userId) {
			if (typeof username == 'undefined') { username = ''; }
			if (typeof email == 'undefined') { email = ''; }
			if (typeof userId == 'undefined') { userId = 0; }

			var params = [];
			params.push({ name: 'username', value: username });
			params.push({ name: 'email', value: email });
			params.push({ name: 'userId', value: userId });

			var data = getAllByParams('User', 'ExistsUsername', params);
			return $q.when(data);
		}

		function user_setPassword(item) {
			var objName = 'user';
			var action = 'SetPassword';
			return $http.put(urlAPI + '/' + objName + '/' + action, item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function user_activate(id) {
			var url = urlAPI + '/user/activate?id=' + id;
			return $http.post(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed activate for user: %s', message);
					return message.status;
				});
		}

		function user_deactivate(id) {
			var url = urlAPI + '/user/deactivate?id=' + id;
			return $http.post(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed deactivate for user: %s', message);
					return message.status;
				});
		}

		function user_resetPassword(username) {
			var url = urlAPI + '/user/resetpassword?username=' + username;
			return $http.post(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed Reset Password for user: %s', message);
					return message.status;
				});
		}

		function user_invioCredenziali(username) {
			var url = urlAPI + '/user/invioCredenziali?username=' + username;
			return $http.post(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed Reset Password for user: %s', message);
					return message.status;
				});
		}

		function user_GeneraPassword(id) {
			if (typeof id == 'undefined') { id = 0; }

			var url = urlAPI + '/User/GeneraPassword?id=' + id;
			return $http.post(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed GeneraObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function user_UnlockAccount(item) {
			return $http.put(urlAPI + '/User/UnlockAccount', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed UnlockAccountObj for %s: %s', objName, message);
					return message.status;
				});
		}

        /*
		function user_delete(id) {
		    console.log("deleteUser(%s)", id);

		    var data = deleteObj('user', id);
		    return $q.when(data);
		}
        */

		// ******************************
		//  ROLE   
		function role_getAllList() {
			var objName = 'user';
			var actionName = 'GetAllListRoles';
			return $http.get(urlAPI + '/' + objName + '/' + actionName)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getAllList for %s: %s', objName, message);
					return message.status;
				});
		}

		function role_getAll(nome) {
			if (typeof nome == 'undefined') { nome = ''; }

			var params = [];
			params.push({ name: 'nome', value: nome });

			var data = getAllByParams('user', 'GetAllRoles', params);
			return $q.when(data);
		}

		/*function role_getAll() {
			var objName = 'user';
			var actionName = 'GetAllRoles';
			var url = urlAPI + '/' + objName + '/' + actionName;
			return $http.get(url)
									.then(function (response) {
										return response.data;
									})
									.catch(function (message) {
									    console.info('XHR Failed role_getAll for %s: %s', objName, message);
										return message.status;
									});
		}*/

		function role_get(id) {
			var objName = 'user';
			var actionName = 'GetRole';
			var url = urlAPI + '/' + objName + '/' + actionName + '/' + id;

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getAll for %s: %s', objName, message);
					return message.status;
				});
		}

		function role_getDto(id) {
			var objName = 'user';
			var actionName = 'Role_GetDto';
			var url = urlAPI + '/' + objName + '/' + actionName + '/' + id;

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed role_getDto for %s: %s', objName, message);
					return message.status;
				});
		}

		function role_getAllUser(pageSize, page, nome, roleId, userId, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof userId == 'undefined') { userId = 0; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'userId', value: userId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('user', 'Role_GetAllUserByFilter', params);
			return $q.when(data);
		}

		function role_countAllUser(nome, roleId, userId) {
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof userId == 'undefined') { userId = 0; }

			var params = [];
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'userId', value: userId });

			var data = getAllByParams('user', 'Role_CountUserByFilter', params);
			return $q.when(data);
		}

		function role_add(item) {
			var objName = 'user';
			var action = 'Role_Post';
			return $http.post(urlAPI + '/' + objName + '/' + action, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed role_addObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function role_update(item) {
			var objName = 'user';
			var action = 'Role_Put';
			return $http.put(urlAPI + '/' + objName + '/' + action, item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed role_updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function role_delete(id) {
			var actionName = 'Role_Delete';

			var data = $http.delete(urlAPI + '/User/' + actionName + '/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed role_deleteObj for %s: %s', objName, message);
					return message.status;
				});
			return $q.when(data);
		}

		function roleUser_add(roleId, userId) {
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof userId == 'undefined') { userId = 0; }

			var params = [];
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'userId', value: userId });

			var objName = 'user';
			var actionName = 'RoleUser_Add';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?'
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;

			}
			return $http.post(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed addObj for %s: %s', objName, message);
					return message.status;
				});

		}

		function roleUser_delete(roleId, userId) {
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof userId == 'undefined') { userId = 0; }

			var params = [];
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'userId', value: userId });

			var objName = 'user';
			var actionName = 'RoleUser_Delete';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?'
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.delete(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed deleteObj for %s: %s', objName, message);
					return message.status;
				});
		}

	    /*
        questo metodo cancella fisicamente i record da 
            - dbo.Att_TAttachVisibility
            - dbo.WEB_RolesAuthorizations
            - dbo.WEB_UsersInRole
        funziona solo quando uno dei due � diverso da zero e l'altro � zero
        */
		function deleteChildrenOfRoleIdOrUserId(roleId, tAttachId) {
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof tAttachId == 'undefined') { tAttachId = 0; }

			var params = [];
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'tAttachId', value: tAttachId });

			var objName = 'user';
			var actionName = 'DeleteChildren';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?'
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.delete(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed deleteChildrenObj for %s: %s', objName, message);
					return message.status;
				});
		}



		// ******************************
		//  USER ROLE  
		function userRole_getAll(id) {
			var objName = 'user';
			var actionName = 'GetUserRoles';
			var url = urlAPI + '/' + objName + '/' + actionName + '/' + id;

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getAll for %s: %s', objName, message);
					return message.status;
				});
		}

		function userRole_add(risorsaId, roleId) {
			if (typeof risorsaId == 'undefined') { risorsaId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }

			var params = [];
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'roleId', value: roleId });

			var objName = 'user';
			var actionName = 'AddUserRole';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?'
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;

			}
			return $http.post(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed addObj for %s: %s', objName, message);
					return message.status;
				});

		}

		function userRole_delete(risorsaId, roleId) {
			if (typeof risorsaId == 'undefined') { risorsaId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }

			var params = [];
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'roleId', value: roleId });

			var objName = 'user';
			var actionName = 'DeleteUserRole';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?'
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.delete(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed deleteObj for %s: %s', objName, message);
					return message.status;
				});
		}

		// QUERY
		function query_getAllByFilter(pageSize, page, nominativo, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof order == 'undefined') { order = 'alfabetico'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('query', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function query_countByFilter(nominativo) {
			if (typeof nominativo == 'undefined') { nominativo = ''; }

			var params = [];
			params.push({ name: 'nominativo', value: nominativo });

			var data = getAllByParams('query', 'CountByFilter', params);

			return $q.when(data);
		}

		function queryEntity_download(id, queryParams) {
			if (typeof id == 'undefined') { id = 0; }
			if (typeof queryParams == 'undefined') { queryParams = []; }

			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'queryParams', value: queryParams });

			var objName = 'query';
			var actionName = 'Download';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?'
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed Exec for %s: %s', objName, message);
					return message.status;
				});
			/*
			var data = getAllByParam('query', 'Download', 'id', id);

			return $q.when(data);
			*/
		}

		function queryEntity_getAllByFilter(pageSize, page, id, queryParams) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof id == 'undefined') { id = 0; }
			if (typeof queryParams == 'undefined') { queryParams = []; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'id', value: id });
			params.push({ name: 'queryParams', value: queryParams });

			var objName = 'query';
			var actionName = 'Entity_GetAllByPage';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?'
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.post(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed Exec for %s: %s', objName, message);
					return message.status;
				});
		}

		function queryEntity_countByFilter(id, queryParams) {
			if (typeof id == 'undefined') { id = ''; }
			if (typeof queryParams == 'undefined') { queryParams = []; }

			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'queryParams', value: queryParams });

			var objName = 'query';
			var actionName = 'Entity_CountAll';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?'
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed Exec for %s: %s', objName, message);
					return message.status;
				});
			/*
					var data = getAllByParams('query', 'Entity_CountAll', params);

					return $q.when(data);
					*/
		}

		// NOTIFICATION
		function notification_getAllByFilter(pageSize, page, onlyActive, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof onlyActive == 'undefined') { onlyActive = true; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'onlyActive', value: onlyActive });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('notification', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function notification_countByFilter(onlyActive) {
			if (typeof onlyActive == 'undefined') { onlyActive = true; }
			var params = [];
			params.push({ name: 'onlyActive', value: onlyActive });

			var data = getAllByParams('notification', 'CountByFilter', params);

			return $q.when(data);
		}

        //Metodi per BACKOFFICE
		function notification_getAll(pageSize, page, testuale, onlyActive, bRead, bHome, iSistema, order) {
            if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
            if (typeof page == 'undefined') { page = 1; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof onlyActive == 'undefined') { onlyActive = true; }
            if (typeof bRead == 'undefined') { bRead = 0; }
            if (typeof bHome == 'undefined') { bHome = 0; }
            if (typeof iSistema == 'undefined') { iSistema = 0; }
            if (typeof order == 'undefined') { order = 'data'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'onlyActive', value: onlyActive });
            params.push({ name: 'bRead', value: bRead });
            params.push({ name: 'bHome', value: bHome });
            params.push({ name: 'iSistema', value: iSistema });
            params.push({ name: 'order', value: order });

			var data = getAllByParams('notification', 'GetAll', params);
			return $q.when(data);
		}

		function notification_countAll(testuale, onlyActive, bRead, bHome, iSistema) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof onlyActive == 'undefined') { onlyActive = true; }
            if (typeof bRead == 'undefined') { bRead = 0; }
            if (typeof bHome == 'undefined') { bHome = 0; }
            if (typeof iSistema == 'undefined') { iSistema = 0; }
            var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'onlyActive', value: onlyActive });
            params.push({ name: 'bRead', value: bRead });
            params.push({ name: 'bHome', value: bHome });
            params.push({ name: 'iSistema', value: iSistema });

			var data = getAllByParams('notification', 'CountAll', params);

			return $q.when(data);
		}

		function notification_getDto(id) {
			var actionName = 'GetDto';
			return $http.get(urlAPI + '/Notification/' + actionName + '/' + id)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed notification_getDto for %s: %s', objName, message);
					return message.status;
				});
		}

		function notification_add(item) {
			var action = 'Post';
			return $http.post(urlAPI + '/Notification/' + action, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed notification_add for %s: %s', objName, message);
					return message.status;
				});
		}

		function notification_update(item) {
			var action = 'Put';
			return $http.put(urlAPI + '/Notification/' + action, item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed notification_update for %s: %s', objName, message);
					return message.status;
				});
		}

		function notification_delete(id) {
			var actionName = 'Delete';

			var data = $http.delete(urlAPI + '/Notification/' + actionName + '/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed notification_delete for %s: %s', objName, message);
					return message.status;
				});
			return $q.when(data);
		}

		// ******************************
		//  NOTIFICATION VISIBILITY - NUOVI METODI

		function notificationVisibility_getAll(notificationId, roleId, userId) {
			if (typeof notificationId == 'undefined') { notificationId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof userId == 'undefined') { userId = 0; }

			var params = [];
			params.push({ name: 'notificationId', value: notificationId });
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'userId', value: userId });

			var objName = 'notification';
			var actionName = 'notificationVisibility_GetAllByFilter';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?'
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;

			}

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getAll for %s: %s', objName, message);
					return message.status;
				});
		}

		function notificationVisibility_add(item) {
			var objName = 'notification';
			var actionName = 'notificationVisibility_Add';

			return $http.post(urlAPI + '/' + objName + '/' + actionName, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed notificationVisibility_add for %s: %s', objName, message);
					return message.status;
				});

		}

		function notificationVisibility_update(item) {
			var objName = 'notification';
			var actionName = 'notificationVisibility_Update';

			return $http.put(urlAPI + '/' + objName + '/' + actionName, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed notificationVisibility_update for %s: %s', objName, message);
					return message.status;
				});

		}

		function notificationVisibility_delete(id) {
			var objName = 'notification';
			var actionName = 'notificationVisibility_Delete';
			var url = urlAPI + '/' + objName + '/' + actionName + '/' + id;

			return $http.delete(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed notificationVisibility_delete for %s: %s', objName, message);
					return message.status;
				});
		}

		// ******************************
		//  NOTIFICATION USER - NUOVI METODI

		function notificationUser_getAll(notificationId, dtRead) {
			if (typeof notificationId == 'undefined') { notificationId = 0; }
			if (typeof dtRead == 'undefined') { dtRead = ""; }

			var params = [];
			params.push({ name: 'notificationId', value: notificationId });
			params.push({ name: 'dtRead', value: dtRead });

			var objName = 'notification';
			var actionName = 'notificationUser_GetAllByFilter';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?'
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;

			}

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getAll for %s: %s', objName, message);
					return message.status;
				});
		}



		function notificationUser_push(notificationId) {
			if (typeof notificationId == 'undefined') { notificationId = 0; }

			var item = {};
			item.NotificationId = notificationId;

			var objName = 'notification';
			var actionName = 'notificationUser_Push';

			return $http.post(urlAPI + '/' + objName + '/' + actionName, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed notificationUser_add for %s: %s', objName, message);
					return message.status;
				});

		}

		function notificationUser_update(notificationId) {
			if (typeof notificationId == 'undefined') { notificationId = 0; }

			var params = [];
			params.push({ name: 'notificationId', value: notificationId });

			var objName = 'notification';
			var actionName = 'notificationUser_Update';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?'
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.put(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed notificationUser_update for %s: %s', objName, message);
					return message.status;
				});

		}

		function notificationUser_delete(id) {
			if (typeof id == 'undefined') { id = 0; }
			var objName = 'notification';
			var actionName = 'notificationUser_Delete';

			return $http.delete(urlAPI + '/' + objName + '/' + actionName + '/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed notificationUser_delete for %s: %s', objName, message);
					return message.status;
				});
		}

		//--DOWNLOAD
		function download_getAllByFilter(pageSize, page, onlyActive, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof onlyActive == 'undefined') { onlyActive = true; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'onlyActive', value: onlyActive });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('download', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function download_countByFilter(onlyActive) {
			if (typeof onlyActive == 'undefined') { onlyActive = true; }
			var params = [];
			params.push({ name: 'onlyActive', value: onlyActive });

			var data = getAllByParams('download', 'CountByFilter', params);

			return $q.when(data);
		}


		function download_getAll(pageSize, page, onlyActive, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof onlyActive == 'undefined') { onlyActive = true; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'onlyActive', value: onlyActive });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('Download', 'GetAll', params);
			return $q.when(data);
		}

		function download_countAll(onlyActive) {
			if (typeof onlyActive == 'undefined') { onlyActive = true; }
			var params = [];
			params.push({ name: 'onlyActive', value: onlyActive });

			var data = getAllByParams('Download', 'CountAll', params);

			return $q.when(data);
		}

		function download_getDto(id) {
			var actionName = 'GetDto';
			return $http.get(urlAPI + '/Download/' + actionName + '/' + id)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed download_getDto for %s: %s', objName, message);
					return message.status;
				});
		}

		function download_add(item) {
			var action = 'Post';
			return $http.post(urlAPI + '/Download/' + action, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed download_add for %s: %s', objName, message);
					return message.status;
				});
		}

		function download_update(item) {
			var action = 'Put';
			return $http.put(urlAPI + '/Download/' + action, item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed download_update for %s: %s', objName, message);
					return message.status;
				});
		}

		function download_delete(id) {
			var actionName = 'Delete';

			var data = $http.delete(urlAPI + '/Download/' + actionName + '/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed download_delete for %s: %s', objName, message);
					return message.status;
				});
			return $q.when(data);
		}

		// ******************************
		//  DOWNLOAD VISIBILITY - NUOVI METODI

		function downloadVisibility_getAll(downloadId, roleId) {
			if (typeof downloadId == 'undefined') { downloadId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }

			var params = [];
			params.push({ name: 'downloadId', value: downloadId });
			params.push({ name: 'roleId', value: roleId });

			var objName = 'download';
			var actionName = 'downloadVisibility_GetAllByFilter';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?'
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;

			}

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getAll for %s: %s', objName, message);
					return message.status;
				});
		}

		function downloadVisibility_addRole(downloadId, roleId) {
			if (typeof downloadId == 'undefined') { downloadId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }

			var item = {};
			item.downloadId = downloadId;
			item.RoleId = roleId;

			var objName = 'download';
			var actionName = 'downloadVisibility_AddRole';

			return $http.post(urlAPI + '/' + objName + '/' + actionName, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed downloadVisibility_addRole for %s: %s', objName, message);
					return message.status;
				});

		}

		function downloadVisibility_updateRole(downloadId, roleId) {
			if (typeof downloadId == 'undefined') { downloadId = ''; }
			if (typeof roleId == 'undefined') { roleId = 0; }

			var params = [];
			params.push({ name: 'downloadId', value: downloadId });
			params.push({ name: 'roleId', value: roleId });

			var item = {};
			item.downloadId = downloadId;
			item.RoleId = roleId;

			var objName = 'download';
			var actionName = 'downloadVisibility_UpdateRole';

			return $http.post(urlAPI + '/' + objName + '/' + actionName, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed downloadVisibility_updateRole for %s: %s', objName, message);
					return message.status;
				});

		}

		function downloadVisibility_deleteRole(downloadId, roleId) {
			if (typeof downloadId == 'undefined') { downloadId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }

			var params = [];
			params.push({ name: 'downloadId', value: downloadId });
			params.push({ name: 'roleId', value: roleId });

			var objName = 'download';
			var actionName = 'downloadVisibility_RemoveRole';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?'
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.delete(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed downloadVisibility_deleteRole for %s: %s', objName, message);
					return message.status;
				});
		}


		// ******************************
		// TRACCIATO

		function tracciato_export(iExport, dtExport, forcedElab) {
			if (typeof iExport == 'undefined') { iExport = 0; }
			if (typeof dtExport == 'undefined') { dtExport = ''; }
			if (typeof forcedElab == 'undefined') { forcedElab = false; }

			var params = [];
			params.push({ name: 'iExport', value: iExport });
			params.push({ name: 'dtExport', value: dtExport });
			params.push({ name: 'forcedElab', value: forcedElab });

			var data = getAllByParams('tracciato', 'Export', params);
			return $q.when(data);
		}

		function tracciato_resetExp(iExport) {
			if (typeof iExport == 'undefined') { iExport = 0; }

			var params = [];
			params.push({ name: 'iExport', value: iExport });

			var data = getAllByParams('tracciato', 'ResetExp', params);
			return $q.when(data);
		}

		// ******************************
		//  ACCREDITAMENTO
		function cndAccreditamento_getAllList(nome, provinciaId) {
			if (typeof nome == 'undefined') { nome = ''; }
			//if (typeof bAttivo == 'undefined') { bAttivo = 0; }
			//if (typeof bCompleted == 'undefined') { bCompleted = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			//if (typeof bSuspended == 'undefined') { bSuspended = -1; }

			var params = [];
			params.push({ name: 'nome', value: nome });
			//params.push({ name: 'bAttivo', value: bAttivo });
			//params.push({ name: 'bCompleted', value: bCompleted });
			params.push({ name: 'provinciaId', value: provinciaId });
			//params.push({ name: 'bSuspended', value: bSuspended });

			var data = getAllByParams('cndAccreditamento', 'GetAllList', params);

			return $q.when(data);
		}

		function cndAccreditamento_getAllMemberDidList(nome, provinciaId) {
			var params = [];
			params.push({ name: 'nome', value: '' });
			params.push({ name: 'provinciaId', value: 0 });

			var data = getAllByParams('cndAccreditamento', 'GetAllListByFilter', params);

			return $q.when(data);
		}

		function cndAccreditamento_getAllNoMemberDidList(nome, provinciaId) {
			var params = [];
			params.push({ name: 'nome', value: '' });
			params.push({ name: 'provinciaId', value: 0 });

			var data = getAllByParams('cndAccreditamento', 'GetAllListByFilter', params);

			return $q.when(data);
		}

		function cndAccreditamento_getAll(pageSize, page, isWhole, azienda, atecoId, formaGiuridicaId, provinciaId, bSuspended, email, codiceFiscale, iStato, progettoId, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof isWhole == 'undefined') { isWhole = 0; }
			//if (typeof bAttivo == 'undefined') { bAttivo = 0; }
			//if (typeof bCompleted == 'undefined') { bCompleted = 0; }
			if (typeof azienda == 'undefined') { azienda = ''; }
			if (typeof atecoId == 'undefined') { atecoId = 0; }
			if (typeof formaGiuridicaId == 'undefined') { formaGiuridicaId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof bSuspended == 'undefined') { bSuspended = -1; }
			if (typeof email == 'undefined') { email = ''; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }
			if (typeof progettoId == 'undefined') { progettoId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'isWhole', value: isWhole });
			//params.push({ name: 'bAttivo', value: bAttivo });
			//params.push({ name: 'bCompleted', value: bCompleted });
			params.push({ name: 'azienda', value: azienda });
			params.push({ name: 'atecoId', value: atecoId });
			params.push({ name: 'formaGiuridicaId', value: formaGiuridicaId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'bSuspended', value: bSuspended });
			params.push({ name: 'email', value: email });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'iStato', value: iStato });
			params.push({ name: 'progettoId', value: progettoId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('cndAccreditamento', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function cndAccreditamento_countAll(isWhole, azienda, atecoId, formaGiuridicaId, provinciaId, bSuspended, email, codiceFiscale, iStato, progettoId) {
			if (typeof isWhole == 'undefined') { isWhole = 0; }
			//if (typeof bAttivo == 'undefined') { bAttivo = 0; }
			//if (typeof bCompleted == 'undefined') { bCompleted = 0; }
			if (typeof azienda == 'undefined') { azienda = ''; }
			if (typeof atecoId == 'undefined') { atecoId = 0; }
			if (typeof formaGiuridicaId == 'undefined') { formaGiuridicaId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof bSuspended == 'undefined') { bSuspended = -1; }
			if (typeof email == 'undefined') { email = ''; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }
			if (typeof progettoId == 'undefined') { progettoId = 0; }


			var params = [];
			params.push({ name: 'isWhole', value: isWhole });
			//params.push({ name: 'bAttivo', value: bAttivo });
			//params.push({ name: 'bCompleted', value: bCompleted });
			params.push({ name: 'azienda', value: azienda });
			params.push({ name: 'atecoId', value: atecoId });
			params.push({ name: 'formaGiuridicaId', value: formaGiuridicaId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'bSuspended', value: bSuspended });
			params.push({ name: 'email', value: email });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'iStato', value: iStato });
			params.push({ name: 'progettoId', value: progettoId });

			var data = getAllByParams('cndAccreditamento', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndAccreditamento_exists(cndAccreditamentoId, codiceFiscale, piva, ipa, progettoId) {
			if (typeof cndAccreditamentoId == 'undefined') { cndAccreditamentoId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof piva == 'undefined') { piva = ''; }
			if (typeof ipa == 'undefined') { ipa = ''; }
			if (typeof progettoId == 'undefined') { progettoId = 0; }
			var params = [];
			params.push({ name: 'cndAccreditamentoId', value: cndAccreditamentoId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'piva', value: piva });
			params.push({ name: 'ipa', value: ipa });
			params.push({ name: 'progettoId', value: progettoId });

			var data = getAllByParams('cndAccreditamento', 'Exists', params);
			return $q.when(data);
		}

		function cndAccreditamento_getByUsername() {
			var data = getAllNoParam('cndAccreditamento', 'GetByUsername');
			return $q.when(data);
		}

		function cndAccreditamento_get(id) {
			var data = getById('cndAccreditamento', id);
			return $q.when(data);
		}

		function cndAccreditamento_getByUID(uid, progettoUID) {
			var params = [];
			params.push({ name: 'Uid', value: uid });
			params.push({ name: 'progettoUID', value: progettoUID });

			var data = getAllByParams('cndAccreditamento', 'GetByUID', params);
			return $q.when(data);
		}

		function cndAccreditamento_unlock(item) {
			var objName = 'cndAccreditamento';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndAccreditamento_setStatus(item) {
			var objName = 'cndAccreditamento';

			return $http.put(urlAPI + '/' + objName + '/SetStatus', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndAccreditamento_printPDFAll(progettoUId, accredUId, index) {
			var params = [];
			params.push({ name: 'progettoUId', value: progettoUId });
			params.push({ name: 'accredUId', value: accredUId });
			params.push({ name: 'index', value: index });
			var data = getAllByParams('cndAccreditamento', 'GetAllegato', params);
			return $q.when(data);
		}

		function cndAccreditamento_findPDFAll(UId, progettoUID, index) {
			var params = [];
			params.push({ name: 'UId', value: UId });
			params.push({ name: 'progettoUID', value: progettoUID });
			params.push({ name: 'index', value: index });
			var data = getAllByParams('cndAccreditamento', 'FindAllegato', params);
			return $q.when(data);
		}

		function cndAccreditamento_printRicevuta(progettoUId, accredUId) {
			var params = [];
			params.push({ name: 'progettoUId', value: progettoUId });
			params.push({ name: 'accredUId', value: accredUId });
			var data = getAllByParams('cndAccreditamento', 'PrintRicevuta', params);
			return $q.when(data);
		}



		function cndAccreditamento_add(item) {
			var data = addObj('cndAccreditamento', item);
			return $q.when(data);
		}

		function cndAccreditamento_update(item) {
			var data = updateObj('cndAccreditamento', item);
			return $q.when(data);
		}

		function cndAccreditamento_delete(id) {
			var data = deleteObj('cndAccreditamento', id);
			return $q.when(data);
		}

		function cndAccreditamento_setAnnulled(id, locked, noteAnnulled) {
			if (typeof noteAnnulled == 'undefined') { noteAnnulled = ''; }
			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'locked', value: locked });
			params.push({ name: 'noteAnnulled', value: noteAnnulled });

			var data = getAllByParams('cndAccreditamento', 'SetAnnulled', params);
			return $q.when(data);
		}

		// ******************************
		//  CNDAccreditamento SEDI
		function cndAccreditamentoSede_getAllList(nominativo, cndProgettoId, cndAccreditamentoId, provinciaId, comuneId) {
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof cndProgettoId == 'undefined') { cndProgettoId = 0; }
			if (typeof cndAccreditamentoId == 'undefined') { cndAccreditamentoId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }

			var params = [];
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'cndProgettoId', value: cndProgettoId });
			params.push({ name: 'cndAccreditamentoId', value: cndAccreditamentoId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'comuneId', value: comuneId });

			var data = getAllByParams('cndAccreditamentoSede', 'GetAllList', params);
			return $q.when(data);
		}

		function cndAccreditamentoSede_getAll(pageSize, page, nominativo, cndProgettoId, cndAccreditamentoId, provinciaId, comuneId, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof cndProgettoId == 'undefined') { cndProgettoId = 0; }
			if (typeof cndAccreditamentoId == 'undefined') { cndAccreditamentoId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'cndProgettoId', value: cndProgettoId });
			params.push({ name: 'cndAccreditamentoId', value: cndAccreditamentoId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'comuneId', value: comuneId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('cndAccreditamentoSede', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function cndAccreditamentoSede_countAll(nominativo, cndProgettoId, cndAccreditamentoId, provinciaId, comuneId) {
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof cndProgettoId == 'undefined') { cndProgettoId = 0; }
			if (typeof cndAccreditamentoId == 'undefined') { cndAccreditamentoId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }

			var params = [];
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'cndProgettoId', value: cndProgettoId });
			params.push({ name: 'cndAccreditamentoId', value: cndAccreditamentoId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'comuneId', value: comuneId });

			var data = getAllByParams('cndAccreditamentoSede', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndAccreditamentoSede_get(id) {
			var data = getById('cndAccreditamentoSede', id);
			return $q.when(data);
		}

		function cndAccreditamentoSede_add(item) {
			var data = addObj('cndAccreditamentoSede', item);
			return $q.when(data);
		}

		function cndAccreditamentoSede_update(item) {
			var data = updateObj('cndAccreditamentoSede', item);
			return $q.when(data);
		}

		function cndAccreditamentoSede_delete(id) {
			var data = deleteObj('cndAccreditamentoSede', id);
			return $q.when(data);
		}

		function cndAccreditamentoSede_exists(cndProgettoId, cndAccreditamentoId, comuneId) {
			if (typeof cndProgettoId == 'undefined') { cndProgettoId = 0; }
			if (typeof cndAccreditamentoId == 'undefined') { cndAccreditamentoId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }

			var params = [];
			params.push({ name: 'cndProgettoId', value: cndProgettoId });
			params.push({ name: 'cndAccreditamentoId', value: cndAccreditamentoId });
			params.push({ name: 'comuneId', value: comuneId });

			var data = getAllByParams('cndAccreditamentoSede', 'Exists', params);
			return $q.when(data);
		}

		// ******************************
		//  DomandaAdesione
		function cndDomandaAdesione_getAllList(nominativo, nascComuneId) {
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof nascComuneId == 'undefined') { nascComuneId = -1; }

			var params = [];
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'nascComuneId', value: nascComuneId });

			var data = getAllByParams('cndDomandaAdesione', 'GetAllList', params);

			return $q.when(data);
		}

		function cndDomandaAdesione_getAll(pageSize, page, nominativo, nascComuneId, email, codiceFiscale, iStato, cpiId, progettoId, iProfilo, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof nascComuneId == 'undefined') { nascComuneId = -1; }
			if (typeof email == 'undefined') { email = ''; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof progettoId == 'undefined') { progettoId = 0; }
			if (typeof iProfilo == 'undefined') { iProfilo = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'nascComuneId', value: nascComuneId });
			params.push({ name: 'email', value: email });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'iStato', value: iStato });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'progettoId', value: progettoId });
			params.push({ name: 'iProfilo', value: iProfilo });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('cndDomandaAdesione', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function cndDomandaAdesione_countAll(nominativo, nascComuneId, email, codiceFiscale, iStato, cpiId, progettoId, iProfilo) {
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof nascComuneId == 'undefined') { nascComuneId = -1; }
			if (typeof email == 'undefined') { email = ''; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof progettoId == 'undefined') { progettoId = 0; }
			if (typeof iProfilo == 'undefined') { iProfilo = 0; }

			var params = [];
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'nascComuneId', value: nascComuneId });
			params.push({ name: 'email', value: email });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'iStato', value: iStato });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'progettoId', value: progettoId });
			params.push({ name: 'iProfilo', value: iProfilo });

			var data = getAllByParams('cndDomandaAdesione', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndDomandaAdesione_exists(domandaAdesioneId, codiceFiscale, progettoId) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof progettoId == 'undefined') { progettoId = 0; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'progettoId', value: progettoId });

			var data = getAllByParams('cndDomandaAdesione', 'Exists', params);
			return $q.when(data);
		}

		function cndDomandaAdesione_assign(codiceFiscale, cpiId) {
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }

			var params = [];
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'cpiId', value: cpiId });

			var data = getAllByParams('cndDomandaAdesione', 'Assign', params);
			return $q.when(data);
		}

		function cndDomandaAdesione_statusCF(codiceFiscale, cpiId) {
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }

			var params = [];
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'cpiId', value: cpiId });

			var data = getAllByParams('cndDomandaAdesione', 'StatusCF', params);
			return $q.when(data);
		}

		function cndDomandaAdesione_unlock(item) {
			var objName = 'cndDomandaAdesione';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndDomandaAdesione_setStatus(item) {
			var objName = 'cndDomandaAdesione';

			return $http.put(urlAPI + '/' + objName + '/SetStatus', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndDomandaAdesione_printPDFAll(progettoUId, adesUId, index) {
			var params = [];
			params.push({ name: 'progettoUId', value: progettoUId });
			params.push({ name: 'adesUId', value: adesUId });
			params.push({ name: 'index', value: index });
			var data = getAllByParams('cndDomandaAdesione', 'GetAllegato', params);
			return $q.when(data);
		}

		function cndDomandaAdesione_findPDFAll(UId, progettoUID, index) {
			var params = [];
			params.push({ name: 'UId', value: UId });
			params.push({ name: 'progettoUID', value: progettoUID });
			params.push({ name: 'index', value: index });
			var data = getAllByParams('cndDomandaAdesione', 'FindAllegato', params);
			return $q.when(data);
		}

		function cndDomandaAdesione_printRicevuta(progettoUId, accredUId) {
			var params = [];
			params.push({ name: 'progettoUId', value: progettoUId });
			params.push({ name: 'accredUId', value: accredUId });
			var data = getAllByParams('cndDomandaAdesione', 'PrintRicevuta', params);
			return $q.when(data);
		}

		function cndDomandaAdesione_get(id) {
			var data = getById('cndDomandaAdesione', id);
			return $q.when(data);
		}

		function cndDomandaAdesione_getByUID(Uid, progettoUID) {
			var params = [];
			params.push({ name: 'Uid', value: Uid });
			params.push({ name: 'progettoUID', value: progettoUID });

			var data = getAllByParams('cndDomandaAdesione', 'GetByUID', params);
			return $q.when(data);
		}

		function cndDomandaAdesione_add(item) {
			var data = addObj('cndDomandaAdesione', item);
			return $q.when(data);
		}

		function cndDomandaAdesione_update(item) {
			var data = updateObj('cndDomandaAdesione', item);
			return $q.when(data);
		}

		function cndDomandaAdesione_delete(id) {
			var data = deleteObj('cndDomandaAdesione', id);
			return $q.when(data);
		}

		function cndDomandaAdesione_setAnnulled(id, locked) {
			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'locked', value: locked });

			var data = getAllByParams('cndDomandaAdesione', 'SetAnnulled', params);
			return $q.when(data);
		}

		function cndDomandaAdesione_setFieldsISEE(item) {
			var objName = 'cndDomandaAdesione';

			return $http.put(urlAPI + '/' + objName + '/SetFieldsISEE', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}


		//*********************************
		//-- SEND LINK ACCESSO FROM EMAIL AND CODICE FISCALE
		function cndProgetto_sendLnkAccesso(progettoUID, email, codiceFiscale, tipoCandidatura) {
			var params = [];
			params.push({ name: 'progettoUID', value: progettoUID });
			params.push({ name: 'email', value: email });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'tipoCandidatura', value: tipoCandidatura });

			var data = getAllByParams('CNDProgetto', 'SendLnkAccesso', params);
			return $q.when(data);
		}


		// ******************************
		//  Progetto
		function cndProgetto_getAllList(testuale, code, iTipoCandidatura, _data) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof code == 'undefined') { code = ''; }
			if (typeof iTipoCandidatura == 'undefined') { iTipoCandidatura = 0; }
			if (typeof _data == 'undefined') { _data = ''; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'code', value: code });
			params.push({ name: 'iTipoCandidatura', value: iTipoCandidatura });
			params.push({ name: '_data', value: _data });

			var data = getAllByParams('CNDProgetto', 'GetAllList', params);

			return $q.when(data);
		}

		function cndProgetto_getAll(pageSize, page, testuale, code, iTipoCandidatura, _data, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof code == 'undefined') { code = ''; }
			if (typeof iTipoCandidatura == 'undefined') { iTipoCandidatura = 0; }
			if (typeof _data == 'undefined') { _data = ''; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'code', value: code });
			params.push({ name: 'iTipoCandidatura', value: iTipoCandidatura });
			params.push({ name: '_data', value: _data });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('CNDProgetto', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function cndProgetto_countAll(testuale, code, iTipoCandidatura, _data) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof code == 'undefined') { code = ''; }
			if (typeof iTipoCandidatura == 'undefined') { iTipoCandidatura = 0; }
			if (typeof _data == 'undefined') { _data = ''; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'code', value: code });
			params.push({ name: 'iTipoCandidatura', value: iTipoCandidatura });
			params.push({ name: '_data', value: _data });

			var data = getAllByParams('CNDProgetto', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndProgetto_get(id) {
			var data = getById('CNDProgetto', id);
			return $q.when(data);
		}

		function cndProgetto_getByUID(UID) {
			var objName = 'CNDProgetto';
			return $http.get(urlAPI + '/' + objName + '/GetByUID?UID=' + UID)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getByUID for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndProgetto_add(item) {
			var data = addObj('CNDProgetto', item);
			return $q.when(data);
		}

		function cndProgetto_update(item) {
			var data = updateObj('CNDProgetto', item);
			return $q.when(data);
		}

		function cndProgetto_delete(id) {
			var data = deleteObj('CNDProgetto', id);
			return $q.when(data);
		}

		// ******************************
		//  CND CV
		function cndCV_getAllList(domandaAdesioneId, nominativo) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'nominativo', value: nominativo });

			var data = getAllByParams('cndCV', 'GetAllList', params);

			return $q.when(data);
		}

		function cndCV_getAll(pageSize, page, domandaAdesioneId, nominativo, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('cndCV', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function cndCV_countAll(domandaAdesioneId, nominativo) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'nominativo', value: nominativo });

			var data = getAllByParams('cndCV', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndCV_get(id) {
			var data = getById('cndCV', id);
			return $q.when(data);
		}

		function cndCV_getByDomandaId(domandaId) {
			var objName = 'cndCV';
			return $http.get(urlAPI + '/' + objName + '/GetByDomandaId?domandaId=' + domandaId)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getByDomandaId for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndCV_getByDomandaUID(uid) {
			var objName = 'cndCV';
			return $http.get(urlAPI + '/' + objName + '/GetByDomandaUID?Uid=' + uid)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getByUID for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndCV_unlock(item) {
			var objName = 'cndCV';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndCV_printPDF(progettoUId, domandaUId) {
			var params = [];
			params.push({ name: 'progettoUId', value: progettoUId });
			params.push({ name: 'domandaUId', value: domandaUId });
			var data = getAllByParams('cndCV', 'GetAllegatoCV', params);
			return $q.when(data);
		}

		function cndCV_findCV(UId, progettoUID) {
			var params = [];
			params.push({ name: 'UId', value: UId });
			params.push({ name: 'progettoUID', value: progettoUID });
			var data = getAllByParams('cndCV', 'FindCV', params);
			return $q.when(data);
		}

		function cndCV_add(item) {
			var data = addObj('cndCV', item);
			return $q.when(data);
		}

		function cndCV_update(item) {
			var data = updateObj('cndCV', item);
			return $q.when(data);
		}

		function cndCV_delete(id) {
			var data = deleteObj('cndCV', id);
			return $q.when(data);
		}

		// ******************************
		//  CND CV Abilit
		function cndCVAbilit_getAllList(domandaAdesioneId, anno, mese, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVAbilit', 'GetAllList', params);

			return $q.when(data);
		}

		function cndCVAbilit_getAll(pageSize, page, domandaAdesioneId, anno, mese, bValide, bDelete, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('cndCVAbilit', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function cndCVAbilit_countAll(domandaAdesioneId, anno, mese, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVAbilit', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndCVAbilit_get(id) {
			var data = getById('cndCVAbilit', id);
			return $q.when(data);
		}

		function cndCVAbilit_add(item) {
			var data = addObj('cndCVAbilit', item);
			return $q.when(data);
		}

		function cndCVAbilit_update(item) {
			var data = updateObj('cndCVAbilit', item);
			return $q.when(data);
		}

		function cndCVAbilit_delete(id) {
			var data = deleteObj('cndCVAbilit', id);
			return $q.when(data);
		}

		// ******************************
		//  CND CV Corso
		function cndCVCorso_getAllList(domandaAdesioneId, anno, mese, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVCorso', 'GetAllList', params);

			return $q.when(data);
		}

		function cndCVCorso_getAll(pageSize, page, domandaAdesioneId, anno, mese, bValide, bDelete, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('cndCVCorso', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function cndCVCorso_countAll(domandaAdesioneId, anno, mese, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVCorso', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndCVCorso_get(id) {
			var data = getById('cndCVCorso', id);
			return $q.when(data);
		}

		function cndCVCorso_add(item) {
			var data = addObj('cndCVCorso', item);
			return $q.when(data);
		}

		function cndCVCorso_update(item) {
			var data = updateObj('cndCVCorso', item);
			return $q.when(data);
		}

		function cndCVCorso_delete(id) {
			var data = deleteObj('cndCVCorso', id);
			return $q.when(data);
		}

		// ******************************
		//  CND CV Servizio
		function cndCVServizio_getAllList(domandaAdesioneId, anno, mese, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVServizio', 'GetAllList', params);

			return $q.when(data);
		}

		function cndCVServizio_getAll(pageSize, page, domandaAdesioneId, anno, mese, bValide, bDelete, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('cndCVServizio', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function cndCVServizio_countAll(domandaAdesioneId, anno, mese, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVServizio', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndCVServizio_get(id) {
			var data = getById('cndCVServizio', id);
			return $q.when(data);
		}


		function cndCVServizio_saveAll(objValue) {
			var objName = 'cndCVServizio';
			return $http.post(urlAPI + '/' + objName + '/SaveAll', objValue)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndCVServizio_add(item) {
			var data = addObj('cndCVServizio', item);
			return $q.when(data);
		}

		function cndCVServizio_update(item) {
			var data = updateObj('cndCVServizio', item);
			return $q.when(data);
		}

		function cndCVServizio_delete(id) {
			var data = deleteObj('cndCVServizio', id);
			return $q.when(data);
		}

		// ******************************
		//  CND CV Pubb
		function cndCVPubb_getAllList(domandaAdesioneId, tipoPubbId, anno, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof tipoPubbId == 'undefined') { tipoPubbId = -1; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'tipoPubbId', value: tipoPubbId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVPubb', 'GetAllList', params);

			return $q.when(data);
		}

		function cndCVPubb_getAll(pageSize, page, domandaAdesioneId, tipoPubbId, anno, bValide, bDelete, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof tipoPubbId == 'undefined') { tipoPubbId = -1; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'tipoPubbId', value: tipoPubbId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('cndCVPubb', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function cndCVPubb_countAll(domandaAdesioneId, tipoPubbId, anno, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof tipoPubbId == 'undefined') { tipoPubbId = -1; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'tipoPubbId', value: tipoPubbId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVPubb', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndCVPubb_get(id) {
			var data = getById('cndCVPubb', id);
			return $q.when(data);
		}

		function cndCVPubb_add(item) {
			var data = addObj('cndCVPubb', item);
			return $q.when(data);
		}

		function cndCVPubb_update(item) {
			var data = updateObj('cndCVPubb', item);
			return $q.when(data);
		}

		function cndCVPubb_delete(id) {
			var data = deleteObj('cndCVPubb', id);
			return $q.when(data);
		}

		// ******************************
		//  CND CV Spec
		function cndCVSpec_getAllList(domandaAdesioneId, anno, mese, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVSpec', 'GetAllList', params);

			return $q.when(data);
		}

		function cndCVSpec_getAll(pageSize, page, domandaAdesioneId, anno, mese, bValide, bDelete, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('cndCVSpec', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function cndCVSpec_countAll(domandaAdesioneId, anno, mese, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVSpec', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndCVSpec_get(id) {
			var data = getById('cndCVSpec', id);
			return $q.when(data);
		}


		function cndCVSpec_saveAll(objValue) {
			var objName = 'cndCVSpec';
			return $http.post(urlAPI + '/' + objName + '/SaveAll', objValue)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndCVSpec_add(item) {
			var data = addObj('cndCVSpec', item);
			return $q.when(data);
		}

		function cndCVSpec_update(item) {
			var data = updateObj('cndCVSpec', item);
			return $q.when(data);
		}

		function cndCVSpec_delete(id) {
			var data = deleteObj('cndCVSpec', id);
			return $q.when(data);
		}

		// ******************************
		//  CND CV Idoneita
		function cndCVIdoneita_getAllList(domandaAdesioneId, anno, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVIdoneita', 'GetAllList', params);

			return $q.when(data);
		}

		function cndCVIdoneita_getAll(pageSize, page, domandaAdesioneId, anno, bValide, bDelete, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('cndCVIdoneita', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function cndCVIdoneita_countAll(domandaAdesioneId, anno, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVIdoneita', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndCVIdoneita_get(id) {
			var data = getById('cndCVIdoneita', id);
			return $q.when(data);
		}

		function cndCVIdoneita_add(item) {
			var data = addObj('cndCVIdoneita', item);
			return $q.when(data);
		}

		function cndCVIdoneita_update(item) {
			var data = updateObj('cndCVIdoneita', item);
			return $q.when(data);
		}

		function cndCVIdoneita_delete(id) {
			var data = deleteObj('cndCVIdoneita', id);
			return $q.when(data);
		}


		//*****************************************
		//--VALIDAZIONE CF E IBAN
		function validazione_cf(codiceFiscale, isEnte) {
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof isEnte == 'undefined') { isEnte = false; }

			var params = [];
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'isEnte', value: isEnte });

			var data = getAllByParams('Validazione', 'GetValidCF', params);
			return $q.when(data);
		}

		function validazione_piva(piva) {
			if (typeof piva == 'undefined') { piva = ''; }

			var params = [];
			params.push({ name: 'piva', value: piva });

			var data = getAllByParams('Validazione', 'GetValidPIVA', params);
			return $q.when(data);
		}

		function validazione_iban(iban) {
			if (typeof iban == 'undefined') { iban = ''; }

			var params = [];
			params.push({ name: 'iban', value: iban });

			var data = getAllByParams('Validazione', 'GetValidIBAN', params);
			return $q.when(data);
		}

		function validazione_fieldsCF(codiceFiscale, nome, cognome, sesso, dtNasc, paeseId, comuneId) {
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof cognome == 'undefined') { cognome = ''; }
			if (typeof sesso == 'undefined') { sesso = ''; }
			if (typeof dtNasc == 'undefined') { dtNasc = ''; }
			if (typeof paeseId == 'undefined') { paeseId = -1; }
			if (typeof comuneId == 'undefined') { comuneId = -1; }

			var params = [];
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'cognome', value: cognome });
			params.push({ name: 'sesso', value: sesso });
			params.push({ name: 'dtNasc', value: dtNasc });
			params.push({ name: 'paeseId', value: paeseId });
			params.push({ name: 'comuneId', value: comuneId });

			var data = getAllByParams('Validazione', 'GetValidFieldsCF', params);
			return $q.when(data);
		}


		//--ACCOUNT
		function account_getDaysValidityPassword() {
			return $http.get('/Account/ValidityPassword_GetLastDays')
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed lastDaysValidityPassword for %s: %s', message);
					return message.status;
				});
		}

		//-- PARAMS
		function params_get(tSourceCode, sourceId) {
			var objName = 'Params';
			var actionName = 'Get';
			var url = urlAPI + '/' + objName + '/' + actionName;

			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }

			var params = [];
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });



			var numParams = params.length;
			if (numParams > 0) {
				url += '?'
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getAllByParams for %s: %s', objName, message);
					return message.status;
				});

		}



		//-- RUOLO AMM
		function tRuoloAmm_get(id) {
			var data = getById('TRuoloAmm', id);
			return $q.when(data);
		}

		//-- RUOLO DID
		function tRuoloDid_get(id) {
			var data = getById('TRuoloDid', id);
			return $q.when(data);
		}

		// ******************************
		//--  TTirocinanteProfilo 
		function tTirocinanteProfilo_getAllList() {
			var data = getAllList('tTirocinanteProfilo');
			return $q.when(data);
		}

		function tTirocinanteProfilo_get(id) {
			var data = getById('tTirocinanteProfilo', id);
			return $q.when(data);
		}

		// ******************************
		//--  TProfiloDD
		function tProfiloDD_getAllList() {
			var data = getAllList('tProfiloDD');
			return $q.when(data);
		}

		function tProfiloDD_getAll() {
			var data = getAll('tProfiloDD');
			return $q.when(data);
		}

		function tProfiloDD_get(id) {
			var data = getById('tProfiloDD', id);
			return $q.when(data);
		}

		// ******************************
		//--  TTirocinio 
		function tTirocinio_getAllList() {
			var data = getAllList('tTirocinio');
			return $q.when(data);
		}

		function tTirocinio_get(id) {
			var data = getById('tTirocinio', id);
			return $q.when(data);
		}

		// ******************************
		//--  TTirocinioDLG 
		function tTirocinioDLG_getAllList() {
			var data = getAllList('tTirocinioDLG');
			return $q.when(data);
		}

		function tTirocinioDLG_get(id) {
			var data = getById('tTirocinioDLG', id);
			return $q.when(data);
		}

		// ******************************
		//--  TRuoloSoggetto
		function tRuoloSoggetto_getAll(tableName) {
			if (typeof tableName == 'undefined') { tableName = ''; }

			var params = [];
			params.push({ name: 'tableName', value: tableName });

			var data = getAllByParams('tRuoloSoggetto', 'GetAll', params);
			return $q.when(data);
		}

		function tRuoloSoggetto_get(id) {
			var data = getById('tRuoloSoggetto', id);
			return $q.when(data);
		}

		// ******************************
		//--  TLavoro 
		function tLavoro_getAllList(group) {
			if (typeof group == 'undefined') { group = ''; }

			var params = [];
			params.push({ name: 'group', value: group });

			var data = getAllByParams('tLavoro', 'GetAllList', params);
			return $q.when(data);
		}

		function tLavoro_get(id) {
			var data = getById('tLavoro', id);
			return $q.when(data);
		}

		// ******************************
		//-- TFormaGiuridica        
		function tFormaGiuridica_getAllList() {
			var data = getAllList('tFormaGiuridica');
			return $q.when(data);
		}

		function tFormaGiuridica_get(id) {
			var data = getById('tFormaGiuridica', id);
			return $q.when(data);
		}

		// ******************************
		//-- TAteco          
		function tAteco_getAllList() {
			var data = getAllList('tAteco');
			return $q.when(data);
		}

		function tAteco_get(id) {
			if (typeof id == 'undefined') { id = 0; }
			var data = getById('tAteco', id);
			return $q.when(data);
		}

		function tAteco_getByText(text) {
			var data = getAllByParam('tAteco', 'GetByText', 'text', text);
			return $q.when(data);
		}

		// ******************************
		//-- TTitoloStudio          
		function tTitoloStudio_getAllList() {
			var data = getAllList('tTitoloStudio');
			return $q.when(data);
		}

		function tTitoloStudio_get(id) {
			var data = getById('tTitoloStudio', id);
			return $q.when(data);
		}

		// ******************************
		//-- TCondizioneMercato          
		function tCondizioneMercato_getAllList() {
			var data = getAllList('tCondizioneMercato');
			return $q.when(data);
		}

		function tCondizioneMercato_get(id) {
			var data = getById('tCondizioneMercato', id);
			return $q.when(data);
		}

		// ******************************
		//-- TDurataRicerca          
		function tDurataRicerca_getAllList() {
			var data = getAllList('tDurataRicerca');
			return $q.when(data);
		}

		function tDurataRicerca_get(id) {
			var data = getById('tDurataRicerca', id);
			return $q.when(data);
		}

		// ******************************
		//-- TGruppoVulnerabilita          
		function tGruppoVulnerabilita_getAllList() {
			var data = getAllList('tGruppoVulnerabilita');
			return $q.when(data);
		}

		function tGruppoVulnerabilita_get(id) {
			var data = getById('tGruppoVulnerabilita', id);
			return $q.when(data);
		}

		// ******************************
		//-- TStatoPartecipante          
		function tStatoPartecipante_getAllList() {
			var data = getAllList('tStatoPartecipante');
			return $q.when(data);
		}

		function tStatoPartecipante_get(id) {
			var data = getById('tStatoPartecipante', id);
			return $q.when(data);
		}

		// ******************************
		//-- TCPI          
		function tCPI_getAllList() {
			var data = getAllList('tCPI');
			return $q.when(data);
		}

		function tCPI_getAll(title, aziendaId, provinciaId) {
			if (typeof title == 'undefined') { title = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }

			var params = [];
			params.push({ name: 'title', value: title });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'provinciaId', value: provinciaId });

			var data = getAllByParams('tCPI', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function tCPI_get(id) {
			var data = getById('tCPI', id);
			return $q.when(data);
		}

		// ******************************
		//-- TTirociniSpese         
		function tTirociniSpese_getAllList() {
			var data = getAllList('tTirocinioSpesa');
			return $q.when(data);
		}

		function tTirociniSpese_get(id) {
			var data = getById('tTirocinioSpesa', id);
			return $q.when(data);
		}

		// ******************************
		//-- ContenutoFormativo          
		function contenutoFormativo_getAllList() {
			var data = getAllList('contenutoFormativo');
			return $q.when(data);
		}

		function contenutoFormativo_get(id) {
			var data = getById('contenutoFormativo', id);
			return $q.when(data);
		}

		//------------------------------------------------------------------
		//-- EDUP
		//------------------------------------------------------------------

		//-- TEST
		function test_getAllList() {
			var data = getAllList('test');
			return $q.when(data);
		}

		function test_getAllListExclude(testId) {
			var objName = 'test';
			if (typeof testId == 'undefined') { testId = 0; }

			return $http.get(urlAPI + '/' + objName + '/GetAllListExclude?testId=' + testId)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed GetAllListExclude for %s: %s', objName, message);
					return message.status;
				});

			//return $q.when(data);
		}

		function test_count() {
			var data = getAllByParams('test', 'Count');
			return $q.when(data);
		}

		function test_countByFilter(testo) {
			if (typeof testo == 'undefined') { testo = ''; }
			var params = [];
			params.push({ name: 'testo', value: testo });

			var data = getAllByParams('test', 'CountByFilter', params);
			return $q.when(data);
		}

		function test_getAll() {
			var data = getAllNoParam('test', 'getAll');
			return $q.when(data);
		}

		function test_getAllByFilter(pageSize, page, testo, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof testo == 'undefined') { testo = ''; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testo', value: testo });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('test', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function test_get(id) {
			var data = getById('test', id);
			return $q.when(data);
		}

		function test_update(item) {
			var data = updateObj('Test', item);
			return $q.when(data);
		}

		function test_delete(id) {
			var data = deleteObj('test', id);
			return $q.when(data);
		}


		function test_add(item) {
			var data = addObj('test', item);
			return $q.when(data);
		}

		//-- question
		function question_getAllList() {
			var data = getAllList('question');
			return $q.when(data);
		}

		function question_getAllListInTest(testId) {
			var objName = 'question';
			if (typeof testId == 'undefined') { testId = 0; }

			return $http.get(urlAPI + '/' + objName + '/GetAllListInTest?testId=' + testId)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getAllList for %s: %s', objName, message);
					return message.status;
				});

			//return $q.when(data);
		}

		function question_getAllListNotInTest(testId) {
			var objName = 'question';
			if (typeof testId == 'undefined') { testId = 0; }

			return $http.get(urlAPI + '/' + objName + '/GetAllListNotInTest?testId=' + testId)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getAllList for %s: %s', objName, message);
					return message.status;
				});

			//return $q.when(data);
		}

		function question_count() {
			var data = getAllByParams('question', 'Count');
			return $q.when(data);
		}

		function question_countByFilter(testo) {
			if (typeof testo == 'undefined') { testo = ''; }
			var params = [];
			params.push({ name: 'testo', value: testo });

			var data = getAllByParams('question', 'CountByFilter', params);
			return $q.when(data);
		}

		function question_getAll() {
			var data = getAllNoParam('question', 'getAll');
			return $q.when(data);
		}

		function question_getAllByFilter(pageSize, page, testo, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof testo == 'undefined') { testo = ''; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testo', value: testo });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('question', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function question_getAllByTest(testId, order) {
			if (typeof testId == 'undefined') { testId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'testId', value: testId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('question', 'getAllByTest', params);
			return $q.when(data);
		}

		function question_get(id) {
			var data = getById('question', id);
			return $q.when(data);
		}

		function question_update(item) {
			var data = updateObj('question', item);
			return $q.when(data);
		}

		function question_delete(id) {
			var data = deleteObj('question', id);
			return $q.when(data);
		}

		function question_add(item) {
			var data = addObj('question', item);
			return $q.when(data);
		}

		function question_addToTest(item, testId) {
			var objName = 'questionTest';
			var method = 'AddQuestionToTest';

			if (typeof testId == 'undefined') { testId = 0; }
			if (typeof item == 'undefined') { item = {}; }

			var url = urlAPI + '/' + objName + '/' + method;

			item.testId = testId;


			return $http.post(url, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed question_addToTest for %s: %s', objName, message);
					return message.status;
				});

		    /*
            return addObj('question', item).then(function (data) {
                return questionTest_addByParams(testId, data.Id).then(function (data2) {
                });
                /*
                var data2 = questionTest_addByParams(testId, data.Id);
                var dataUnion = {};
                dataUnion.question = data;
                dataUnion.questionTest = data2;
                return $q.when(dataUnion);
                //
            });
            */
		}



		function question_upload(filename, file) {
			var objName = 'question';
			var method = 'Upload';

			if (typeof filename == 'undefined') { filename = ''; }
			if (typeof file == 'undefined') { file = {}; }

			var url = urlAPI + '/' + objName + '/' + method;

			var item = {};
			item.filename = filename;
			item.file = file;


			return $http.post(url, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed question_upload for %s: %s', objName, message);
					return message.status;
				});

		}


		function question_deleteFiles(filesList) {
			var objName = 'question';
			if (typeof filesList == 'undefined') { filesList = []; }

			var obj = {
				filesList: filesList
			}

			var url = urlAPI + '/' + objName + '/DeleteFiles';
			return $http.put(url, obj)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed DeleteFiles for %s: %s', objName, message);
					return message.status;
				});

		}

		//-- choice
		function choice_getAllList() {
			var data = getAllList('choice');
			return $q.when(data);
		}

		function choice_count() {
			var data = getAllByParams('choice', 'Count');
			return $q.when(data);
		}

		function choice_countByFilter(testo) {
			if (typeof testo == 'undefined') { testo = ''; }
			var params = [];
			params.push({ name: 'testo', value: testo });

			var data = getAllByParams('choice', 'CountByFilter', params);
			return $q.when(data);
		}

		function choice_getAll() {
			var data = getAllNoParam('choice', 'getAll');
			return $q.when(data);
		}

		function choice_getAllByQuestion(questionId, order) {
			if (typeof questionId == 'undefined') { questionId = 0; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'questionId', value: questionId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('choice', 'getAllByQuestion', params);
			return $q.when(data);
		}

		function choice_get(id) {
			var data = getById('choice', id);
			return $q.when(data);
		}

		function choice_add(item) {
			var data = addObj('choice', item);
			return $q.when(data);
		}

		function choice_upload(filename, file) {
			var objName = 'choice';
			var method = 'Upload';

			if (typeof filename == 'undefined') { filename = ''; }
			if (typeof file == 'undefined') { file = {}; }

			var url = urlAPI + '/' + objName + '/' + method;

			var item = {};
			item.filename = filename;
			item.file = file;


			return $http.post(url, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed choice_upload for %s: %s', objName, message);
					return message.status;
				});

		}

		function choice_update(item) {
			var data = updateObj('choice', item);
			return $q.when(data);
		}

		function choice_delete(id) {
			var data = deleteObj('choice', id);
			return $q.when(data);
		}

		//-- questionTest
		function questionTest_getAllList(testId) {
			var objName = 'questionTest';
			var action = 'GetAllList';
			if (typeof testId == 'undefined') { testId = 0; }

			return $http.get(urlAPI + '/' + objName + '/' + action + '/' + testId)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getAllList for %s: %s', objName, message);
					return message.status;
				});

			//return $q.when(data);
		}


		function questionTest_count() {
			var data = getAllByParams('questionTest', 'Count');
			return $q.when(data);
		}

		function questionTest_countByFilter(testo) {
			if (typeof testo == 'undefined') { testo = ''; }
			var params = [];
			params.push({ name: 'testo', value: testo });

			var data = getAllByParams('questionTest', 'CountByFilter', params);
			return $q.when(data);
		}

		function questionTest_getAll() {
			var data = getAllNoParam('questionTest', 'getAll');
			return $q.when(data);
		}

		function questionTest_getAllByFilter(pageSize, page, testo, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof testo == 'undefined') { testo = ''; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testo', value: testo });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('questionTest', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function questionTest_getAllByTest(testId, order) {
			if (typeof testId == 'undefined') { testId = 0; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'testId', value: testId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('questionTest', 'getAllByTest', params);
			return $q.when(data);
		}

		function questionTest_getAllByQuestion(testId, questionId, order) {
			if (typeof testId == 'undefined') { testId = 0; }
			if (typeof questionId == 'undefined') { questionId = 0; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'testId', value: testId });
			params.push({ name: 'questionId', value: questionId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('questionTest', 'getAllByQuestion', params);
			return $q.when(data);
		}

		function questionTest_get(id) {
			var data = getById('questionTest', id);
			return $q.when(data);
		}

		function questionTest_update(item) {
			var data = updateObj('questionTest', item);
			return $q.when(data);
		}


		function questionTest_changeSequence(orderList) {
			var objName = 'questionTest';
			if (typeof orderList == 'undefined') { orderList = []; }

			var obj = {
				orderList: orderList
			}

			var url = urlAPI + '/' + objName + '/ChangeSequence';
			return $http.put(url, obj)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed ChangeSequence for %s: %s', objName, message);
					return message.status;
				});

		}

		function questionTest_delete(id) {
			var data = deleteObj('questionTest', id);
			return $q.when(data);
		}

		function questionTest_add(item) {
			var data = addObj('questionTest', item);
			return $q.when(data);
		}

		function questionTest_importList(testId, questionsList) {
			var objName = 'questionTest';
			var method = 'ImportList';

			if (typeof testId == 'undefined') { testId = 0; }
			if (typeof questionsList == 'undefined') { questionsList = []; }

			var url = urlAPI + '/' + objName + '/' + method;

			var obj = {
				testId: testId,
				questionsList: questionsList
			}

			return $http.put(url, obj)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed ImportList for %s: %s', objName, message);
					return message.status;
				});
		}

		function questionTest_addByParams(testId, questionId) {
			var item = {};
			item.testId = testId;
			item.questionId = questionId;
			var data = addObj('questionTest', item);
			return $q.when(data);
		}


		//-- SESSION
		function session_getAllList() {
			var data = getAllList('session');
			return $q.when(data);
		}

		function session_count() {
			var data = getAllByParams('session', 'Count');
			return $q.when(data);
		}

		function session_countByFilter(bStato, testId, testo) {
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof testId == 'undefined') { testId = 0; }
			if (typeof testo == 'undefined') { testo = ''; }

			var params = [];
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'testId', value: testId });
			params.push({ name: 'testo', value: testo });

			var data = getAllByParams('session', 'CountByFilter', params);
			return $q.when(data);
		}

		function session_getAll() {
			var data = getAllNoParam('session', 'getAll');
			return $q.when(data);
		}

		function session_getAllByFilter(pageSize, page, bStato, testId, testo, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof testId == 'undefined') { testId = 0; }
			if (typeof testo == 'undefined') { testo = ''; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'testId', value: testId });
			params.push({ name: 'testo', value: testo });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('session', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function session_get(id) {
			var data = getById('session', id);
			return $q.when(data);
		}

		function session_add(item) {
			var data = addObj('session', item);
			return $q.when(data);
		}

		function session_update(item) {
			var data = updateObj('session', item);
			return $q.when(data);
		}

		function session_delete(id) {
			var data = deleteObj('session', id);
			return $q.when(data);
		}

		function session_activate(sessionId) {
			var objName = 'Session';
			var actionName = 'Activate';
			if (typeof sessionId == 'undefined') { sessionId = 0; }

			var url = urlAPI + '/' + objName + '/' + actionName + '?sessionId=' + sessionId;
			return $http.put(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed session_activate for %s: %s', objName, message);
					return message.status;
				});
		}

		function session_inactivate(sessionId) {
			var objName = 'Session';
			var actionName = 'Inactive';
			if (typeof sessionId == 'undefined') { sessionId = 0; }

			var url = urlAPI + '/' + objName + '/' + actionName + '?sessionId=' + sessionId;
			return $http.put(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed session_inactivate for %s: %s', objName, message);
					return message.status;
				});
		}

		//-- SESSIONSTUDENTE
		function studenteSession_getAllList(sessionId) {
			var data = getAllByParam('studenteSession', 'GetAllList', 'sessionId', sessionId);
			return $q.when(data);
		}

		function studenteSession_addList(sessionId, studentiList) {
			var objName = 'studenteSession';
			var method = 'AddList';

			if (typeof sessionId == 'undefined') { sessionId = 0; }
			if (typeof studentiList == 'undefined') { studentiList = []; }

			var url = urlAPI + '/' + objName + '/' + method;

			var obj = {
				sessionId: sessionId,
				studentiList: studentiList
			}

			return $http.put(url, obj)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed AddList for %s: %s', objName, message);
					return message.status;
				});
		}

		function studenteSession_count() {
			var data = getAllByParams('studenteSession', 'Count');
			return $q.when(data);
		}

		function studenteSession_countByFilter(sessionId) {
			if (typeof sessionId == 'undefined') { sessionId = 0; }

			var params = [];
			params.push({ name: 'sessionId', value: sessionId });

			var data = getAllByParams('studenteSession', 'CountByFilter', params);
			//console.dir(data);
			return $q.when(data);
		}

		function studenteSession_getAll() {
			var data = getAllNoParam('studenteSession', 'getAll');
			return $q.when(data);
		}

		function studenteSession_getAllByFilter(pageSize, page, sessionId, nominativo, order) {
			if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
			if (typeof page == 'undefined') { page = 1; }
			if (typeof sessionId == 'undefined') { sessionId = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'sessionId', value: sessionId });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('studenteSession', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function studenteSession_get(id) {
			var data = getById('studenteSession', id);
			return $q.when(data);
		}

		function studenteSession_update(item) {
			var data = updateObj('studenteSession', item);
			return $q.when(data);
		}

		function studenteSession_delete(id) {
			var data = deleteObj('studenteSession', id);
			return $q.when(data);
		}


		// ******************************
		//  DASHBOARD - APP
		function dashboard_get() {
			var data = getAllNoParam('dashboard', 'get');
			return $q.when(data);
		}

		function dashboard_getByProfileId(profileId) {
			if (typeof profileId == 'undefined') { profileId = 0; }

			var params = [];
			params.push({ name: 'profileId', value: profileId });

			var data = getAllByParams('dashboard', 'getByProfileId', params);
			return $q.when(data);
		}

		function dashboard_getAllProfiles() {
			var data = getAllNoParam('dashboard', 'getAllProfiles');
			return $q.when(data);
		}

		//SYSTEM
		function getWhoAmI() {
			return $http.get(urlAPI + '/system/whoami')
				.then(getWhoAmIComplete)
				.catch(function (message) {
					console.info('XHR Failed for whoami: %s', message);
				});

			function getWhoAmIComplete(response) {
				return response.data;
			}
		}

	}
})();